import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-width: 0;
  min-height: 100%;
  color: #172033;
}

/* End-to-end journey: one shared narrative from request to approved report. */
.landing-section-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 24px;
}

.landing-section-heading > div > span,
.service-journey-map-title > span {
  color: #27806d;
  font-size: 9px;
  font-weight: 840;
  letter-spacing: 0.12em;
}

.landing-journey-legend {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #687589;
  font-size: 9px;
  white-space: nowrap;
}

.landing-journey-legend span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.landing-journey-legend i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #5aa995;
}

.landing-journey-legend i.human {
  border: 2px solid #6e7d92;
  background: #fff;
}

.landing-journey-track {
  width: 100%;
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 8px;
}

.landing-journey-card {
  min-width: 0;
  min-height: 132px;
  padding: 12px;
  display: grid;
  align-content: start;
  gap: 7px;
  position: relative;
  border: 1px solid #dfe8e6;
  border-radius: 12px;
  background: linear-gradient(180deg, #fff, #f8fbfa);
  box-shadow: 0 7px 20px rgba(35, 61, 57, 0.045);
}

.landing-journey-card.human-gate {
  border-color: #cdd8e5;
  background: linear-gradient(180deg, #fff, #f7f9fc);
}

.landing-journey-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.landing-journey-card-top i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #207562;
  background: #e9f6f2;
  font-size: 9px;
  font-style: normal;
  font-weight: 850;
}

.landing-journey-card.human-gate .landing-journey-card-top i {
  color: #4a5f7f;
  background: #edf1f7;
}

.landing-journey-card-top span {
  overflow: hidden;
  color: #8a95a4;
  font-size: 7px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.landing-journey-card > strong {
  color: #26354a;
  font-size: 11px;
  line-height: 1.35;
}

.landing-journey-card > p {
  margin: 0;
  color: #6f7c8e;
  font-size: 8px;
  line-height: 1.45;
}

.landing-journey-card > em {
  width: fit-content;
  margin-top: auto;
  padding: 4px 6px;
  border-radius: 999px;
  color: #277a68;
  background: #edf8f5;
  font-size: 7px;
  font-style: normal;
  font-weight: 760;
}

.landing-journey-card > svg {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 50%;
  right: -14px;
  z-index: 2;
  color: #91a09f;
  background: #fff;
  border-radius: 50%;
  transform: translateY(-50%);
}

.landing-agent-band {
  margin-top: 10px;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  border: 1px solid #e3e9ec;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.86);
}

.landing-agent-band-title {
  display: grid;
  gap: 3px;
}

.landing-agent-band-title span {
  color: #27806d;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.landing-agent-band-title strong {
  color: #2c394d;
  font-size: 10px;
}

.landing-agent-list {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 6px;
}

.landing-agent-list article {
  min-width: 0;
  padding: 6px 7px;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background: #f7f9fa;
}

.landing-agent-list article > i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #267866;
  background: #e8f5f1;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}

.landing-agent-list article > div {
  min-width: 0;
  display: grid;
}

.landing-agent-list strong,
.landing-agent-list small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.landing-agent-list strong {
  color: #344156;
  font-size: 8px;
}

.landing-agent-list small {
  margin-top: 2px;
  color: #7b8797;
  font-size: 6.5px;
}

.landing-metrics.landing-outputs {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.landing-outputs .landing-metric strong {
  font-size: 15px;
}

.agent-platform.landing-mode > .service-journey-map {
  display: none;
}

.service-journey-map {
  width: min(100% - 32px, 1450px);
  margin: 8px auto 0;
  padding: 12px 14px;
  border: 1px solid #dce7e4;
  border-radius: 14px;
  background: linear-gradient(135deg, #fff 0%, #f7fbfa 100%);
  box-shadow: 0 8px 24px rgba(32, 60, 54, 0.04);
}

.service-journey-map-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.service-journey-map-title {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.service-journey-map-title > strong {
  color: #233247;
  font-size: 14px;
}

.service-journey-map-title > small {
  color: #718092;
  font-size: 9px;
}

.service-object-path {
  max-width: 56%;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8691a0;
  font-size: 8px;
  white-space: nowrap;
}

.service-object-path span {
  color: #8793a2;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.service-object-path strong {
  max-width: 170px;
  overflow: hidden;
  color: #314359;
  text-overflow: ellipsis;
}

.service-object-path i {
  color: #45a18b;
  font-style: normal;
}

.service-journey-track {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 7px;
}

.service-journey-stage {
  min-width: 0;
  min-height: 76px;
  padding: 8px;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: start;
  gap: 6px;
  position: relative;
  border: 1px solid #e1e7e9;
  border-radius: 10px;
  color: inherit;
  text-align: left;
  background: #fff;
}

.service-journey-stage > svg {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  right: -12px;
  z-index: 2;
  color: #8c999f;
  background: #fff;
  border-radius: 50%;
  transform: translateY(-50%);
}

.service-stage-index {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  position: relative;
  border-radius: 8px;
  color: #657386;
  background: #f0f3f5;
  font-size: 8px;
  font-weight: 850;
}

.service-stage-index i {
  position: absolute;
  font-style: normal;
}

.service-journey-stage.done .service-stage-index span {
  opacity: 0;
}

.service-stage-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.service-stage-copy small,
.service-stage-copy strong,
.service-stage-copy em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.service-stage-copy small {
  color: #8692a0;
  font-size: 6.5px;
}

.service-stage-copy strong {
  color: #354458;
  font-size: 9px;
}

.service-stage-copy em {
  color: #617185;
  font-size: 7px;
  font-style: normal;
}

.service-journey-stage > b {
  padding: 3px 5px;
  border-radius: 999px;
  color: #7b8795;
  background: #f2f4f5;
  font-size: 6px;
  font-weight: 780;
  white-space: nowrap;
}

.service-journey-stage.active {
  border-color: #4fae96;
  background: #eff9f6;
  box-shadow: 0 0 0 3px rgba(71, 162, 140, 0.09);
}

.service-journey-stage.active .service-stage-index,
.service-journey-stage.done .service-stage-index {
  color: #fff;
  background: #318b75;
}

.service-journey-stage.active > b,
.service-journey-stage.ready > b {
  color: #22725f;
  background: #dff3ed;
}

.service-journey-stage.done {
  border-color: #cce3dd;
}

.service-journey-stage.ready {
  border-color: #a9c7dc;
  background: #f5f9fc;
}

.service-journey-stage.locked {
  opacity: 0.58;
}

.decision-reading-guide {
  padding: 8px 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border-top: 1px solid #e4e9ec;
  background: #f8fafb;
}

.decision-reading-guide > div {
  min-width: 0;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  gap: 2px 8px;
}

.decision-reading-guide > div > i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  grid-row: span 2;
  border-radius: 7px;
  color: #267866;
  background: #e5f4ef;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}

.decision-reading-guide span,
.decision-reading-guide small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.decision-reading-guide span {
  color: #738094;
  font-size: 8px;
}

.decision-reading-guide strong {
  color: #27364a;
  font-size: 10px;
}

.decision-reading-guide small {
  grid-column: 2/-1;
  color: #8a95a3;
  font-size: 7px;
}

.decision-reading-guide > em {
  color: #7fa69c;
  font-style: normal;
}

.final-approval {
  display: grid;
  gap: 12px;
}

.final-approval-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.final-approval-heading > div {
  display: grid;
  gap: 3px;
}

.final-approval-heading span {
  color: #3b8d78;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.final-approval-heading strong {
  color: #243449;
  font-size: 13px;
}

.final-approval-heading > em {
  padding: 5px 8px;
  border-radius: 999px;
  color: #377b69;
  background: #e9f5f1;
  font-size: 8px;
  font-style: normal;
  font-weight: 760;
}

.final-decision-steps {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr) 20px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.final-decision-steps > i {
  color: #72a496;
  font-style: normal;
  text-align: center;
}

.final-decision-step {
  min-width: 0;
  padding: 9px 10px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #dde5e7;
  border-radius: 10px;
  color: inherit;
  text-decoration: none;
  background: #fff;
}

.final-decision-step > i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #547083;
  background: #edf2f5;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}

.final-decision-step > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.final-decision-step span {
  color: #7f8c9b;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.08em;
}

.final-decision-step strong {
  color: #2c3b4f;
  font-size: 10px;
}

.final-decision-step small {
  overflow: hidden;
  color: #7b8797;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.final-decision-step > em {
  padding: 4px 6px;
  border-radius: 999px;
  color: #657488;
  background: #f0f3f5;
  font-size: 7px;
  font-style: normal;
  white-space: nowrap;
}

.final-decision-step.done,
.final-decision-step.active {
  border-color: #8ecbbd;
  background: #f0f8f6;
}

.final-decision-step.done > i,
.final-decision-step.active > i {
  color: #fff;
  background: #338b75;
}

.final-decision-step.ready {
  border-color: #9dbed4;
  background: #f4f8fb;
}

.final-decision-step.locked {
  cursor: not-allowed;
  opacity: 0.58;
}

.final-approval-actions {
  justify-content: flex-end;
}

.final-approval-actions .final-report-link {
  border-color: #1f6f5f;
  color: #fff;
  background: #1f6f5f;
}

@media (max-width: 1180px) {
  .landing-journey-track,
  .service-journey-track {
    overflow-x: auto;
    grid-template-columns: repeat(8, minmax(140px, 1fr));
  }
  .landing-agent-band {
    grid-template-columns: 1fr;
  }
  .service-journey-map-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .service-object-path {
    max-width: 100%;
  }
}
@media (max-width: 860px) {
  .landing-section-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  .landing-agent-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .landing-metrics.landing-outputs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .service-journey-map {
    min-width: 780px;
    margin-right: 16px;
    margin-left: 16px;
  }
  .decision-reading-guide,
  .final-decision-steps {
    grid-template-columns: 1fr;
  }
  .decision-reading-guide > em,
  .final-decision-steps > i {
    transform: rotate(90deg);
  }
}
.agent-platform:not(.landing-mode) {
  min-width: 1080px;
}

/* Review refinement: 12-column layout and 8pt component scale for the 1440px landing view. */
.agent-platform.landing-mode .landing-dashboard {
  --landing-grid-margin: 16px;
  --landing-grid-gutter: 16px;
  --landing-section-gap: 24px;
  --landing-card-radius: 16px;
  --landing-content-max: 1440px;
  --landing-group-max: 1120px;
}
.agent-platform.landing-mode .landing-topbar {
  height: 56px;
  padding-right: 24px;
  padding-left: 24px;
}
.agent-platform.landing-mode .landing-mobile-menu {
  display: none;
}
.agent-platform.landing-mode .landing-focus-close {
  display: none;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero {
  width: auto;
  height: auto;
  min-height: 0;
  padding: 32px 0;
  display: grid;
  position: fixed;
  inset: 0 0 0 216px;
  z-index: 40;
  place-items: center;
  grid-template-columns: minmax(0, 1fr);
  column-gap: 0;
  overflow-y: auto;
  background: rgba(248, 251, 251, 0.97);
  backdrop-filter: blur(16px);
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero-copy {
  width: min(840px, 100% - 48px);
  height: auto;
  margin: auto 0;
  padding: 0;
  display: block;
  grid-column: 1;
  grid-row: 1;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-eyebrow,
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero-copy > p,
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-product-visual {
  display: none;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero-copy h1 {
  width: 100%;
  margin: 0;
  text-align: center;
  font-size: 40px;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-composer {
  width: 100%;
  max-width: none;
  margin-top: 24px;
  box-shadow: 0 28px 72px rgba(24, 47, 61, 0.16);
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-composer textarea {
  height: 136px;
  font-size: 15px;
  transition: height 0.14s ease;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-composer-actions {
  min-height: 60px;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-attach,
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-file-chip {
  height: 44px;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-start {
  min-width: 168px;
  height: 60px;
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-focus-close {
  width: 40px;
  height: 40px;
  padding: 0;
  display: grid;
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 42;
  place-items: center;
  border: 1px solid #dce4e8;
  border-radius: 12px;
  color: #445064;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 24px rgba(28, 48, 60, 0.08);
}
.agent-platform.landing-mode .landing-dashboard.composer-focus .landing-focus-close svg {
  width: 20px;
  height: 20px;
}
.agent-platform.landing-mode .landing-hero {
  width: min(100% - 96px, var(--landing-content-max));
  height: 540px;
  max-width: none;
  margin: 0 auto;
  padding: 24px 0 0;
  grid-template-columns: minmax(0, 656px) minmax(0, 1fr);
  column-gap: 32px;
}
.agent-platform.landing-mode .landing-hero-copy {
  width: 100%;
  padding: 0;
  grid-column: 1;
  grid-row: 1;
}
.agent-platform.landing-mode .landing-eyebrow {
  font-size: 14px;
  line-height: 1.4;
}
.agent-platform.landing-mode .landing-hero-copy h1 {
  width: calc(100% + 64px);
  margin-top: 12px;
  font-size: 44px;
  line-height: 1.12;
  letter-spacing: -0.048em;
}
.agent-platform.landing-mode .landing-hero-copy > p {
  width: calc(100% + 64px);
  margin-top: 8px;
  color: #505d70;
  font-size: 15px;
  line-height: 1.6;
}
.agent-platform.landing-mode .landing-composer {
  width: calc(100% + 96px);
  max-width: 656px;
  margin-top: 8px;
  padding: 16px 24px 0;
  position: relative;
  overflow: hidden;
  border-radius: var(--landing-card-radius);
  box-shadow: 0 20px 48px rgba(30, 53, 66, 0.12);
}
.agent-platform.landing-mode .landing-composer-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.agent-platform.landing-mode .landing-composer-heading label {
  color: #202a3b;
  font-size: 16px;
  font-weight: 800;
}
.agent-platform.landing-mode .landing-composer-heading span {
  color: #8b95a3;
  font-size: 11px;
  white-space: nowrap;
}
.agent-platform.landing-mode .landing-composer textarea {
  height: 104px;
  margin-top: 12px;
  padding: 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.6;
}
.agent-platform.landing-mode .landing-composer-actions {
  min-height: 56px;
  margin-top: 12px;
}
.agent-platform.landing-mode .landing-attach,
.agent-platform.landing-mode .landing-file-chip {
  height: 40px;
  padding-right: 16px;
  padding-left: 16px;
  border-radius: 12px;
  font-size: 12px;
}
.agent-platform.landing-mode .landing-start {
  min-width: 152px;
  height: 56px;
  padding: 0 24px;
  border-radius: 12px;
  gap: 12px;
  font-size: 14px;
}
.agent-platform.landing-mode .landing-start svg {
  width: 20px;
  height: 20px;
}
.agent-platform.landing-mode .landing-start:disabled {
  opacity: 0.72;
  background: linear-gradient(135deg, #62b7a9, #45a293);
  box-shadow: 0 8px 18px rgba(0, 114, 95, 0.12);
}
.agent-platform.landing-mode .landing-examples {
  width: auto;
  margin: 8px -24px 0;
  padding: 8px 24px;
  border-top: 1px solid #e8ecef;
  background: #fbfcfc;
}
.agent-platform.landing-mode .landing-examples > strong {
  font-size: 10px;
}
.agent-platform.landing-mode .landing-example-list {
  margin-top: 8px;
  gap: 8px;
  flex-wrap: nowrap;
}
.agent-platform.landing-mode .landing-example-list button {
  min-width: 0;
  min-height: 32px;
  padding: 0 12px;
  overflow: hidden;
  flex: 1 1 auto;
  font-size: 9.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.agent-platform.landing-mode .landing-composer-loading {
  padding: 24px;
  display: flex;
  position: absolute;
  inset: 0;
  z-index: 12;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  color: #1d2939;
  background: radial-gradient(circle at 50% 12%, rgba(38, 184, 158, 0.13), transparent 42%), rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(7px);
}
.agent-platform.landing-mode .landing-analysis-loader {
  width: 56px;
  height: 56px;
  display: grid;
  position: relative;
  place-items: center;
}
.agent-platform.landing-mode .landing-analysis-loader > i {
  position: absolute;
  inset: 0;
  border: 3px solid #d9efea;
  border-top-color: #07927d;
  border-right-color: #54bca9;
  border-radius: 50%;
  animation: spin 0.85s linear infinite;
}
.agent-platform.landing-mode .landing-analysis-loader > span {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #15243a;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.02em;
}
.agent-platform.landing-mode .landing-composer-loading > em {
  margin-top: 12px;
  padding: 5px 9px;
  border-radius: 999px;
  color: #087765;
  background: #eaf8f5;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.04em;
}
.agent-platform.landing-mode .landing-composer-loading > strong {
  margin-top: 10px;
  font-size: 17px;
  line-height: 1.35;
}
.agent-platform.landing-mode .landing-composer-loading > p {
  margin: 5px 0 0;
  color: #687586;
  font-size: 11px;
  line-height: 1.5;
}
.agent-platform.landing-mode .landing-analysis-progress {
  width: min(100%, 336px);
  margin-top: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 34px;
  align-items: center;
  gap: 10px;
}
.agent-platform.landing-mode .landing-analysis-progress > span {
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: #e6eeec;
}
.agent-platform.landing-mode .landing-analysis-progress i {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #07927d, #63c6b4);
  transition: width 0.28s ease;
}
.agent-platform.landing-mode .landing-analysis-progress b {
  color: #087765;
  font-size: 10px;
  font-weight: 800;
  text-align: right;
}
.agent-platform.landing-mode .landing-product-visual {
  grid-column: 2;
  grid-row: 1;
  height: 100%;
}
.agent-platform.landing-mode .landing-product-visual > img {
  width: 420px;
  height: 420px;
  top: 48px;
  right: 0;
  left: auto;
  transform: none;
  filter: saturate(0.96) contrast(1.055) drop-shadow(0 20px 20px rgba(37, 57, 70, 0.14));
}
.agent-platform.landing-mode .landing-product-visual::before {
  width: 360px;
  height: 360px;
  top: 78px;
  right: 30px;
  left: auto;
  transform: none;
}
.agent-platform.landing-mode .landing-orbit {
  left: 49%;
  transform: translate(-50%, -50%);
}
.agent-platform.landing-mode .orbit-one {
  width: 430px;
  height: 430px;
}
.agent-platform.landing-mode .orbit-two {
  width: 480px;
  height: 352px;
}
.agent-platform.landing-mode .orbit-three {
  width: 350px;
  height: 448px;
}
.agent-platform.landing-mode .landing-float-card {
  min-width: 112px;
  min-height: 48px;
  padding: 8px;
  gap: 8px;
  border: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.58);
  box-shadow: none;
  backdrop-filter: blur(5px);
}
.agent-platform.landing-mode .landing-float-card > span {
  width: 34px;
  height: 34px;
  border-radius: 50%;
}
.agent-platform.landing-mode .landing-float-card strong {
  font-size: 10px;
}
.agent-platform.landing-mode .landing-float-card small {
  display: none;
}
.agent-platform.landing-mode .landing-float-card.requirement {
  top: 48px;
  left: 136px;
}
.agent-platform.landing-mode .landing-float-card.generation {
  top: 40px;
  right: 24px;
}
.agent-platform.landing-mode .landing-float-card.simulation {
  top: 224px;
  left: 200px;
}
.agent-platform.landing-mode .landing-float-card.recommendation {
  top: 232px;
  right: 8px;
}
.agent-platform.landing-mode .landing-float-card.approval {
  right: 120px;
  bottom: 24px;
}
.agent-platform.landing-mode .landing-process {
  width: min(100% - 96px, var(--landing-content-max));
  min-height: 0;
  margin: var(--landing-section-gap) auto 0;
  padding: 0;
  border-top: 0;
  background: transparent;
}
.agent-platform.landing-mode .landing-section-heading {
  width: 100%;
  max-width: none;
}
.agent-platform.landing-mode .landing-section-heading h2 {
  font-size: 20px;
  line-height: 1.4;
}
.agent-platform.landing-mode .landing-section-heading p {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
}
.agent-platform.landing-mode .landing-process-track {
  width: 100%;
  max-width: none;
  margin-top: 16px;
  grid-template-columns: minmax(0, 1fr) 40px minmax(0, 1fr) 40px minmax(0, 1fr) 40px minmax(0, 1fr) 40px minmax(0, 1fr);
}
.agent-platform.landing-mode .landing-process-card {
  height: 184px;
  min-height: 184px;
  padding: 16px;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: 40px 1fr auto;
  gap: 10px;
  overflow: hidden;
  border-radius: var(--landing-card-radius);
  box-shadow: 0 8px 24px rgba(37, 53, 65, 0.055);
}
.agent-platform.landing-mode .landing-process-card-heading {
  min-width: 0;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}
.agent-platform.landing-mode .landing-process-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  font-size: 14px;
}
.agent-platform.landing-mode .landing-process-card strong {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
}
.agent-platform.landing-mode .landing-process-card p {
  margin: 0;
  grid-row: 2;
  font-size: 11.5px;
  line-height: 1.55;
}
.agent-platform.landing-mode .landing-process-card > em {
  margin-top: 12px;
  padding: 6px 8px;
  grid-row: 3;
  align-self: end;
  font-size: 9px;
}
.agent-platform.landing-mode .landing-process-arrow {
  width: 24px;
  height: 24px;
  justify-self: center;
  border: 1px solid #e1e8eb;
  border-radius: 50%;
  background: #fff;
}
.agent-platform.landing-mode .landing-process-arrow svg {
  width: 16px;
  height: 16px;
}
.agent-platform.landing-mode .landing-metrics {
  width: min(100% - 96px, var(--landing-content-max));
  max-width: none;
  min-height: 96px;
  margin: var(--landing-section-gap) auto 24px;
  border-radius: var(--landing-card-radius);
  box-shadow: 0 8px 24px rgba(35, 55, 68, 0.05);
}
.agent-platform.landing-mode .landing-metric {
  padding: 16px;
  gap: 12px;
}
.agent-platform.landing-mode .landing-metric-icon {
  width: 40px;
  height: 40px;
  font-size: 12px;
}
.agent-platform.landing-mode .landing-metric span {
  font-size: 11px;
}
.agent-platform.landing-mode .landing-metric strong {
  font-size: 24px;
}
.agent-platform.landing-mode .landing-metric small {
  margin-top: 6px;
  font-size: 9.5px;
}
@media (max-width: 1400px) {
  .agent-platform.landing-mode .landing-hero {
    width: calc(100% - 64px);
    height: auto;
    min-height: 600px;
    padding-bottom: 16px;
    grid-template-columns: minmax(0, 3fr) minmax(360px, 2fr);
    column-gap: 24px;
  }
  .agent-platform.landing-mode .landing-hero-copy {
    grid-column: 1;
  }
  .agent-platform.landing-mode .landing-hero-copy h1 {
    width: 100%;
    font-size: 40px;
  }
  .agent-platform.landing-mode .landing-hero-copy > p,
  .agent-platform.landing-mode .landing-composer {
    width: 100%;
    max-width: none;
  }
  .agent-platform.landing-mode .landing-product-visual {
    grid-column: 2;
  }
  .agent-platform.landing-mode .landing-orbit,
  .agent-platform.landing-mode .landing-product-visual::before,
  .agent-platform.landing-mode .landing-product-visual > img {
    left: auto;
    transform: none;
  }
  .agent-platform.landing-mode .landing-product-visual > img {
    width: 360px;
    height: 360px;
    top: 108px;
    right: 0;
  }
  .agent-platform.landing-mode .landing-product-visual::before {
    top: 108px;
    right: 0;
  }
  .agent-platform.landing-mode .landing-process,
  .agent-platform.landing-mode .landing-metrics {
    width: calc(100% - 64px);
  }
  .agent-platform.landing-mode .landing-process-track {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
  }
  .agent-platform.landing-mode .landing-process-arrow {
    display: none;
  }
  .agent-platform.landing-mode .landing-metrics {
    min-height: 0;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 1px;
    overflow: hidden;
    background: #e7ecef;
  }
  .agent-platform.landing-mode .landing-metric {
    min-height: 96px;
    background: #fff;
  }
  .agent-platform.landing-mode .landing-metric + .landing-metric::before {
    display: none;
  }
}
@media (max-width: 1100px) {
  .agent-platform.landing-mode .landing-hero {
    min-height: 640px;
    grid-template-columns: minmax(0, 1fr) 300px;
    column-gap: 16px;
  }
  .agent-platform.landing-mode .landing-hero-copy h1 {
    font-size: 38px;
  }
  .agent-platform.landing-mode .landing-product-visual > img {
    width: 300px;
    height: 300px;
    top: 158px;
  }
  .agent-platform.landing-mode .landing-product-visual::before {
    width: 280px;
    height: 280px;
    top: 168px;
    right: 10px;
  }
  .agent-platform.landing-mode .orbit-one {
    width: 320px;
    height: 320px;
  }
  .agent-platform.landing-mode .orbit-two {
    width: 344px;
    height: 260px;
  }
  .agent-platform.landing-mode .orbit-three {
    width: 260px;
    height: 336px;
  }
}
@media (max-width: 1023px) {
  .agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero {
    left: 0;
  }
  .agent-platform.landing-mode .landing-topbar {
    padding-right: 20px;
    padding-left: 20px;
  }
  .agent-platform.landing-mode .landing-mobile-menu {
    width: 36px;
    height: 36px;
    padding: 0;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border: 1px solid #e1e7ea;
    border-radius: 10px;
    color: #344154;
    background: #fff;
  }
  .agent-platform.landing-mode .landing-mobile-menu svg {
    width: 20px;
    height: 20px;
  }
  .agent-platform.landing-mode .landing-breadcrumb {
    margin-right: auto;
    margin-left: 12px;
  }
}
@media (max-width: 768px) {
  .agent-platform.landing-mode .landing-topbar {
    height: 56px;
    padding-right: 16px;
    padding-left: 16px;
  }
  .agent-platform.landing-mode .landing-breadcrumb > span,
  .agent-platform.landing-mode .landing-breadcrumb > i,
  .agent-platform.landing-mode .landing-help,
  .agent-platform.landing-mode .landing-user strong {
    display: none;
  }
  .agent-platform.landing-mode .landing-tools {
    gap: 8px;
  }
  .agent-platform.landing-mode .landing-hero {
    width: calc(100% - 32px);
    min-height: 0;
    padding-top: 24px;
    grid-template-columns: minmax(0, 1fr);
    row-gap: 24px;
  }
  .agent-platform.landing-mode .landing-hero-copy {
    grid-column: 1;
    grid-row: 1;
  }
  .agent-platform.landing-mode .landing-hero-copy h1,
  .agent-platform.landing-mode .landing-hero-copy > p,
  .agent-platform.landing-mode .landing-composer {
    width: 100%;
  }
  .agent-platform.landing-mode .landing-hero-copy h1 {
    font-size: 36px;
  }
  .agent-platform.landing-mode .landing-product-visual {
    height: 352px;
    grid-column: 1;
    grid-row: 2;
  }
  .agent-platform.landing-mode .landing-product-visual > img {
    width: 320px;
    height: 320px;
    top: 16px;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
  .agent-platform.landing-mode .landing-product-visual::before {
    top: 36px;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
  .agent-platform.landing-mode .landing-process,
  .agent-platform.landing-mode .landing-metrics {
    width: calc(100% - 32px);
  }
  .agent-platform.landing-mode .landing-process-track {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }
  .agent-platform.landing-mode .landing-process-card {
    height: 176px;
    min-height: 176px;
  }
  .agent-platform.landing-mode .landing-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 520px) {
  .agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero {
    padding: 72px 0 24px;
  }
  .agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero-copy {
    width: calc(100% - 32px);
  }
  .agent-platform.landing-mode .landing-dashboard.composer-focus .landing-hero-copy h1 {
    font-size: 30px;
  }
  .agent-platform.landing-mode .landing-dashboard.composer-focus .landing-composer {
    margin-top: 16px;
  }
  .agent-platform.landing-mode .landing-dashboard.composer-focus .landing-focus-close {
    top: 16px;
    right: 16px;
  }
  .agent-platform.landing-mode .landing-user {
    display: none;
  }
  .agent-platform.landing-mode .landing-hero-copy h1 {
    font-size: 32px;
  }
  .agent-platform.landing-mode .landing-hero-copy > p {
    font-size: 14px;
  }
  .agent-platform.landing-mode .landing-composer {
    padding-right: 16px;
    padding-left: 16px;
  }
  .agent-platform.landing-mode .landing-composer-heading span {
    display: none;
  }
  .agent-platform.landing-mode .landing-composer textarea {
    height: 112px;
  }
  .agent-platform.landing-mode .landing-start {
    min-width: 136px;
    height: 48px;
    padding-right: 16px;
    padding-left: 16px;
  }
  .agent-platform.landing-mode .landing-examples {
    margin-right: -16px;
    margin-left: -16px;
    padding-right: 16px;
    padding-left: 16px;
  }
  .agent-platform.landing-mode .landing-example-list {
    flex-wrap: wrap;
  }
  .agent-platform.landing-mode .landing-example-list button {
    flex: 1 1 calc(50% - 4px);
  }
  .agent-platform.landing-mode .landing-product-visual {
    height: 312px;
  }
  .agent-platform.landing-mode .landing-product-visual > img {
    width: 280px;
    height: 280px;
    top: 16px;
  }
  .agent-platform.landing-mode .landing-product-visual::before {
    top: 16px;
  }
  .agent-platform.landing-mode .landing-composer-loading {
    padding: 16px;
  }
  .agent-platform.landing-mode .orbit-one {
    width: 300px;
    height: 300px;
  }
  .agent-platform.landing-mode .orbit-two {
    width: 328px;
    height: 248px;
  }
  .agent-platform.landing-mode .orbit-three {
    width: 248px;
    height: 320px;
  }
  .agent-platform.landing-mode .landing-process-track,
  .agent-platform.landing-mode .landing-metrics {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ReviewOps landing dashboard — rebuilt from the supplied Mobility design reference. */
.agent-platform.landing-mode {
  min-height: 100vh;
  background: #fbfdfd;
}

.agent-platform.landing-mode > .platform-header,
.agent-platform.landing-mode > .workflow-page-intro,
.agent-platform.landing-mode > .run-context-bar,
.agent-platform.landing-mode > .journey-navigation,
.agent-platform.landing-mode > .journey-main {
  display: none;
}

.landing-dashboard {
  --landing-ink: #10152f;
  --landing-muted: #667085;
  --landing-mint: #008f7a;
  --landing-line: #e7ecef;
  min-height: 100vh;
  overflow: hidden;
  color: var(--landing-ink);
  background: radial-gradient(circle at 72% 25%, rgba(73, 170, 221, 0.09), transparent 27%), radial-gradient(circle at 48% 8%, rgba(73, 190, 164, 0.045), transparent 25%), linear-gradient(180deg, #fff 0%, #fbfdfd 66%, #f8fbfb 100%);
}

.landing-topbar {
  height: 56px;
  padding: 0 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(231, 236, 239, 0.8);
  background: rgba(255, 255, 255, 0.72);
}

.landing-breadcrumb,
.landing-tools,
.landing-user,
.landing-eyebrow,
.landing-composer-actions,
.landing-attachments,
.landing-section-heading,
.landing-metric,
.landing-example-list {
  display: flex;
  align-items: center;
}

.landing-breadcrumb {
  gap: 8px;
  color: #87909f;
  font-size: 9px;
  font-weight: 760;
  letter-spacing: 0.08em;
}

.landing-breadcrumb i {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #aeb7c2;
}

.landing-breadcrumb strong {
  color: #364153;
  font-size: 10px;
  letter-spacing: 0;
}

.landing-tools {
  gap: 15px;
  color: #4d5667;
}

.landing-help {
  border: 0;
  color: inherit;
  background: transparent;
}

.landing-help:hover,
.landing-user:hover {
  color: #087a69;
  background: #f0f8f6;
}

.landing-help {
  min-height: 30px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #e4e8eb;
  border-radius: 7px 0 0 7px;
  font-size: 11px;
  font-weight: 680;
  text-decoration: none;
}

.landing-user {
  min-height: 36px;
  gap: 8px;
  border-radius: 9px;
  color: inherit;
  text-decoration: none;
}

.landing-user > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #354052;
  background: #e8ecef;
  font-size: 10px;
  font-weight: 800;
}

.landing-user strong {
  color: #343b4a;
  font-size: 11px;
}

.landing-hero {
  height: 474px;
  max-width: 1240px;
  margin: 0 auto;
  padding: 42px 36px 24px;
  display: grid;
  grid-template-columns: minmax(450px, 0.92fr) minmax(520px, 1.08fr);
  gap: 24px;
}

.landing-hero-copy {
  padding: 8px 0 0 8px;
  position: relative;
  z-index: 4;
}

.landing-eyebrow {
  gap: 8px;
  color: #097765;
  font-size: 11px;
  font-weight: 780;
}

.landing-eyebrow i {
  width: 18px;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #0ba68d, #54c9b6);
}

.landing-hero-copy h1 {
  margin: 17px 0 0;
  color: var(--landing-ink);
  font-size: 43px;
  font-weight: 820;
  line-height: 1.18;
  letter-spacing: -0.045em;
}

.landing-hero-copy > p {
  margin: 14px 0 0;
  color: #596476;
  font-size: 13px;
  line-height: 1.75;
}

.landing-composer {
  width: min(100%, 490px);
  margin-top: 17px;
  padding: 13px 14px 12px;
  border: 1px solid #e3e8eb;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 14px 36px rgba(30, 53, 66, 0.075);
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.18s;
}

.landing-composer:focus-within,
.landing-composer.ready {
  border-color: #9bcfc5;
  box-shadow: 0 16px 38px rgba(19, 104, 88, 0.11), 0 0 0 3px rgba(29, 163, 139, 0.055);
}

.landing-composer.parsing {
  transform: translateY(-1px);
}

.landing-composer > label {
  display: block;
  color: #252d3d;
  font-size: 11px;
  font-weight: 780;
}

.landing-composer textarea {
  width: 100%;
  height: 59px;
  margin-top: 8px;
  padding: 10px 11px;
  display: block;
  resize: none;
  border: 1px solid #dce3e7;
  border-radius: 7px;
  outline: 0;
  color: #293548;
  background: #fff;
  font-size: 11px;
  line-height: 1.55;
  transition: border-color 0.16s, box-shadow 0.16s;
}

.landing-composer textarea:focus {
  border-color: #8ac8bc;
  box-shadow: 0 0 0 3px rgba(29, 163, 139, 0.07);
}

.landing-composer textarea::placeholder {
  color: #9aa5b2;
}

.landing-composer-actions {
  min-height: 36px;
  margin-top: 9px;
  justify-content: space-between;
  gap: 10px;
}

.landing-attachments {
  min-width: 0;
  gap: 5px;
  overflow: hidden;
}

.landing-attach,
.landing-file-chip {
  height: 31px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  border: 1px solid #dfe5e9;
  border-radius: 7px;
  color: #566174;
  background: #fff;
  font-size: 9px;
  font-weight: 680;
}

.landing-attach svg {
  width: 14px;
  height: 14px;
}

.landing-file-chip {
  max-width: 125px;
  border-color: #cfe5df;
  color: #157662;
  background: #f2faf8;
}

.landing-file-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.landing-file-chip em {
  font-size: 11px;
  font-style: normal;
}

.landing-start {
  min-width: 106px;
  height: 36px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: linear-gradient(135deg, #058975, #00725f);
  box-shadow: 0 8px 16px rgba(0, 114, 95, 0.18);
  font-size: 10px;
  font-weight: 760;
}

.landing-start:hover:not(:disabled) {
  transform: translateY(-1px);
  background: linear-gradient(135deg, #087c6b, #065f52);
}

.landing-start:disabled {
  cursor: not-allowed;
  opacity: 0.48;
  box-shadow: none;
}

.landing-start svg {
  width: 15px;
  height: 15px;
}

.landing-examples {
  width: min(100%, 520px);
  margin-top: 13px;
}

.landing-examples > strong {
  color: #606b7c;
  font-size: 9px;
  font-weight: 760;
}

.landing-example-list {
  margin-top: 7px;
  gap: 5px;
  flex-wrap: wrap;
}

.landing-example-list button {
  min-height: 27px;
  padding: 0 10px;
  border: 1px solid #e1e6e9;
  border-radius: 999px;
  color: #5f6878;
  background: rgba(255, 255, 255, 0.82);
  font-size: 8px;
  transition: color 0.16s, border-color 0.16s, background 0.16s;
}

.landing-example-list button:hover {
  border-color: #a9d8ce;
  color: #087361;
  background: #f3faf8;
}

.landing-product-visual {
  min-width: 0;
  position: relative;
  isolation: isolate;
}

.landing-product-visual::before {
  content: "";
  width: 350px;
  height: 350px;
  position: absolute;
  top: 38px;
  left: 50%;
  z-index: -3;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(210, 235, 244, 0.7), rgba(244, 250, 251, 0.18) 62%, transparent 72%);
  transform: translateX(-48%);
}

.landing-product-visual > img {
  width: 390px;
  height: 390px;
  object-fit: contain;
  position: absolute;
  top: 27px;
  left: 50%;
  z-index: 2;
  border-radius: 50%;
  mix-blend-mode: multiply;
  transform: translateX(-48%);
  filter: saturate(0.93) contrast(1.03) drop-shadow(0 18px 18px rgba(37, 57, 70, 0.12));
}

.landing-orbit {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: -1;
  border: 1px solid rgba(73, 157, 202, 0.17);
  border-radius: 50%;
  transform: translate(-48%, -51%);
}

.orbit-one {
  width: 430px;
  height: 430px;
}

.orbit-two {
  width: 500px;
  height: 350px;
  border-style: dashed;
  border-color: rgba(61, 177, 163, 0.18);
}

.orbit-three {
  width: 360px;
  height: 470px;
  border-color: rgba(104, 111, 227, 0.13);
}

.landing-orbit-dots i {
  width: 7px;
  height: 7px;
  position: absolute;
  z-index: 1;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #20b5a3;
  box-shadow: 0 2px 8px rgba(25, 156, 139, 0.2);
}

.landing-orbit-dots i:nth-child(1) {
  top: 65px;
  left: 34%;
}

.landing-orbit-dots i:nth-child(2) {
  top: 170px;
  right: 7%;
  background: #6576ef;
}

.landing-orbit-dots i:nth-child(3) {
  bottom: 67px;
  right: 22%;
  background: #3e91dc;
}

.landing-orbit-dots i:nth-child(4) {
  bottom: 42px;
  left: 29%;
}

.landing-orbit-dots i:nth-child(5) {
  top: 183px;
  left: 8%;
  background: #14aab4;
}

.landing-float-card {
  min-width: 132px;
  min-height: 55px;
  padding: 9px 11px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  z-index: 4;
  border: 1px solid rgba(226, 233, 237, 0.9);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 25px rgba(49, 68, 82, 0.085);
  backdrop-filter: blur(10px);
}

.landing-float-card > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 9px;
  color: #078673;
  background: #e7f7f3;
  font-size: 10px;
  font-weight: 850;
}

.landing-float-card > div {
  display: grid;
}

.landing-float-card strong {
  color: #303949;
  font-size: 9px;
  white-space: nowrap;
}

.landing-float-card small {
  margin-top: 3px;
  color: #85909e;
  font-size: 7px;
  white-space: nowrap;
}

.landing-float-card.requirement {
  top: 44px;
  left: 8px;
}

.landing-float-card.generation {
  top: 28px;
  right: 3px;
}

.landing-float-card.simulation {
  top: 195px;
  left: -8px;
}

.landing-float-card.recommendation {
  top: 206px;
  right: -5px;
}

.landing-float-card.approval {
  right: 102px;
  bottom: 10px;
}

.landing-float-card.generation > span,
.landing-float-card.recommendation > span {
  color: #5c4ed3;
  background: #f0edff;
}

.landing-float-card.simulation > span {
  color: #128598;
  background: #e8f8fa;
}

.landing-float-card.approval > span {
  color: #267d5d;
  background: #eaf7ef;
}

.landing-process {
  min-height: 218px;
  padding: 17px 38px 18px;
  border-top: 1px solid #e8edef;
  background: rgba(255, 255, 255, 0.86);
}

.landing-section-heading {
  max-width: 1168px;
  margin: 0 auto;
  display: block;
}

.landing-section-heading h2 {
  margin: 0;
  color: #1d2638;
  font-size: 17px;
  letter-spacing: -0.015em;
}

.landing-section-heading p {
  margin: 4px 0 0;
  color: #8993a2;
  font-size: 9px;
}

.landing-process-track {
  max-width: 1168px;
  margin: 12px auto 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr) 24px minmax(0, 1fr) 24px minmax(0, 1fr) 24px minmax(0, 1fr);
  align-items: center;
}

.landing-process-card {
  min-width: 0;
  min-height: 135px;
  padding: 14px 14px 12px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  grid-template-rows: 1fr auto;
  align-items: start;
  gap: 0 10px;
  border: 1px solid #e5eaed;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(37, 53, 65, 0.035);
  transition: transform 0.17s, box-shadow 0.17s, border-color 0.17s;
}

.landing-process-card:hover {
  transform: translateY(-2px);
  border-color: #c8e0db;
  box-shadow: 0 12px 22px rgba(37, 83, 72, 0.08);
}

.landing-process-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  grid-row: 1;
  border-radius: 11px;
  color: #087b68;
  background: #e7f7f2;
  font-size: 12px;
  font-weight: 850;
}

.landing-process-card > div:nth-child(2) {
  min-width: 0;
}

.landing-process-card strong {
  color: #273245;
  font-size: 10px;
  line-height: 1.25;
}

.landing-process-card p {
  margin: 6px 0 0;
  color: #758091;
  font-size: 8px;
  line-height: 1.55;
}

.landing-process-card > em {
  width: fit-content;
  margin-top: 8px;
  padding: 4px 7px;
  grid-column: 1/-1;
  border-radius: 999px;
  color: #16806e;
  background: #edf9f6;
  font-size: 6.5px;
  font-style: normal;
  font-weight: 760;
}

.landing-process-card[data-tone=blue] .landing-process-icon,
.landing-process-card[data-tone=blue] > em {
  color: #2877c6;
  background: #ebf4fd;
}

.landing-process-card[data-tone=violet] .landing-process-icon,
.landing-process-card[data-tone=violet] > em {
  color: #7051d1;
  background: #f1edff;
}

.landing-process-card[data-tone=orange] .landing-process-icon,
.landing-process-card[data-tone=orange] > em {
  color: #d45d35;
  background: #fff0ea;
}

.landing-process-card[data-tone=green] .landing-process-icon,
.landing-process-card[data-tone=green] > em {
  color: #267b50;
  background: #eaf7ef;
}

.landing-process-arrow {
  display: grid;
  place-items: center;
  color: #a8b2bf;
  font-style: normal;
}

.landing-process-arrow svg {
  width: 17px;
  height: 17px;
}

.landing-metrics {
  max-width: 1168px;
  min-height: 88px;
  margin: 14px auto 28px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border: 1px solid #e7ecef;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(35, 55, 68, 0.045);
}

.landing-metric {
  min-width: 0;
  padding: 14px 18px;
  gap: 11px;
  position: relative;
}

.landing-metric + .landing-metric::before {
  content: "";
  width: 1px;
  height: 44px;
  position: absolute;
  top: 50%;
  left: 0;
  background: #e4e9ec;
  transform: translateY(-50%);
}

.landing-metric-icon {
  width: 35px;
  height: 35px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #15816e;
  background: #e8f7f3;
  font-size: 10px;
  font-weight: 840;
}

.landing-metric > div:last-child {
  min-width: 0;
  display: grid;
}

.landing-metric span {
  color: #5f6b7c;
  font-size: 8px;
  font-weight: 680;
}

.landing-metric strong {
  margin-top: 2px;
  color: #1b2638;
  font-size: 21px;
  line-height: 1;
}

.landing-metric small {
  margin-top: 5px;
  overflow: hidden;
  color: #9099a6;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.landing-metric[data-tone=blue] .landing-metric-icon {
  color: #2d75c5;
  background: #eaf3fc;
}

.landing-metric[data-tone=green] .landing-metric-icon {
  color: #267b50;
  background: #e9f6ed;
}

.landing-metric[data-tone=sky] .landing-metric-icon {
  color: #2384ad;
  background: #e9f5fa;
}

.landing-metric[data-tone=teal] .landing-metric-icon {
  color: #177c65;
  background: #e8f5ef;
}

@media (max-width: 1240px) {
  .landing-topbar {
    padding-right: 26px;
    padding-left: 26px;
  }
  .landing-hero {
    padding-right: 24px;
    padding-left: 24px;
    grid-template-columns: minmax(420px, 0.9fr) minmax(480px, 1.1fr);
  }
  .landing-hero-copy h1 {
    font-size: 39px;
  }
  .landing-process {
    padding-right: 24px;
    padding-left: 24px;
  }
  .landing-process-card {
    padding-right: 10px;
    padding-left: 10px;
  }
  .landing-metrics {
    margin-right: 24px;
    margin-left: 24px;
  }
  .landing-float-card.recommendation {
    right: 0;
  }
}
* {
  box-sizing: border-box;
}

button,
textarea,
input {
  font: inherit;
}

button {
  cursor: pointer;
}

.agent-platform {
  --ink: #172033;
  --muted: #748094;
  --line: #e4e7ec;
  --surface: #fff;
  --canvas: #f7f7f5;
  --mint: #2ab89a;
  --mint-dark: #177b68;
  --blue: #5c7cfa;
  --qa-accent: #2f8b75;
  --qa-accent-soft: #e9f6f2;
  --qa-ink: #2f3f54;
  --qa-muted: #7c8898;
  --qa-line: #dce3e7;
  --qa-panel-radius: 16px;
  --qa-card-radius: 12px;
  --qa-control-radius: 10px;
  min-height: 100vh;
  background: radial-gradient(circle at 78% 8%, rgba(92, 124, 250, 0.055), transparent 22%), radial-gradient(circle at 18% 24%, rgba(42, 184, 154, 0.06), transparent 20%), var(--canvas);
}

.platform-header {
  height: 64px;
  padding: 0 28px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 40;
  border-bottom: 1px solid rgba(222, 225, 230, 0.9);
  background: rgba(250, 250, 248, 0.92);
  backdrop-filter: blur(18px);
}

.platform-identity,
.project-context,
.header-actions,
.composer-agent,
.context-files,
.run-status {
  display: flex;
  align-items: center;
}

.platform-identity {
  gap: 11px;
}

.identity-mark {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  position: relative;
  border-radius: 11px;
  color: #fff;
  background: linear-gradient(145deg, #303b54, #182134);
  box-shadow: 0 6px 18px rgba(23, 32, 51, 0.16);
  font-size: 9px;
  font-weight: 850;
}

.identity-mark i {
  width: 8px;
  height: 8px;
  position: absolute;
  right: -2px;
  bottom: -2px;
  border: 2px solid #fafaf8;
  border-radius: 50%;
  background: #46d3b3;
}

.platform-identity > div:last-child {
  display: grid;
}

.platform-identity strong {
  color: #172033;
  font-size: 13px;
  font-weight: 760;
}

.platform-identity small {
  margin-top: 2px;
  color: #8b94a4;
  font-size: 9px;
}

.project-context {
  gap: 8px;
  color: #697589;
  font-size: 11px;
}

.project-context span {
  color: #8b94a3;
}

.project-context strong {
  color: #303a4d;
  font-weight: 680;
}

.project-context em {
  padding: 3px 6px;
  border-radius: 5px;
  color: #778195;
  background: #eceef1;
  font-size: 8px;
  font-style: normal;
  font-weight: 750;
}

.header-actions {
  justify-content: flex-end;
  gap: 8px;
}

.run-status {
  height: 31px;
  padding: 0 10px;
  gap: 6px;
  border: 1px solid #dde3ea;
  border-radius: 999px;
  color: #68758a;
  background: rgba(255, 255, 255, 0.78);
  font-size: 9px;
  font-weight: 680;
}

.run-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #9ca8b7;
}

.run-status.complete {
  border-color: #c7e8df;
  color: #247e6a;
  background: #f0faf7;
}

.run-status.complete i {
  background: #33bd9e;
}

.header-actions button {
  height: 36px;
  padding: 0 11px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  color: #4f5c70;
  background: #fff;
  font-size: 10px;
  font-weight: 680;
}

.header-actions button svg {
  width: 16px;
  height: 16px;
}

.header-actions .icon-action {
  width: 36px;
  padding: 0;
  justify-content: center;
}

.header-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.mobile-menu {
  display: none !important;
}

.journey-navigation {
  min-height: 82px;
  padding: 13px 26px;
  position: sticky;
  top: 64px;
  z-index: 35;
  border-bottom: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(16px);
}

.journey-track {
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.journey-step {
  min-width: 126px;
  padding: 4px 2px;
  display: flex;
  align-items: center;
  gap: 9px;
  border: 0;
  color: #98a1af;
  text-align: left;
  background: transparent;
}

.journey-step > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border: 1px solid #d9dee5;
  border-radius: 50%;
  color: #8e98a8;
  background: #fff;
}

.journey-step > span svg {
  width: 17px;
  height: 17px;
}

.journey-step > span em {
  font-size: 9px;
  font-style: normal;
  font-weight: 750;
}

.journey-step > div {
  display: grid;
}

.journey-step strong {
  color: #697487;
  font-size: 10px;
  font-weight: 720;
}

.journey-step small {
  margin-top: 2px;
  font-size: 8px;
}

.journey-step.active > span {
  border-color: #273349;
  color: #fff;
  background: #273349;
  box-shadow: 0 0 0 4px rgba(39, 51, 73, 0.08);
}

.journey-step.active strong {
  color: #1b2537;
}

.journey-step.active small {
  color: #657186;
}

.journey-step.done > span {
  border-color: #a9dfd3;
  color: #1d927a;
  background: #edf9f6;
}

.journey-step.done strong {
  color: #4e5c6f;
}

.journey-step:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.journey-line {
  height: 1px;
  min-width: 20px;
  flex: 1;
  background: #e0e4e9;
}

.journey-line.done {
  background: #a9dfd3;
}

.run-context-bar {
  max-width: 1340px;
  min-height: 102px;
  margin: 16px auto 0;
  padding: 13px 14px;
  display: grid;
  grid-template-columns: 188px minmax(420px, 1fr) 320px;
  align-items: stretch;
  gap: 12px;
  border: 1px solid #dce4e6;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 9px 26px rgba(35, 48, 62, 0.045);
}

.run-context-id {
  padding: 5px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #e6ebed;
}

.run-context-id > span,
.run-context-metric span,
.handoff-heading span {
  color: #84909f;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.run-context-id > strong {
  margin-top: 4px;
  color: #203146;
  font-family: "D2Coding", monospace;
  font-size: 13px;
  letter-spacing: -0.02em;
}

.run-context-id > small {
  margin-top: 3px;
  color: #778697;
  font-size: 7px;
  font-weight: 720;
  letter-spacing: 0.04em;
}

.run-context-id > em {
  width: fit-content;
  margin-top: 7px;
  padding: 3px 5px;
  border-radius: 4px;
  color: #657387;
  background: #eef1f3;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.run-context-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.run-context-metric {
  min-width: 0;
  padding: 9px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 9px;
  background: #f7f9f9;
}

.run-context-metric strong {
  margin-top: 4px;
  overflow: hidden;
  color: #344257;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-handoff-card {
  min-width: 0;
  padding: 9px 11px;
  border: 1px solid #d9e9e5;
  border-radius: 10px;
  background: #f3faf8;
}

.handoff-heading,
.handoff-route {
  display: flex;
  align-items: center;
}

.handoff-heading {
  justify-content: space-between;
}

.handoff-heading em {
  color: #23836f;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.handoff-route {
  margin-top: 5px;
  gap: 6px;
  color: #2a3c50;
  font-size: 9px;
}

.handoff-route i {
  color: #35a087;
  font-style: normal;
}

.run-handoff-card p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #687789;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.journey-main {
  max-width: 1340px;
  margin: 0 auto;
  padding: 20px 24px 70px;
}

.input-experience {
  max-width: 1120px;
  margin: 0 auto;
}

.input-hero {
  text-align: center;
}

.hero-badge {
  width: fit-content;
  margin: 0 auto 12px;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #dce3e8;
  border-radius: 999px;
  color: #557065;
  background: rgba(255, 255, 255, 0.74);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.hero-badge i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3ac3a4;
  box-shadow: 0 0 0 4px rgba(58, 195, 164, 0.1);
}

.input-hero h1 {
  margin: 0;
  color: #182235;
  font-size: 34px;
  font-weight: 760;
  letter-spacing: -0.035em;
}

.input-hero p {
  max-width: 690px;
  margin: 10px auto 0;
  color: #748094;
  font-size: 12px;
  line-height: 1.65;
}

.input-experience.review-mode {
  max-width: 1120px;
}

.input-hero.review-mode {
  text-align: left;
}

.input-hero.review-mode h1 {
  font-size: 27px;
  letter-spacing: -0.025em;
}

.input-hero.review-mode .review-attention {
  margin-top: 14px;
  border: 1px solid #e6bd79;
  border-radius: 12px;
  text-align: left;
}

.input-hero.review-mode .review-attention + .review-lead {
  margin-top: 9px;
}

.review-lead {
  margin-top: 14px;
  padding: 15px 17px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  border: 1px solid #cfe2dd;
  border-radius: 13px;
  background: linear-gradient(110deg, #f1f9f7, #fff 72%);
  box-shadow: 0 8px 22px rgba(42, 91, 79, 0.06);
}

.review-lead-mark {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #fff;
  background: #2f8b76;
}

.review-lead-mark svg {
  width: 21px;
  height: 21px;
}

.review-lead-copy {
  min-width: 0;
  display: grid;
}

.review-lead-copy > span,
.review-lead-confidence span {
  color: #398473;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.review-lead-copy > strong {
  margin-top: 3px;
  overflow: hidden;
  color: #26394d;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.input-hero .review-lead-copy p {
  max-width: none;
  margin: 4px 0 0;
  color: #657587;
  font-size: 11px;
  line-height: 1.5;
}

.review-lead-confidence {
  min-width: 126px;
  padding: 9px 11px;
  display: grid;
  justify-items: end;
  border-left: 1px solid #dce9e5;
}

.review-lead-confidence span {
  color: #82918f;
  letter-spacing: 0;
}

.review-lead-confidence strong {
  margin-top: 3px;
  color: #287d69;
  font-size: 18px;
}

.review-summary {
  margin-top: 9px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.review-stat {
  min-height: 54px;
  padding: 9px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #dfe5e9;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.88);
}

.review-stat span {
  color: #657387;
  font-size: 11px;
  font-weight: 680;
}

.review-stat strong {
  color: #24344a;
  font-size: 20px;
  line-height: 1;
}

.review-stat.review-needed {
  border-color: #e7c78d;
  background: #fff9ee;
}

.review-stat.review-needed:not(.clear) {
  box-shadow: 0 5px 14px rgba(174, 105, 25, 0.12);
}

.review-stat.review-needed strong {
  color: #a7661d;
}

.review-stat.review-needed.clear {
  border-color: #cde4de;
  background: #f2faf7;
}

.review-stat.review-needed.clear strong {
  color: #26806c;
}

.agent-constellation {
  max-width: 910px;
  margin: 25px auto 0;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  align-items: center;
  position: relative;
}

.agent-constellation::before {
  content: "";
  height: 1px;
  position: absolute;
  right: 7%;
  left: 7%;
  z-index: 0;
  background: linear-gradient(90deg, transparent, #d7dfe6 10%, #a9ddd1 50%, #d7dfe6 90%, transparent);
}

.constellation-core,
.constellation-agent {
  position: relative;
  z-index: 1;
}

.constellation-core {
  width: 86px;
  height: 86px;
  display: grid;
  justify-self: center;
  place-items: center;
  grid-column: 4;
  grid-row: 1;
  border: 1px solid #bedfd7;
  border-radius: 27px;
  color: #fff;
  background: linear-gradient(145deg, #26334a, #162034);
  box-shadow: 0 15px 35px rgba(27, 42, 60, 0.17);
}

.core-pulse {
  position: absolute;
  inset: -8px;
  border: 1px solid rgba(42, 184, 154, 0.18);
  border-radius: 33px;
}

.constellation-core span {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 850;
}

.constellation-core strong {
  margin-top: -18px;
  color: #9ee7d9;
  font-size: 7px;
  font-weight: 750;
  letter-spacing: 0.04em;
}

.constellation-agent {
  width: 126px;
  min-height: 57px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 7px;
  justify-self: center;
  border: 1px solid #e0e5ea;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 4px 13px rgba(32, 45, 60, 0.035);
}

.constellation-agent:nth-of-type(2) {
  grid-column: 1;
  grid-row: 1;
}

.constellation-agent:nth-of-type(3) {
  grid-column: 2;
  grid-row: 1;
}

.constellation-agent:nth-of-type(4) {
  grid-column: 3;
  grid-row: 1;
}

.constellation-agent:nth-of-type(5) {
  grid-column: 5;
  grid-row: 1;
}

.constellation-agent:nth-of-type(6) {
  grid-column: 6;
  grid-row: 1;
}

.constellation-agent:nth-of-type(7) {
  grid-column: 7;
  grid-row: 1;
}

.constellation-agent > span {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 7px;
  color: #657287;
  background: #eef1f4;
  font-size: 8px;
  font-weight: 800;
}

.constellation-agent > div {
  min-width: 0;
  display: grid;
}

.constellation-agent strong {
  overflow: hidden;
  color: #445064;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.constellation-agent small {
  margin-top: 2px;
  overflow: hidden;
  color: #959eac;
  font-size: 6.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.constellation-agent.detected {
  border-color: #9dd9cc;
  background: #f1faf8;
  box-shadow: 0 0 0 3px rgba(42, 184, 154, 0.07);
}

.constellation-agent.detected > span {
  color: #1d8c75;
  background: #dcf4ee;
}

.conversation-composer {
  max-width: 1080px;
  margin: 24px auto 0;
  overflow: hidden;
  border: 1px solid #d5dce3;
  border-radius: 19px;
  background: #fff;
  box-shadow: 0 17px 45px rgba(31, 43, 59, 0.09);
  transition: border 0.2s, box-shadow 0.2s;
}

.conversation-composer:focus-within {
  border-color: #95cfc3;
  box-shadow: 0 18px 48px rgba(34, 95, 84, 0.12), 0 0 0 4px rgba(42, 184, 154, 0.06);
}

.conversation-composer.parsing {
  border-color: #97cfc3;
}

.composer-top {
  min-height: 62px;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f3;
  background: linear-gradient(90deg, #fbfdfc, #fafbfc);
}

.composer-agent {
  gap: 10px;
}

.mini-agent {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #eafffa;
  background: #243247;
  font-size: 8px;
  font-weight: 850;
}

.composer-agent > div {
  display: grid;
}

.composer-agent strong {
  color: #344054;
  font-size: 11px;
}

.composer-agent small {
  margin-top: 3px;
  color: #8a94a3;
  font-size: 8px;
}

.composer-top > em {
  color: #9aa3b0;
  font-size: 8px;
  font-style: normal;
}

.conversation-composer textarea {
  width: 100%;
  height: auto;
  min-height: 140px;
  max-height: 420px;
  padding: 17px 18px;
  display: block;
  overflow-y: hidden;
  resize: none;
  border: 0;
  outline: 0;
  color: #293548;
  background: #fff;
  font-size: 13px;
  line-height: 1.7;
  field-sizing: content;
}

.conversation-composer textarea::placeholder {
  color: #a0a9b6;
}

.composer-context {
  min-height: 66px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #edf0f3;
  background: #fcfcfb;
}

.context-files {
  min-width: 0;
  gap: 6px;
}

.file-chip,
.add-file {
  height: 34px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e0e4e9;
  border-radius: 9px;
  color: #5f6c7f;
  background: #fff;
  font-size: 8px;
}

.file-chip i {
  padding: 3px 4px;
  border-radius: 4px;
  color: #4771c9;
  background: #edf2ff;
  font-size: 6px;
  font-style: normal;
  font-weight: 850;
}

.file-chip em {
  color: #a2aab5;
  font-size: 10px;
  font-style: normal;
}

.add-file {
  border-style: dashed;
  color: #6f7c8e;
  background: transparent;
}

.add-file svg {
  width: 14px;
  height: 14px;
}

.run-agents {
  min-width: 185px;
  min-height: 44px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 0;
  border-radius: 12px;
  color: #fff;
  background: #202c40;
  box-shadow: 0 7px 18px rgba(31, 44, 64, 0.15);
}

.run-agents:hover:not(:disabled) {
  background: #152034;
}

.run-agents:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.run-button-copy {
  display: grid;
  text-align: left;
}

.run-button-copy span {
  font-size: 10px;
  font-weight: 760;
}

.run-button-copy small {
  margin-top: 2px;
  color: #b8c2d0;
  font-size: 6.5px;
}

.run-agents svg {
  width: 18px;
  height: 18px;
}

.loading-ring {
  width: 17px;
  height: 17px;
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-top-color: #72ddc7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.quick-prompts {
  max-width: 1080px;
  margin: 14px auto 0;
  display: grid;
  grid-template-columns: auto repeat(3, 1fr);
  align-items: stretch;
  gap: 7px;
}

.quick-prompts > span {
  padding: 0 6px;
  display: flex;
  align-items: center;
  color: #8d96a4;
  font-size: 8px;
  font-weight: 700;
}

.quick-prompts button {
  min-height: 52px;
  padding: 8px 9px;
  display: grid;
  grid-template-columns: 1fr auto;
  text-align: left;
  border: 1px solid #e1e5e9;
  border-radius: 11px;
  color: #435064;
  background: rgba(255, 255, 255, 0.7);
}

.quick-prompts button:hover {
  border-color: #b8d9d1;
  background: #fff;
}

.quick-prompts strong {
  font-size: 8px;
}

.quick-prompts small {
  margin-top: 3px;
  color: #929ba9;
  font-size: 6.5px;
}

.quick-prompts em {
  grid-column: 2;
  grid-row: 1/3;
  align-self: center;
  color: #7b8797;
  font-size: 11px;
  font-style: normal;
}

.quick-prompts .demo-prompt {
  border-color: #cce4de;
  background: #f4faf8;
}

.requirement-approval {
  max-width: 1120px;
  margin: 12px auto 0;
  overflow: hidden;
  border: 1px solid #d7e0e5;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 17px 45px rgba(31, 43, 59, 0.08);
}

.review-commandbar {
  min-height: 58px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid #e5eaed;
  background: linear-gradient(90deg, #f4faf8, #fff);
}

.review-command-state {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.review-command-state > small {
  width: 100%;
  color: #84909f;
  font-size: 9px;
}

.review-command-guide {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 8px;
}

.review-command-guide > span {
  color: #84909f;
  font-size: 9px;
}

.review-command-guide > em {
  padding: 3px 6px;
  border: 1px solid #c9dce8;
  border-radius: 999px;
  color: #3d6f8d;
  background: #eef6fa;
  font-size: 8px;
  font-style: normal;
  font-weight: 740;
  white-space: nowrap;
}

.review-command-guide > em.review-rule {
  border-color: #e4c58d;
  color: #875615;
  background: #fff6e7;
}

.review-command-state > span {
  color: #728093;
  font-size: 10px;
  font-weight: 680;
}

.review-command-state > strong {
  color: #24364a;
  font-size: 15px;
}

.review-command-state > em {
  margin-left: 3px;
  padding: 5px 7px;
  border-radius: 7px;
  color: #946523;
  background: #fff0d8;
  font-size: 9px;
  font-style: normal;
  font-weight: 740;
}

.review-command-state > em.ready {
  color: #257663;
  background: #e6f5f1;
}

.review-command-actions {
  display: flex;
  align-items: center;
  gap: 7px;
}

.review-command-actions > button {
  min-height: 36px;
  padding: 0 11px;
  display: flex;
  align-items: center;
  gap: 7px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 740;
  white-space: nowrap;
}

.review-reanalyze {
  border: 1px solid #d9e0e5;
  color: #68778a;
  background: #fff;
}

.review-reanalyze:hover {
  border-color: #b8c7d0;
  background: #f8fafb;
}

.review-help-trigger {
  min-height: 28px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #bcd8d1;
  border-radius: 8px;
  color: #2d7463;
  background: #edf8f5;
  font-size: 9px;
  font-weight: 770;
  white-space: nowrap;
}

.review-help-trigger:hover {
  border-color: #77af9f;
  background: #e2f3ee;
}

.review-help-trigger > span {
  font-size: 12px;
  line-height: 1;
}

.review-focus {
  border: 1px solid #e3c285;
  color: #915b18;
  background: #fff9ee;
}

.review-run {
  border: 0;
  color: #fff;
  background: #202c40;
  box-shadow: 0 6px 14px rgba(31, 44, 64, 0.13);
}

.review-run:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.review-run svg {
  width: 16px;
  height: 16px;
}

.review-attention {
  padding: 12px 14px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  border-bottom: 1px solid #e6bd79;
  background: linear-gradient(90deg, #fff2d9, #fffaf1);
  box-shadow: inset 4px 0 0 #dc8f21;
  animation: stage-in 0.18s ease-out;
}

.review-attention-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: #d9871a;
  font-size: 15px;
  font-weight: 850;
}

.review-attention-copy {
  display: grid;
  gap: 3px;
}

.review-attention-copy strong {
  color: #7f4d12;
  font-size: 12px;
}

.review-attention-copy p {
  margin: 0;
  color: #8b6b43;
  font-size: 10px;
  line-height: 1.5;
}

.review-attention > button {
  min-height: 34px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #d89a3d;
  border-radius: 8px;
  color: #7d4c11;
  background: #fff;
  font-size: 10px;
  font-weight: 760;
  white-space: nowrap;
}

.review-attention > button:hover {
  border-color: #ba7517;
  background: #fff9ee;
}

.review-attention > button svg {
  width: 16px;
  height: 16px;
}

.requirement-details {
  border-bottom: 1px solid #e4e9ec;
  animation: stage-in 0.2s ease-out;
}

.approval-head {
  min-height: 76px;
  padding: 14px 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e7ebef;
  background: linear-gradient(90deg, #f2faf8, #fbfcfc);
}

.approval-agent {
  display: flex;
  align-items: center;
  gap: 11px;
}

.approval-icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  position: relative;
  border-radius: 12px;
  color: #fff;
  background: #243247;
  font-size: 9px;
  font-weight: 850;
}

.approval-icon i {
  width: 8px;
  height: 8px;
  position: absolute;
  right: -2px;
  bottom: -2px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #38c4a5;
}

.approval-agent > div:last-child {
  display: grid;
}

.approval-agent > div:last-child span {
  color: #318d79;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.approval-agent strong {
  margin-top: 4px;
  color: #29364a;
  font-size: 13px;
}

.approval-head > em {
  padding: 6px 8px;
  border-radius: 7px;
  color: #946523;
  background: #fff3df;
  font-size: 8px;
  font-style: normal;
  font-weight: 720;
}

.approval-head > em.ready {
  color: #257663;
  background: #e7f6f1;
}

.approval-head > em.attention {
  color: #985e18;
  background: #fff0d8;
}

.request-brief {
  min-height: 84px;
  padding: 14px 17px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e7ebef;
  background: linear-gradient(90deg, #f8fbfb, #fff);
}

.brief-mark {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 1px solid #d4e7e2;
  border-radius: 11px;
  color: #26806c;
  background: #eef8f5;
}

.brief-mark svg {
  width: 20px;
  height: 20px;
}

.brief-copy {
  display: grid;
}

.brief-copy > span {
  color: #318d79;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.brief-copy strong {
  margin-top: 4px;
  color: #2f3d50;
  font-size: 12px;
}

.brief-copy p {
  margin: 4px 0 0;
  color: #7f8a99;
  font-size: 8px;
  line-height: 1.45;
}

.brief-pipeline {
  margin-top: 6px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.brief-pipeline em,
.brief-pipeline strong {
  margin: 0;
  padding: 3px 6px;
  border: 1px solid #d7e6e2;
  border-radius: 999px;
  color: #557068;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 740;
}

.brief-pipeline strong {
  color: #fff;
  border-color: #318d79;
  background: #318d79;
}

.brief-pipeline i {
  color: #7aa99d;
  font-size: 8px;
  font-style: normal;
}

.brief-source {
  min-width: 112px;
  padding: 8px 10px;
  display: grid;
  border: 1px solid #e0e6ea;
  border-radius: 9px;
  background: #fff;
}

.brief-source span,
.brief-source small {
  color: #8b96a5;
  font-size: 7px;
}

.brief-source strong {
  margin: 3px 0;
  color: #425165;
  font-size: 10px;
}

.project-information {
  padding: 14px 17px;
  display: grid;
  gap: 11px;
  border-bottom: 1px solid #dfe9e6;
  background: linear-gradient(110deg, #f0f8f6 0%, #f8fbfa 55%, #fff 100%);
}

.project-information-head {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.project-information-icon {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #fff;
  background: #2f8b76;
  font-size: 10px;
  font-weight: 850;
  box-shadow: 0 5px 12px rgba(47, 139, 118, 0.16);
}

.project-information-head > div:nth-child(2) {
  display: grid;
}

.project-information-head span {
  color: #318d79;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.project-information-head strong {
  margin-top: 2px;
  color: #32475a;
  font-size: 11px;
}

.project-information-head small {
  margin-top: 2px;
  color: #7f909c;
  font-size: 8px;
}

.project-information-head > em {
  padding: 5px 8px;
  border: 1px solid #cce2dc;
  border-radius: 999px;
  color: #397e6d;
  background: rgba(255, 255, 255, 0.8);
  font-size: 7px;
  font-style: normal;
  font-weight: 750;
}

.project-information-body {
  display: grid;
  grid-template-columns: minmax(220px, 0.85fr) minmax(260px, 1.5fr);
  gap: 8px;
}

.project-information-body > label,
.project-information-source {
  min-height: 57px;
  padding: 8px 10px;
  display: grid;
  align-content: center;
  border: 1px solid #d9e7e3;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.82);
}

.project-information-body span {
  color: #81918f;
  font-size: 7px;
  font-weight: 720;
}

.project-information-body label input {
  width: 100%;
  height: 24px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #d7e3e0;
  outline: 0;
  color: #30475a;
  background: transparent;
  font-size: 11px;
  font-weight: 760;
}

.project-information-source p {
  margin: 3px 0 0;
  overflow: hidden;
  color: #65778a;
  font-size: 8px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.requirement-guide {
  padding: 16px 17px;
  display: grid;
  grid-template-columns: 38px minmax(250px, 0.95fr) minmax(460px, 1.45fr);
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e7ebef;
  background: #fbfcfc;
}

.guide-symbol {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #267d69;
  background: #e1f3ee;
  font-size: 14px;
  font-weight: 850;
}

.guide-copy {
  display: grid;
}

.guide-copy strong {
  color: #354256;
  font-size: 11px;
}

.guide-copy p {
  margin: 5px 0 0;
  color: #798698;
  font-size: 9px;
  line-height: 1.55;
}

.classification-guide {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 7px;
}

.classification-item {
  min-height: 70px;
  padding: 9px;
  display: grid;
  align-content: center;
  border: 1px solid #e2e7eb;
  border-radius: 9px;
  background: #fff;
}

.classification-item span {
  color: #778497;
  font-size: 8px;
  font-weight: 760;
}

.classification-item strong {
  margin-top: 3px;
  color: #465569;
  font-size: 9px;
}

.classification-item small {
  margin-top: 4px;
  color: #929ca9;
  font-size: 7px;
  line-height: 1.35;
}

.classification-item.constraint {
  border-color: #d9e0e8;
  background: #f8fafc;
}

.classification-item.objective {
  border-color: #d8e5f2;
  background: #f6f9fd;
}

.classification-item.input {
  border-color: #d4e8e2;
  background: #f5faf8;
}

.classification-item.reference {
  border-color: #e6dfd2;
  background: #fbf9f4;
}

.requirement-summary {
  min-height: 62px;
  padding: 9px 17px;
  display: grid;
  grid-template-columns: repeat(4, 96px) minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  border-bottom: 1px solid #e8ecef;
}

.requirement-summary > div {
  padding: 7px 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e2e7eb;
  border-radius: 8px;
  background: #fafbfc;
}

.requirement-summary span {
  color: #7f8b9b;
  font-size: 8px;
}

.requirement-summary strong {
  color: #33455a;
  font-size: 12px;
}

.requirement-summary > p {
  margin: 0;
  color: #758295;
  font-size: 9px;
  line-height: 1.5;
}

.requirement-summary > p strong {
  color: #287d69;
  font-size: inherit;
}

.confidence-detail {
  min-height: 50px;
  padding: 10px 17px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
}

.confidence-detail strong {
  color: #287d69;
  font-size: 11px;
}

.confidence-detail span {
  min-width: 0;
  flex: 1;
  color: #718095;
  font-size: 10px;
  line-height: 1.45;
}

.confidence-detail button {
  padding: 6px 8px;
  border: 1px solid #dce3e8;
  border-radius: 7px;
  color: #5b6f84;
  background: #fff;
  font-size: 9px;
  font-weight: 700;
}

.requirement-groups {
  padding: 12px 14px 16px;
  display: grid;
  gap: 12px;
  background: #fbfcfc;
}

.requirement-group {
  overflow: hidden;
  border: 1px solid #e1e6e9;
  border-radius: 13px;
  background: #fff;
}

.requirement-group-head {
  width: 100%;
  min-height: 38px;
  padding: 12px 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 0;
  color: inherit;
  background: #fff;
  text-align: left;
}

.requirement-group-head:hover {
  background: #fafcfc;
}

.requirement-group-head:focus-visible,
.requirement-item-summary:focus-visible {
  position: relative;
  z-index: 1;
  outline: 2px solid #4a9d89;
  outline-offset: -2px;
}

.requirement-group.collapsed .requirement-group-head {
  min-height: 58px;
}

.group-identity {
  display: flex;
  align-items: center;
  gap: 9px;
}

.group-identity > i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #fff;
  background: #526176;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.requirement-group[data-kind=constraint] .group-identity > i {
  background: #34445b;
}

.requirement-group[data-kind=objective] .group-identity > i {
  background: #637fb1;
}

.requirement-group[data-kind=input] .group-identity > i {
  background: #32917b;
}

.requirement-group[data-kind=reference] .group-identity > i {
  background: #8d7956;
}

.group-identity > div {
  display: grid;
}

.group-identity strong {
  color: #35445a;
  font-size: 11px;
}

.group-identity span {
  margin-top: 2px;
  color: #8d98a6;
  font-size: 8px;
}

.group-count {
  display: flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
}

.group-head-actions {
  display: flex;
  align-items: center;
  gap: 11px;
}

.group-chevron {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border: 1px solid #dfe5e8;
  border-radius: 7px;
  color: #657487;
  background: #f9fbfb;
  font-size: 14px;
  font-style: normal;
  line-height: 1;
}

.group-count em {
  margin-right: 5px;
  padding: 4px 6px;
  border-radius: 6px;
  color: #9b641f;
  background: #fff0d8;
  font-size: 7px;
  font-style: normal;
  font-weight: 750;
}

.group-count strong {
  color: #42536a;
  font-size: 12px;
}

.group-count span {
  color: #9aa3ae;
  font-size: 7px;
}

.requirement-grid {
  padding: 0 13px 13px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 7px;
  animation: stage-in 0.18s ease-out;
}

.requirement-item {
  overflow: hidden;
  border: 1px solid #e5e8ec;
  border-radius: 10px;
  background: #fff;
  transition: opacity 0.18s, border-color 0.18s, box-shadow 0.18s;
}

.requirement-item.needs-review {
  border-color: #dba552;
  background: #fffaf1;
  box-shadow: inset 4px 0 0 #df921f, 0 5px 14px rgba(174, 105, 25, 0.1);
}

.requirement-item.excluded {
  border-style: dashed;
  opacity: 0.48;
}

.requirement-item.expanded {
  border-color: #bcd9d2;
  box-shadow: 0 7px 18px rgba(43, 84, 74, 0.07);
}

.requirement-item.editable:not(.needs-review) {
  border-left: 3px solid #78aeca;
}

.requirement-item.editable:not(.needs-review):not(.expanded) .requirement-item-summary {
  background: linear-gradient(90deg, #f5fafd, #fff 28%);
}

.requirement-item.needs-review:not(.expanded) .requirement-item-summary {
  background: linear-gradient(90deg, #fff1d7, #fffaf2 34%, #fff 70%);
}

.requirement-item-summary {
  width: 100%;
  min-height: 74px;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: minmax(120px, 0.9fr) minmax(180px, 1.5fr) 128px 82px 98px 88px;
  align-items: center;
  gap: 8px;
  border: 0;
  color: inherit;
  background: transparent;
  text-align: left;
}

.requirement-item-summary:hover {
  background: #f8fbfa;
}

.item-summary-status {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #277a67;
  background: #e7f5f1;
  font-size: 9px;
  font-weight: 850;
}

.item-summary-status.attention {
  color: #98601c;
  background: #f9e7c8;
}

.item-summary-status.excluded {
  color: #7c8794;
  background: #eef1f3;
}

.item-summary-copy {
  min-width: 0;
  display: grid;
}

.item-summary-copy span,
.item-summary-value span,
.item-summary-kind > span,
.item-summary-confidence > span,
.item-summary-review > span {
  color: #7c8999;
  font-size: 9px;
  font-weight: 700;
}

.item-summary-copy strong,
.item-summary-value strong {
  margin-top: 4px;
  overflow: hidden;
  color: #2e4054;
  font-size: 12px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-summary-value,
.item-summary-kind,
.item-summary-confidence,
.item-summary-review {
  min-width: 0;
  display: grid;
  align-content: center;
}

.item-summary-value {
  padding-left: 10px;
  border-left: 1px solid #e5e9ec;
}

.item-summary-value strong {
  color: #263f52;
  font-size: 13px;
}

.item-summary-kind > em,
.item-summary-review > em {
  width: fit-content;
  margin-top: 5px;
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-style: normal;
  font-weight: 760;
  white-space: nowrap;
}

.item-summary-kind > em {
  color: #526176;
  background: #edf1f4;
}

.item-summary-kind[data-kind=objective] > em {
  color: #536c9b;
  background: #eef2fa;
}

.item-summary-kind[data-kind=input] > em {
  color: #287663;
  background: #e8f5f1;
}

.item-summary-kind[data-kind=reference] > em {
  color: #786542;
  background: #f4f0e7;
}

.item-summary-confidence strong {
  margin-top: 4px;
  color: #436276;
  font-size: 14px;
}

.item-summary-confidence.low strong {
  color: #a5651a;
}

.item-summary-review > em {
  color: #6d7885;
  background: #edf0f2;
}

.item-summary-review.clear > em {
  color: #277763;
  background: #e4f3ef;
}

.item-summary-review.attention > em {
  border: 1px solid #e4b66c;
  color: #814b0d;
  background: #ffe5ba;
  font-weight: 820;
}

.item-summary-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.item-summary-meta > span {
  color: #7f8b99;
  font-size: 10px;
  white-space: nowrap;
}

.item-summary-meta em {
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-style: normal;
  font-weight: 760;
  white-space: nowrap;
}

.review-badge {
  color: #935b17;
  background: #fff0d8;
  white-space: nowrap;
}

.editable-badge {
  border: 1px solid #c7dce8;
  color: #3d6f8d;
  background: #edf6fa;
  white-space: nowrap;
}

.excluded-badge {
  color: #687585;
  background: #edf0f2;
  white-space: nowrap;
}

.item-summary-toggle {
  min-width: 82px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  color: #66778a;
  white-space: nowrap;
}

.item-summary-toggle span {
  font-size: 10px;
  font-weight: 720;
  white-space: nowrap;
}

.item-summary-toggle i {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border: 1px solid #dce3e7;
  border-radius: 7px;
  background: #fff;
  font-size: 13px;
  font-style: normal;
  line-height: 1;
}

.item-summary-toggle i.edit-pencil {
  border-color: #a9cbdc;
  color: #326d8c;
  background: #eaf5fa;
}

.item-summary-toggle i.review-action {
  border-color: #d89a3d;
  color: #fff;
  background: #d9871a;
  font-weight: 850;
}

.requirement-item.needs-review .item-summary-toggle {
  color: #8b5717;
}

.requirement-item-detail {
  padding: 12px 13px 13px;
  border-top: 1px solid #e7ecee;
  background: #fbfcfc;
  animation: stage-in 0.18s ease-out;
}

.requirement-interpretation {
  padding: 12px;
  display: grid;
  gap: 8px;
  border: 1px solid #cfe2dd;
  border-radius: 11px;
  background: #f6faf9;
}

.interpretation-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.interpretation-heading > div {
  display: grid;
  gap: 3px;
}

.interpretation-heading span {
  color: #347c6c;
  font-size: 10px;
  font-weight: 780;
}

.interpretation-heading strong {
  color: #2f4654;
  font-size: 13px;
  font-weight: 740;
}

.interpretation-comparison {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 54px minmax(0, 1fr);
  align-items: stretch;
  gap: 8px;
}

.interpretation-source,
.interpretation-result {
  min-height: 82px;
  padding: 11px 12px;
  display: grid;
  align-content: start;
  gap: 8px;
  border: 1px solid #dfe5e8;
  border-radius: 9px;
  background: #fff;
}

.interpretation-result {
  border-color: #bddbd3;
  background: #edf8f5;
}

.interpretation-label {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
}

.interpretation-label > i {
  width: 22px;
  height: 22px;
  display: grid;
  flex: 0 0 22px;
  place-items: center;
  border-radius: 6px;
  color: #607084;
  background: #eef1f3;
  font-size: 9px;
  font-style: normal;
  font-weight: 820;
}

.interpretation-result .interpretation-label > i {
  color: #277663;
  background: #d6ede7;
}

.interpretation-label > span {
  color: #607084;
  font-size: 10px;
  font-weight: 760;
}

.interpretation-source > p,
.interpretation-result > p {
  margin: 0;
  color: #3d5063;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.6;
}

.interpretation-result > p {
  color: #294d44;
}

.interpretation-arrow {
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 3px;
  color: #438c79;
}

.interpretation-arrow > span {
  font-size: 18px;
  font-weight: 800;
}

.interpretation-arrow > small {
  color: #718f87;
  font-size: 8px;
  font-weight: 720;
  white-space: nowrap;
}

.requirement-edit-heading {
  margin-top: 8px;
  padding: 8px 10px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border: 1px solid #c7dce8;
  border-bottom: 0;
  border-radius: 10px 10px 0 0;
  background: #eaf4f9;
}

.requirement-edit-heading > i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #fff;
  background: #4e87a6;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.requirement-edit-heading > div {
  display: grid;
  gap: 2px;
}

.requirement-edit-heading strong {
  color: #31566c;
  font-size: 11px;
}

.requirement-edit-grid {
  margin-top: 0;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  border: 1px solid #c7dce8;
  border-radius: 0 0 10px 10px;
  background: #f3f8fb;
}

.requirement-edit-field {
  min-height: 68px;
  padding: 10px 11px;
  display: grid;
  align-content: start;
  border: 1px solid #e1e6e9;
  border-radius: 9px;
  background: #fff;
}

.requirement-edit-field > span,
.requirement-edit-field label > span {
  color: #7c8997;
  font-size: 10px;
  font-weight: 720;
}

.requirement-edit-field select {
  width: 100%;
  height: 30px;
  margin-top: 5px;
  padding: 0 7px;
  border: 1px solid #d7e0e4;
  border-radius: 6px;
  outline: 0;
  color: #354c5e;
  background: #f9fbfb;
  font-size: 11px;
  font-weight: 730;
}

.requirement-edit-field select:not(:disabled),
.requirement-edit-field input:not(:disabled) {
  border-color: #a9c9d9;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(78, 135, 166, 0.05);
}

.requirement-edit-field select:not(:disabled):hover,
.requirement-edit-field input:not(:disabled):hover {
  border-color: #6fa4bf;
}

.requirement-edit-field select:not(:disabled):focus,
.requirement-edit-field input:not(:disabled):focus {
  border-color: #4e87a6;
  box-shadow: 0 0 0 3px rgba(78, 135, 166, 0.14);
}

.requirement-edit-field.requirement-label-field label,
.requirement-edit-field.requirement-value-field label {
  margin: 0;
}

.requirement-edit-field.requirement-label-field label input,
.requirement-edit-field.requirement-value-field label input {
  height: 30px;
  margin-top: 5px;
  padding: 0 7px;
  border: 1px solid #d7e0e4;
  border-radius: 6px;
  background: #f9fbfb;
  font-size: 12px;
}

.requirement-item-head,
.requirement-item-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.requirement-item-head select {
  min-width: 94px;
  height: 26px;
  padding: 0 6px;
  border: 1px solid #dbe2e8;
  border-radius: 6px;
  outline: 0;
  color: #4d6072;
  background: #fff;
  font-size: 8px;
  font-weight: 700;
}

.requirement-confidence {
  display: grid;
  justify-items: end;
}

.requirement-confidence span {
  color: #9aa3af;
  font-size: 6px;
  text-transform: uppercase;
}

.requirement-confidence strong {
  margin-top: 1px;
  color: #607084;
  font-size: 9px;
}

.requirement-confidence.low strong {
  color: #ac681b;
}

.requirement-item label {
  margin-top: 9px;
  display: grid;
}

.requirement-item label > span {
  color: #8994a3;
  font-size: 8px;
}

.requirement-item label input {
  width: 100%;
  height: 28px;
  margin-top: 3px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #dfe5e9;
  outline: 0;
  color: #33455a;
  background: transparent;
  font-size: 11px;
  font-weight: 730;
}

.requirement-item label input:focus {
  border-color: #58ae9b;
}

.requirement-item-foot {
  margin-top: 8px;
}

.requirement-item-foot small {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #99a2ae;
  font-size: 7px;
}

.requirement-item-foot small i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #46bfa5;
}

.requirement-item-foot button {
  padding: 0;
  border: 0;
  color: #748397;
  background: transparent;
  font-size: 7px;
  font-weight: 700;
}

.requirement-routing {
  margin-top: 9px;
  padding: 8px;
  display: grid;
  gap: 7px;
  border: 1px solid #d9e7e3;
  border-radius: 8px;
  background: #f3f9f7;
}

.requirement-routing-meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
}

.requirement-routing-agents,
.requirement-routing-purposes,
.requirement-processing {
  display: grid;
  align-content: start;
  gap: 4px;
}

.requirement-routing span {
  color: #71877f;
  font-size: 7px;
  font-weight: 760;
}

.requirement-routing-agents > div {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.requirement-routing-agents em {
  padding: 3px 5px;
  border: 1px solid #c9dfd9;
  border-radius: 999px;
  color: #287763;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 740;
}

.requirement-routing-purposes {
  padding-left: 7px;
  border-left: 1px solid #dce9e5;
}

.requirement-routing-purposes ul {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 3px;
  list-style: none;
}

.requirement-routing-purposes li {
  position: relative;
  padding-left: 8px;
  color: #40586a;
  font-size: 7px;
  font-weight: 720;
  line-height: 1.35;
}

.requirement-routing-purposes li::before {
  position: absolute;
  top: 4px;
  left: 1px;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #3a947e;
  content: "";
}

.requirement-processing {
  padding-top: 6px;
  border-top: 1px solid #dce9e5;
}

.processing-chain {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px;
}

.processing-chain em,
.processing-chain strong {
  margin: 0;
  padding: 3px 5px;
  border: 1px solid #d2e3de;
  border-radius: 5px;
  color: #4b6570;
  background: #fff;
  font-size: 6px;
  font-style: normal;
  font-weight: 720;
  line-height: 1.25;
}

.processing-chain em {
  color: #fff;
  border-color: #4e8f7f;
  background: #4e8f7f;
}

.processing-chain i {
  color: #76a597;
  font-size: 7px;
  font-style: normal;
}

.requirement-item-evidence {
  margin-top: 9px;
  padding: 7px 8px;
  border: 1px solid #e7ebee;
  border-radius: 7px;
  background: #fff;
}

.requirement-item-evidence span {
  color: #8390a1;
  font-size: 7px;
  font-weight: 750;
}

.evidence-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.evidence-title > div {
  display: grid;
  gap: 2px;
}

.evidence-title small {
  color: #8b96a3;
  font-size: 9px;
  line-height: 1.35;
}

.evidence-title em {
  overflow: hidden;
  color: #9aa4b0;
  font-size: 7px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.requirement-item-evidence p {
  margin: 3px 0 0;
  display: -webkit-box;
  overflow: hidden;
  color: #617085;
  font-size: 8px;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.requirement-review {
  margin-top: 8px;
  padding: 7px 8px;
  display: grid;
  grid-template-columns: 18px 1fr auto;
  align-items: start;
  gap: 6px;
  border: 1px solid #efd9b3;
  border-radius: 7px;
  background: #fff8eb;
}

.requirement-review > i {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #9b641f;
  background: #f4dfb9;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
}

.requirement-review > div {
  display: grid;
}

.requirement-review strong {
  color: #8c5a1c;
  font-size: 8px;
}

.requirement-review p {
  margin: 2px 0 0;
  color: #9a7445;
  font-size: 7px;
  line-height: 1.4;
}

.requirement-review button {
  align-self: center;
  padding: 4px 6px;
  border: 1px solid #dfbd84;
  border-radius: 6px;
  color: #86551b;
  background: #fff;
  font-size: 7px;
  font-weight: 740;
}

.bulk-review-confirmation {
  padding: 16px 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid #dfe7e5;
  border-bottom: 1px solid #dfe7e5;
  background: #f7faf9;
}

.bulk-review-confirmation.complete {
  border-color: #c8e2dc;
  background: #f0f8f6;
}

.bulk-review-confirmation label {
  min-width: 0;
  display: flex;
  position: relative;
  flex: 1;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.bulk-review-input {
  width: 1px;
  height: 1px;
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.bulk-review-checkbox {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  flex: 0 0 24px;
  border: 2px solid #aebbc1;
  border-radius: 7px;
  color: #fff;
  background: #fff;
  transition: border-color 0.16s, background 0.16s, box-shadow 0.16s;
}

.bulk-review-checkbox svg {
  width: 16px;
  height: 16px;
  opacity: 0;
  transform: scale(0.72);
  transition: opacity 0.16s, transform 0.16s;
}

.bulk-review-input:checked + .bulk-review-checkbox {
  border-color: #2f8b76;
  background: #2f8b76;
  box-shadow: 0 0 0 3px rgba(47, 139, 118, 0.12);
}

.bulk-review-input:checked + .bulk-review-checkbox svg {
  opacity: 1;
  transform: scale(1);
}

.bulk-review-input:focus-visible + .bulk-review-checkbox {
  outline: 2px solid #2f8b76;
  outline-offset: 3px;
}

.bulk-review-copy {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.bulk-review-copy strong {
  color: #31475a;
  font-size: 14px;
}

.bulk-review-copy small {
  color: #748397;
  font-size: 11px;
  line-height: 1.45;
}

.bulk-review-confirmation > em {
  padding: 6px 10px;
  border-radius: 999px;
  color: #8b5a1d;
  background: #fff0d8;
  font-size: 10px;
  font-style: normal;
  font-weight: 780;
  white-space: nowrap;
}

.bulk-review-confirmation.complete > em {
  color: #267663;
  background: #dcefe9;
}

.approval-evidence {
  min-height: 48px;
  padding: 0 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #edf0f2;
  border-bottom: 1px solid #edf0f2;
  background: #fbfcfd;
}

.approval-evidence > div {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #788497;
  font-size: 8px;
}

.approval-evidence svg {
  width: 16px;
  height: 16px;
  color: #5b7fa1;
}

.approval-evidence button {
  border: 0;
  color: #5b6f84;
  background: transparent;
  font-size: 8px;
  font-weight: 700;
}

.approval-action {
  padding: 14px 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.approval-action > div {
  display: grid;
}

.approval-action > div strong {
  color: #3c485b;
  font-size: 9px;
}

.approval-action > div span {
  margin-top: 4px;
  color: #8b95a4;
  font-size: 8px;
}

.approval-action > button,
.compare-action > button,
.final-approval-actions > button {
  min-height: 42px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 11px;
  color: #fff;
  background: #202c40;
  box-shadow: 0 7px 18px rgba(31, 44, 64, 0.14);
  font-size: 9px;
  font-weight: 740;
}

.approval-action > button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.approval-action button svg,
.compare-action button svg,
.final-approval-actions button svg {
  width: 17px;
  height: 17px;
}

.stage-experience {
  animation: stage-in 0.3s ease-out;
}

.stage-heading {
  min-height: 82px;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
}

.stage-number {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 1px solid #dde2e7;
  border-radius: 14px;
  color: #728095;
  background: #fff;
  font-size: 10px;
  font-weight: 800;
}

.stage-heading > div:nth-child(2) {
  display: grid;
}

.stage-heading > div:nth-child(2) > span {
  color: #32947e;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.stage-heading h1 {
  margin: 4px 0 0;
  color: #1e293b;
  font-size: 22px;
  font-weight: 760;
  letter-spacing: -0.025em;
}

.stage-heading p {
  margin: 5px 0 0;
  color: #7c8798;
  font-size: 10px;
}

.heading-progress {
  width: 230px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 6px 10px;
}

.heading-progress span {
  color: #8b95a5;
  font-size: 8px;
}

.heading-progress strong {
  color: #34445a;
  font-size: 13px;
}

.heading-progress > i {
  height: 7px;
  grid-column: 1/-1;
  overflow: hidden;
  border-radius: 99px;
  background: #e5e9ed;
}

.heading-progress > i em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #5274e6, #37c1a2);
  transition: width 0.35s ease;
}

.execution-layout {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 275px minmax(0, 1fr);
  gap: 14px;
}

.agent-queue,
.live-agent-work,
.collaboration-feed,
.collaboration-story,
.iteration-selector,
.iteration-inspector,
.result-summary-card,
.result-metrics-card {
  border: 1px solid #dfe3e8;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.035);
}

.agent-queue {
  padding: 11px;
}

.queue-head {
  min-height: 38px;
  padding: 0 7px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f2;
}

.queue-head strong {
  color: #39465a;
  font-size: 10px;
}

.queue-head span {
  color: #929ca9;
  font-size: 7px;
}

.queue-agent {
  width: 100%;
  min-height: 62px;
  margin-top: 6px;
  padding: 8px;
  display: grid;
  grid-template-columns: 30px 1fr auto;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #536075;
  text-align: left;
  background: transparent;
}

.queue-agent:hover:not(:disabled),
.queue-agent.active {
  border-color: #c6ddd8;
  background: #f2f9f7;
}

.queue-agent:disabled {
  cursor: default;
}

.queue-index {
  width: 29px;
  height: 29px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #7d8999;
  background: #eef1f4;
}

.queue-index svg {
  width: 16px;
  height: 16px;
}

.queue-index i {
  width: 8px;
  height: 8px;
  border: 2px solid #27987f;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(39, 152, 127, 0.11);
  animation: pulse 1.4s ease-in-out infinite;
}

.queue-index em {
  font-size: 8px;
  font-style: normal;
  font-weight: 760;
}

.queue-agent > div {
  min-width: 0;
  display: grid;
}

.queue-agent > div strong {
  overflow: hidden;
  color: #3e4b5f;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.queue-agent > div small {
  margin-top: 3px;
  color: #98a1af;
  font-size: 7px;
}

.queue-agent > em {
  padding: 4px 6px;
  border-radius: 6px;
  color: #8a95a4;
  background: #eef1f4;
  font-size: 7px;
  font-style: normal;
  font-weight: 720;
}

.queue-agent > em.active {
  color: #227f6b;
  background: #dff4ef;
}

.queue-agent > em.done {
  color: #477285;
  background: #eaf1f5;
}

.live-agent-work {
  min-height: 500px;
  padding: 18px;
}

.live-agent-head {
  min-height: 82px;
  padding-bottom: 16px;
  display: grid;
  grid-template-columns: 48px 1fr auto;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e9ecef;
}

.live-agent-avatar {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  position: relative;
  border-radius: 14px;
  color: #eafffa;
  background: linear-gradient(145deg, #283a53, #192338);
  box-shadow: 0 9px 22px rgba(24, 35, 56, 0.15);
  font-size: 10px;
  font-weight: 850;
}

.live-agent-avatar i {
  width: 9px;
  height: 9px;
  position: absolute;
  right: -2px;
  bottom: -2px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #43caae;
}

.live-agent-head > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.live-agent-head > div:nth-child(2) span {
  color: #31927d;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.live-agent-head h2 {
  margin: 4px 0 0;
  color: #273449;
  font-size: 17px;
}

.live-agent-head p {
  margin: 4px 0 0;
  overflow: hidden;
  color: #778397;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.confidence-chip {
  padding: 8px 10px;
  display: grid;
  border: 1px solid #dbe5e3;
  border-radius: 10px;
  text-align: right;
  background: #f6faf9;
}

.confidence-chip span {
  color: #83928f;
  font-size: 7px;
}

.confidence-chip strong {
  margin-top: 2px;
  color: #25836f;
  font-size: 13px;
}

.agent-thinking {
  margin-top: 16px;
}

.thinking-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.thinking-label span,
.output-copy > span {
  color: #8692a2;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.thinking-label em {
  color: #9aa3af;
  font-size: 7px;
  font-style: normal;
}

.decision-chain {
  margin-top: 9px;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  align-items: center;
  gap: 6px;
}

.decision-card {
  min-height: 88px;
  padding: 10px;
  display: grid;
  align-content: start;
  border: 1px solid #e3e7eb;
  border-radius: 10px;
  background: #fafbfc;
}

.decision-card span {
  color: #929cab;
  font-size: 7px;
  font-weight: 720;
  text-transform: uppercase;
}

.decision-card strong {
  margin-top: 7px;
  color: #4d5a6d;
  font-size: 8px;
  line-height: 1.35;
}

.decision-card small {
  margin-top: 4px;
  color: #9ca5b1;
  font-size: 6.5px;
  line-height: 1.4;
}

.decision-card.done {
  border-color: #d1e7e1;
  background: #f4faf8;
}

.decision-card.active {
  border-color: #a9d8cc;
  background: #eef9f6;
  box-shadow: 0 0 0 3px rgba(42, 184, 154, 0.06);
}

.decision-chain > i {
  color: #aab3be;
  text-align: center;
  font-size: 10px;
  font-style: normal;
}

.agent-output-card {
  margin-top: 17px;
  padding: 15px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1.2fr;
  align-items: center;
  gap: 18px;
  border: 1px solid #d9e5e2;
  border-radius: 13px;
  background: linear-gradient(135deg, #f4faf8, #f8fafc);
}

.output-copy {
  min-width: 0;
  display: grid;
}

.output-copy strong {
  margin-top: 5px;
  color: #2e3e51;
  font-size: 13px;
}

.output-copy p {
  margin: 6px 0 0;
  color: #768396;
  font-size: 8px;
  line-height: 1.55;
}

.output-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.output-metric {
  padding: 10px;
  display: grid;
  border: 1px solid rgba(214, 224, 223, 0.9);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.78);
}

.output-metric span {
  color: #8793a1;
  font-size: 7px;
}

.output-metric strong {
  margin-top: 4px;
  color: #30465a;
  font-size: 12px;
}

.output-metric small {
  margin-top: 3px;
  color: #9aa3ae;
  font-size: 6.5px;
}

.stage-next {
  margin-top: 14px;
  padding: 11px 13px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 13px;
  color: #7e8999;
  font-size: 8px;
}

.stage-next button {
  min-height: 35px;
  padding: 0 12px;
  border: 1px solid #d8dfe5;
  border-radius: 9px;
  color: #45566c;
  background: #fff;
  font-size: 8px;
  font-weight: 720;
}

.collab-live,
.converged-chip,
.recommendation-badge {
  padding: 9px 12px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #d7e6e2;
  border-radius: 10px;
  color: #2d7f6e;
  background: #f2f9f7;
  font-size: 8px;
  font-weight: 720;
}

.collab-live i,
.converged-chip > i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3fc2a5;
}

.collaboration-layout {
  margin-top: 18px;
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) 340px;
  gap: 14px;
}

.collaboration-feed {
  height: 535px;
  padding: 14px;
  overflow-y: auto;
}

.feed-head {
  min-height: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #e9ecef;
}

.feed-head strong {
  color: #3a475a;
  font-size: 11px;
}

.feed-head span {
  color: #929cab;
  font-size: 8px;
}

.empty-feed {
  padding: 80px 20px;
  text-align: center;
}

.empty-feed strong {
  color: #566276;
  font-size: 11px;
}

.empty-feed p {
  margin: 6px 0 0;
  color: #949daa;
  font-size: 8px;
}

.agent-message {
  padding: 13px 4px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 10px;
  border-bottom: 1px solid #edf0f2;
}

.message-avatar {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #2a745f;
  background: #e1f4ef;
  font-size: 8px;
  font-weight: 780;
}

.message-avatar.error {
  color: #a65047;
  background: #fbe9e6;
}

.message-content {
  min-width: 0;
}

.message-meta {
  display: flex;
  align-items: center;
  gap: 7px;
}

.message-meta strong {
  color: #3d4b60;
  font-size: 9px;
}

.message-meta span {
  color: #738195;
  font-size: 8px;
}

.message-meta time {
  margin-left: auto;
  color: #a0a8b3;
  font-size: 7px;
}

.message-content p {
  margin: 6px 0 0;
  color: #667387;
  font-size: 9px;
  line-height: 1.55;
}

.message-tags {
  margin-top: 7px;
  display: flex;
  gap: 5px;
}

.message-tags em {
  padding: 4px 6px;
  border-radius: 5px;
  color: #7c8797;
  background: #f0f2f4;
  font-size: 6.5px;
  font-style: normal;
}

.message-tags em.done {
  color: #2b806d;
  background: #e4f5f0;
}

.message-tags em.error {
  color: #b25147;
  background: #fae7e4;
}

.message-tags em.retry {
  color: #93652c;
  background: #f8edda;
}

.collaboration-story {
  height: 535px;
  padding: 17px;
}

.story-head {
  display: grid;
}

.story-head span {
  color: #359580;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.story-head strong {
  margin-top: 5px;
  color: #354255;
  font-size: 12px;
}

.story-event {
  min-height: 86px;
  margin-top: 16px;
  padding: 11px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e3e7eb;
  border-radius: 11px;
  background: #fafbfc;
}

.story-icon {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 850;
}

.story-event > div:last-child {
  min-width: 0;
  display: grid;
}

.story-event span {
  color: #818d9e;
  font-size: 7px;
}

.story-event strong {
  margin-top: 4px;
  color: #465368;
  font-size: 9px;
  line-height: 1.4;
}

.story-event small {
  margin-top: 4px;
  color: #9aa3af;
  font-size: 7px;
}

.story-event.fail {
  border-color: #efd4d0;
  background: #fff9f8;
}

.story-event.fail .story-icon {
  color: #b34f45;
  background: #fae7e4;
}

.story-event.redesign .story-icon {
  color: #8a6230;
  background: #f7ecd9;
}

.story-event.pass {
  border-color: #cfe8e1;
  background: #f6fbfa;
}

.story-event.pass .story-icon {
  color: #267b68;
  background: #def3ed;
}

.collaboration-story > i {
  width: 1px;
  height: 15px;
  margin: 0 0 -16px 27px;
  display: block;
  position: relative;
  z-index: 2;
  background: #d5dce2;
}

.story-result {
  margin-top: 17px;
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  border: 1px solid #dce3e7;
  border-radius: 10px;
  background: #f7f9fa;
}

.story-result span {
  color: #8792a1;
  font-size: 7px;
}

.story-result strong {
  grid-column: 2;
  grid-row: 1/3;
  color: #2a8a75;
  font-size: 20px;
}

.story-result small {
  margin-top: 3px;
  color: #6f7c8e;
  font-size: 7px;
}

.converged-chip > div {
  display: grid;
}

.converged-chip span {
  color: #7a948e;
  font-size: 6px;
}

.converged-chip strong {
  margin-top: 2px;
  font-size: 10px;
}

.exploration-funnel {
  min-height: 123px;
  margin-top: 18px;
  padding: 15px 18px;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  align-items: center;
  gap: 11px;
  border: 1px solid #dde3e7;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.035);
}

.exploration-stage {
  min-width: 0;
  display: grid;
}

.exploration-stage span {
  color: #8290a1;
  font-size: 8px;
}

.exploration-stage strong {
  margin-top: 4px;
  color: #26364a;
  font-size: 21px;
  letter-spacing: -0.02em;
}

.exploration-stage small {
  margin-top: 2px;
  color: #9aa3af;
  font-size: 7px;
}

.exploration-stage > i {
  height: 6px;
  margin-top: 9px;
  overflow: hidden;
  border-radius: 99px;
  background: #e8ebee;
}

.exploration-stage > i em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #677fec, #42bea3);
}

.exploration-funnel > svg {
  width: 20px;
  height: 20px;
  justify-self: center;
  color: #9fa9b5;
}

.optimization-layout {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 325px minmax(0, 1fr);
  gap: 14px;
}

.iteration-selector {
  padding: 10px;
}

.iteration-selector button {
  width: 100%;
  min-height: 98px;
  margin-top: 6px;
  padding: 11px;
  display: grid;
  grid-template-columns: 1fr auto;
  text-align: left;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #4f5d71;
  background: #fafbfc;
}

.iteration-selector button:first-child {
  margin-top: 0;
}

.iteration-selector button.active {
  border-color: #aecfc7;
  background: #f1f9f7;
}

.iteration-selector button > span {
  color: #8c97a6;
  font-size: 7px;
}

.iteration-selector button > strong {
  margin-top: 5px;
  font-size: 10px;
}

.iteration-selector button > em {
  grid-column: 2;
  grid-row: 1/3;
  padding: 5px 7px;
  align-self: start;
  border-radius: 6px;
  color: #b45349;
  background: #f9e7e4;
  font-size: 7px;
  font-style: normal;
  font-weight: 780;
}

.iteration-selector button > em.pass {
  color: #267b68;
  background: #e0f3ee;
}

.iteration-selector button > small {
  margin-top: 7px;
  color: #8d98a7;
  font-size: 7px;
}

.iteration-inspector {
  padding: 18px;
}

.iteration-title {
  min-height: 66px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #e8ecef;
}

.iteration-title > div {
  display: grid;
}

.iteration-title span {
  color: #35937f;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.09em;
}

.iteration-title h2 {
  max-width: 600px;
  margin: 6px 0 0;
  color: #354256;
  font-size: 14px;
}

.iteration-title > em {
  padding: 6px 8px;
  border-radius: 7px;
  color: #ae5046;
  background: #fbe9e6;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.iteration-title > em.pass {
  color: #267b68;
  background: #def3ed;
}

.variable-change {
  margin-top: 15px;
}

.variable-change > span {
  color: #8994a3;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.1em;
}

.variable-change > div {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.variable-change em {
  padding: 7px 9px;
  border: 1px solid #dfe5e9;
  border-radius: 8px;
  color: #5e6d80;
  background: #f8fafb;
  font-size: 8px;
  font-style: normal;
}

.iteration-metric-grid {
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.iteration-metric {
  min-height: 83px;
  padding: 11px;
  display: grid;
  border: 1px solid #e2e6ea;
  border-radius: 10px;
  background: #fafbfc;
}

.iteration-metric span {
  color: #8994a3;
  font-size: 8px;
}

.iteration-metric strong {
  margin-top: 5px;
  color: #35465b;
  font-size: 14px;
}

.iteration-metric small {
  margin-top: 4px;
  color: #9ba4af;
  font-size: 7px;
}

.iteration-conclusion {
  margin-top: 15px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #d5e7e2;
  border-radius: 11px;
  background: #f3faf8;
}

.iteration-conclusion > i {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #267b68;
  background: #ddf2ec;
  font-size: 11px;
  font-style: normal;
  font-weight: 850;
}

.iteration-conclusion > div {
  display: grid;
}

.iteration-conclusion strong {
  color: #405064;
  font-size: 9px;
}

.iteration-conclusion span {
  margin-top: 3px;
  color: #7e8b9c;
  font-size: 7px;
}

.recommendation-badge {
  display: grid;
  text-align: right;
}

.recommendation-badge span {
  color: #789087;
  font-size: 7px;
}

.recommendation-badge strong {
  margin-top: 2px;
  color: #26836e;
  font-size: 15px;
}

.evaluation-overview {
  margin-top: 18px;
  padding: 16px;
  display: grid;
  gap: 14px;
  border: 1px solid #dbe4e7;
  border-radius: 16px;
  background: linear-gradient(125deg, rgba(241, 248, 247, 0.96), rgba(255, 255, 255, 0.98));
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.035);
}

.evaluation-overview-head {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
}

.evaluation-agent-mark {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: #2f8070;
  font-size: 9px;
  font-weight: 850;
  box-shadow: 0 6px 14px rgba(47, 128, 112, 0.18);
}

.evaluation-overview-head > div:nth-child(2) {
  display: grid;
}

.evaluation-overview-head span {
  color: #418777;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.evaluation-overview-head strong {
  margin-top: 2px;
  color: #34475a;
  font-size: 12px;
}

.evaluation-overview-head p {
  margin: 3px 0 0;
  color: #7b8998;
  font-size: 8px;
}

.evaluation-overview-head > em {
  padding: 5px 8px;
  border: 1px solid #cee0dc;
  border-radius: 999px;
  color: #347967;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 760;
}

.evaluation-funnel {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) 18px repeat(3, minmax(0, 1fr) 18px) minmax(0, 1fr);
  align-items: stretch;
}

.evaluation-funnel > i {
  display: grid;
  place-items: center;
  color: #78a79c;
  font-size: 10px;
  font-style: normal;
}

.evaluation-funnel-node {
  min-height: 67px;
  padding: 9px 10px;
  display: grid;
  align-content: center;
  border: 1px solid #dde6e7;
  border-radius: 10px;
  background: #fff;
}

.evaluation-funnel-node span {
  color: #778595;
  font-size: 7px;
}

.evaluation-funnel-node strong {
  margin-top: 3px;
  color: #33485b;
  font-size: 15px;
}

.evaluation-funnel-node small {
  margin-top: 3px;
  color: #95a0aa;
  font-size: 6.5px;
}

.evaluation-funnel-node:last-of-type {
  border-color: #bcded6;
  background: #eef8f5;
}

.evaluation-funnel-node:last-of-type strong {
  color: #27806c;
}

.confidence-method {
  padding-top: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #dde8e6;
}

.confidence-method > div:first-child {
  display: grid;
}

.confidence-method > div:first-child span {
  color: #768896;
  font-size: 7px;
  font-weight: 790;
  letter-spacing: 0.07em;
}

.confidence-method > div:first-child strong {
  margin-top: 3px;
  color: #405365;
  font-size: 9px;
}

.confidence-weights {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}

.confidence-weights em {
  padding: 5px 7px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #dce5e7;
  border-radius: 7px;
  background: #fff;
  font-style: normal;
}

.confidence-weights span {
  color: #7c8998;
  font-size: 6.5px;
}

.confidence-weights strong {
  color: #367f6e;
  font-size: 8px;
}

.design-comparison {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.design-option {
  min-height: 760px;
  padding: 17px;
  display: block;
  position: relative;
  border: 1px solid #dee3e8;
  border-radius: 17px;
  color: #4e5b6f;
  text-align: left;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.035);
  transition: transform 0.2s, border 0.2s, box-shadow 0.2s;
}

.design-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 34px rgba(33, 43, 57, 0.08);
}

.design-option.selected {
  border-color: #7fcbbb;
  box-shadow: 0 14px 36px rgba(39, 133, 113, 0.11), inset 0 0 0 1px #9bd8cb;
}

.design-option.recommended::before {
  content: "";
  height: 4px;
  position: absolute;
  top: -1px;
  right: 18px;
  left: 18px;
  border-radius: 0 0 5px 5px;
  background: linear-gradient(90deg, #566fe0, #39bda0);
}

.design-option-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.design-option-top span {
  color: #8792a1;
  font-size: 8px;
  font-weight: 740;
  letter-spacing: 0.07em;
}

.design-option-top em {
  padding: 5px 7px;
  border-radius: 6px;
  color: #2b806c;
  background: #e4f5f0;
  font-size: 7px;
  font-style: normal;
  font-weight: 740;
}

.design-option h2 {
  margin: 14px 0 0;
  color: #2d3a4e;
  font-size: 16px;
}

.design-option > p {
  min-height: 42px;
  margin: 7px 0 0;
  color: #788598;
  font-size: 8px;
  line-height: 1.55;
}

.recommendation-reason {
  min-height: 68px;
  margin-top: 9px;
  padding: 9px 10px;
  display: grid;
  align-content: start;
  border: 1px solid #dbe8e5;
  border-radius: 9px;
  background: #f3f9f7;
}

.recommendation-reason span,
.design-tradeoff span,
.design-pros-cons > div > span {
  color: #3c8573;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.03em;
}

.recommendation-reason p {
  margin: 4px 0 0;
  color: #546779;
  font-size: 8px;
  line-height: 1.5;
}

.design-score {
  margin-top: 14px;
  padding: 10px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: end;
  border: 1px solid #e4e8eb;
  border-radius: 10px;
  background: #f8fafb;
}

.design-score strong {
  color: #26394d;
  font-size: 25px;
  line-height: 1;
}

.design-score > span {
  margin-left: 3px;
  color: #8b96a5;
  font-size: 8px;
}

.design-score small {
  grid-column: 1/-1;
  margin-top: 5px;
  color: #328c78;
  font-size: 7px;
}

.design-confidence {
  margin-top: 10px;
  padding: 10px;
  display: grid;
  border: 1px solid #dfe5ea;
  border-radius: 10px;
  background: #f8fafc;
}

.design-confidence-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.design-confidence-head > div {
  display: grid;
}

.design-confidence-head span {
  color: #6e8091;
  font-size: 6px;
  font-weight: 790;
  letter-spacing: 0.05em;
}

.design-confidence-head strong {
  margin-top: 2px;
  color: #43576a;
  font-size: 8px;
}

.design-confidence-head > em {
  color: #27836e;
  font-size: 16px;
  font-style: normal;
  font-weight: 820;
}

.design-confidence > p {
  margin: 5px 0 0;
  color: #8995a3;
  font-size: 6.5px;
  line-height: 1.4;
}

.confidence-factor-grid {
  margin-top: 7px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.confidence-factor {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 3px 5px;
}

.confidence-factor span {
  overflow: hidden;
  color: #738193;
  font-size: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.confidence-factor strong {
  color: #4b5e70;
  font-size: 6.5px;
}

.confidence-factor > i {
  height: 3px;
  grid-column: 1/-1;
  overflow: hidden;
  border-radius: 99px;
  background: #e2e7eb;
}

.confidence-factor > i em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #5575d9, #37aa91);
}

.design-key-metrics {
  margin-top: 9px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
}

.design-key-metrics div {
  padding: 8px;
  display: grid;
  border: 1px solid #e6e9ec;
  border-radius: 8px;
}

.design-key-metrics span {
  color: #929ba8;
  font-size: 6.5px;
}

.design-key-metrics strong {
  margin-top: 3px;
  color: #4b586b;
  font-size: 8px;
}

.design-tradeoff {
  margin-top: 10px;
  padding: 9px 10px;
  display: grid;
  border: 1px solid #e5e0d8;
  border-radius: 9px;
  background: #fbf9f5;
}

.design-tradeoff span {
  color: #8a7250;
}

.design-tradeoff strong {
  margin-top: 4px;
  color: #5e5a54;
  font-size: 8px;
  line-height: 1.45;
}

.design-pros-cons {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.design-pros-cons > div {
  padding: 8px;
  display: grid;
  align-content: start;
  gap: 4px;
  border: 1px solid #e1e6e9;
  border-radius: 8px;
  background: #fafbfc;
}

.design-pros > span {
  color: #2d826d !important;
}

.design-cons > span {
  color: #986b36 !important;
}

.design-pros-cons em {
  color: #697688;
  font-size: 6.5px;
  font-style: normal;
  line-height: 1.4;
}

.criteria-list {
  margin-top: 13px;
  display: grid;
  gap: 8px;
}

.criterion {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 4px 8px;
}

.criterion-head {
  display: contents;
}

.criterion-head span {
  color: #677487;
  font-size: 7px;
}

.criterion-head strong {
  color: #4c5b6e;
  font-size: 8px;
}

.criterion > i {
  height: 4px;
  grid-column: 1/-1;
  overflow: hidden;
  border-radius: 99px;
  background: #e7eaee;
}

.criterion > i em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #5f79e5, #40bba1);
}

.criterion > small {
  grid-column: 1/-1;
  color: #9aa3af;
  font-size: 6.5px;
}

.select-indicator {
  min-height: 34px;
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #e0e4e8;
  border-radius: 9px;
  color: #758195;
  background: #fafbfc;
  font-size: 8px;
  font-weight: 700;
}

.select-indicator i {
  width: 8px;
  height: 8px;
  border: 1px solid #aab3bf;
  border-radius: 50%;
}

.design-option.selected .select-indicator {
  border-color: #b7ded5;
  color: #287d6a;
  background: #eff9f6;
}

.design-option.selected .select-indicator i {
  border: 2px solid #fff;
  background: #32ac91;
  box-shadow: 0 0 0 1px #32ac91;
}

.compare-action {
  margin-top: 14px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #dae1e6;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.04);
}

.selected-summary {
  display: grid;
}

.selected-summary span {
  color: #8994a3;
  font-size: 7px;
}

.selected-summary strong {
  margin-top: 4px;
  color: #374559;
  font-size: 11px;
}

.selected-summary small {
  margin-top: 3px;
  color: #8e98a6;
  font-size: 7px;
}

.result-hero {
  min-height: 145px;
  padding: 22px;
  display: grid;
  grid-template-columns: 58px 1fr auto;
  align-items: center;
  gap: 16px;
  border: 1px solid #cfe2dd;
  border-radius: 18px;
  background: radial-gradient(circle at 82% 40%, rgba(92, 124, 250, 0.08), transparent 28%), linear-gradient(135deg, #f3faf8, #fff);
  box-shadow: 0 10px 30px rgba(34, 75, 66, 0.055);
}

.result-status {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  border-radius: 17px;
  color: #267e6a;
  background: #def3ed;
}

.result-status svg {
  width: 28px;
  height: 28px;
}

.result-hero-copy {
  display: grid;
}

.result-hero-copy > span {
  color: #2a8b75;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.result-hero h1 {
  margin: 5px 0 0;
  color: #243348;
  font-size: 23px;
  letter-spacing: -0.025em;
}

.result-hero p {
  margin: 6px 0 0;
  color: #758295;
  font-size: 9px;
}

.result-score {
  width: 112px;
  padding: 12px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: end;
  border: 1px solid #d7e4e1;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.76);
}

.result-score > span {
  grid-column: 1/-1;
  color: #809087;
  font-size: 7px;
}

.result-score strong {
  margin-top: 4px;
  color: #27836f;
  font-size: 27px;
  line-height: 1;
}

.result-score em {
  color: #8c97a5;
  font-size: 8px;
  font-style: normal;
}

.result-score small {
  grid-column: 1/-1;
  margin-top: 5px;
  color: #5b746d;
  font-size: 6.5px;
}

.result-layout {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.result-conclusion-strip {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.result-conclusion-item {
  min-width: 0;
  min-height: 62px;
  padding: 10px 11px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border: 1px solid #cfe2dd;
  border-radius: 11px;
  background: #f7fcfa;
}

.result-conclusion-item > i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #fff;
  background: #2f9078;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
}

.result-conclusion-item > div {
  min-width: 0;
  display: grid;
}

.result-conclusion-item span {
  color: #6e8c84;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.result-conclusion-item strong {
  margin-top: 3px;
  overflow: hidden;
  color: #334b5c;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-conclusion-item.confidence {
  border-color: #cbd5ec;
  background: #f6f7fc;
}

.result-conclusion-item.confidence > i {
  background: #6076b4;
}

.result-conclusion-item.caution {
  border-color: #ead8bd;
  background: #fffaf3;
}

.result-conclusion-item.caution > i {
  background: #b27b3d;
}

.result-summary-card,
.result-metrics-card {
  padding: 17px;
}

.summary-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.summary-card-head > div {
  display: grid;
}

.summary-card-head span {
  color: #35937f;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.summary-card-head h2 {
  margin: 4px 0 0;
  color: #354256;
  font-size: 14px;
}

.summary-card-head > em {
  padding: 5px 7px;
  border-radius: 6px;
  color: #2a806c;
  background: #e3f4ef;
  font-size: 7px;
  font-style: normal;
}

.result-summary-card > p {
  margin: 12px 0 0;
  color: #718094;
  font-size: 9px;
  line-height: 1.6;
}

.result-summary-card > p.result-recommendation-conclusion {
  padding: 11px 12px;
  border-left: 3px solid #399b84;
  border-radius: 0 8px 8px 0;
  color: #40596a;
  background: #f2faf7;
  font-size: 11px;
  font-weight: 730;
  line-height: 1.5;
}

.result-recommendation-list {
  margin-top: 10px;
  display: grid;
  gap: 6px;
}

.result-recommendation-list > div {
  min-width: 0;
  min-height: 35px;
  padding: 7px 8px;
  display: grid;
  grid-template-columns: 18px auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8e6;
  border-radius: 8px;
  background: #fbfcfc;
}

.result-recommendation-list i {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #3a9983;
  font-size: 7px;
  font-style: normal;
  font-weight: 850;
}

.result-recommendation-list span {
  color: #2e826e;
  font-size: 8px;
  font-weight: 820;
}

.result-recommendation-list strong {
  overflow: hidden;
  color: #566577;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-recommendation-list > div.caution {
  border-color: #eadfce;
  background: #fffbf5;
}

.result-recommendation-list > div.caution i {
  background: #ac7942;
}

.result-recommendation-list > div.caution span {
  color: #96652f;
}

.result-criteria {
  margin-top: 13px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 13px;
}

.result-criterion {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 8px;
}

.result-criterion span,
.result-criterion strong {
  color: #5c687b;
  font-size: 8px;
}

.result-criterion > i {
  height: 5px;
  grid-column: 1/-1;
  overflow: hidden;
  border-radius: 99px;
  background: #e6eaed;
}

.result-criterion > i em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #6078e5, #3eb99f);
}

.result-criterion small {
  grid-column: 1/-1;
  color: #9aa3af;
  font-size: 6.5px;
}

.result-component {
  margin-top: 14px;
  padding-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  border-top: 1px solid #e8ebee;
}

.result-component div {
  padding: 8px;
  display: grid;
  border: 1px solid #e4e8eb;
  border-radius: 8px;
  background: #f9fafb;
}

.result-component span {
  color: #909aa8;
  font-size: 6px;
  font-weight: 760;
}

.result-component strong {
  margin-top: 4px;
  color: #4d5b6e;
  font-size: 7.5px;
}

.verified-metrics {
  margin-top: 13px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
}

.metric-tier-label {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.metric-tier-label span {
  color: #328a75;
  font-size: 7px;
  font-weight: 830;
  letter-spacing: 0.08em;
}

.metric-tier-label strong {
  color: #617386;
  font-size: 8px;
}

.metric-tier-label.secondary {
  margin-top: 10px;
  padding-top: 9px;
  border-top: 1px solid #e8eceb;
}

.metric-tier-label.secondary span,
.metric-tier-label.secondary strong {
  color: #8994a1;
}

.verified-metrics.core,
.verified-metrics.secondary {
  margin-top: 6px;
  grid-template-columns: repeat(2, 1fr);
}

.verified-metric.core {
  min-height: 82px;
  border-color: #c9e1db;
  background: linear-gradient(135deg, #f2faf7, #fff);
}

.verified-metric.core span {
  color: #587c73;
  font-size: 8px;
  font-weight: 720;
}

.verified-metric.core strong {
  color: #294b5d;
  font-size: 17px;
}

.verified-metrics.secondary .verified-metric {
  min-height: 62px;
  padding: 8px 10px;
  background: #fafbfb;
}

.verified-metric {
  min-height: 76px;
  padding: 10px;
  display: grid;
  border: 1px solid #e3e7ea;
  border-radius: 9px;
  background: #fafbfc;
}

.verified-metric span {
  color: #8b96a5;
  font-size: 7px;
}

.verified-metric strong {
  margin-top: 4px;
  color: #35475b;
  font-size: 12px;
}

.verified-metric small {
  margin-top: 3px;
  color: #32917c;
  font-size: 6.5px;
}

.result-tools {
  margin-top: 14px;
  padding: 10px;
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 10px;
  border: 1px solid #d9e7e3;
  border-radius: 15px;
  background: linear-gradient(135deg, #f2faf7, #f8fafb);
}

.result-output-heading {
  margin-top: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
}

.result-output-heading > div {
  display: grid;
}

.result-output-heading span {
  color: #32917c;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.09em;
}

.result-output-heading strong {
  margin-top: 3px;
  color: #3e4e61;
  font-size: 13px;
}

.result-output-heading p {
  margin: 0;
  color: #84909e;
  font-size: 9px;
}

.result-tool {
  min-height: 108px;
  padding: 12px;
  display: grid;
  grid-template-columns: 48px 1fr auto;
  align-items: center;
  gap: 10px;
  border: 1px solid #dfe4e8;
  border-radius: 14px;
  color: #4c5a6e;
  text-align: left;
  text-decoration: none;
  background: #fff;
}

.result-tool:hover:not(:disabled) {
  border-color: #a9cfc6;
  box-shadow: 0 8px 24px rgba(33, 83, 72, 0.06);
}

.result-tool:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.result-tool.cad {
  grid-template-columns: 135px 1fr auto;
}

.tool-preview {
  height: 80px;
  display: grid;
  place-items: center;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  color: #7990a6;
  background: linear-gradient(rgba(255, 255, 255, 0.74), rgba(255, 255, 255, 0.74)), linear-gradient(90deg, #dce4e9 1px, transparent 1px), linear-gradient(#dce4e9 1px, transparent 1px);
  background-size: auto, 12px 12px, 12px 12px;
}

.tool-preview svg {
  width: 125px;
}

.tool-preview > span {
  padding: 2px 5px;
  position: absolute;
  bottom: 5px;
  left: 6px;
  border-radius: 4px;
  color: #277d69;
  background: rgba(226, 245, 240, 0.94);
  font-size: 6px;
  font-weight: 850;
  letter-spacing: 0.07em;
}

.tool-icon {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #4e698f;
  background: #edf2f8;
  font-size: 7px;
  font-weight: 820;
}

.result-tool > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.result-tool > div:nth-child(2) span {
  color: #35927e;
  font-size: 6.5px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.result-tool > div:nth-child(2) strong {
  margin-top: 4px;
  color: #39475a;
  font-size: 10px;
}

.result-tool > div:nth-child(2) small {
  margin-top: 4px;
  color: #929ba8;
  font-size: 7px;
}

.result-tool > em {
  color: #6c798c;
  font-size: 7px;
  font-style: normal;
  font-weight: 720;
}

.final-approval {
  margin-top: 16px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #26354b;
  border-radius: 14px;
  background: linear-gradient(120deg, #f3f6f9, #fff 70%);
  box-shadow: 0 12px 28px rgba(28, 41, 61, 0.11);
}

.final-approval > div:first-child {
  display: grid;
}

.final-approval > div:first-child span {
  color: #53647b;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.1em;
}

.final-approval > div:first-child strong {
  margin-top: 4px;
  color: #2f3f54;
  font-size: 12px;
}

.final-approval-actions > button:disabled {
  cursor: default;
  color: #257b68;
  background: #e2f4ef;
  box-shadow: none;
}

.result-experience .final-approval-actions > button {
  min-height: 48px;
  padding: 0 18px;
  background: #1d2a3e;
  box-shadow: 0 9px 22px rgba(25, 38, 58, 0.2);
  font-size: 12px;
}

.final-approval-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.final-approval-actions > a {
  min-height: 42px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  border: 1px solid #d8e0e4;
  border-radius: 10px;
  color: #536277;
  background: #fff;
  font-size: 10px;
  font-weight: 700;
  text-decoration: none;
}

.final-approval-actions > a:hover {
  border-color: #b7d8d0;
  color: #287b68;
  background: #f3faf8;
}

.agent-feedback {
  max-width: 850px;
  min-height: 58px;
  margin: 25px auto 0;
  padding: 8px;
  display: grid;
  grid-template-columns: 36px 1fr auto;
  align-items: center;
  gap: 9px;
  border: 1px solid #dce1e6;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 9px 26px rgba(33, 43, 57, 0.05);
}

.feedback-avatar {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: #26344a;
  font-size: 8px;
  font-weight: 820;
}

.agent-feedback > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.agent-feedback span {
  color: #8d97a5;
  font-size: 6.5px;
}

.agent-feedback input {
  width: 100%;
  margin-top: 2px;
  border: 0;
  outline: 0;
  color: #435065;
  background: transparent;
  font-size: 9px;
}

.agent-feedback input::placeholder {
  color: #a0a8b4;
}

.agent-feedback > button {
  height: 34px;
  padding: 0 11px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  background: #273449;
  font-size: 8px;
  font-weight: 700;
}

.agent-feedback > button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.tool-backdrop {
  position: fixed;
  inset: 0;
  z-index: 70;
  background: rgba(13, 20, 31, 0.44);
  backdrop-filter: blur(3px);
}

.requirement-help-modal {
  width: min(680px, 100vw - 32px);
  max-height: calc(100vh - 64px);
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 71;
  overflow: hidden;
  border: 1px solid #d9e2e0;
  border-radius: 18px;
  overflow-y: auto;
  background: #f7f9f9;
  box-shadow: 0 24px 70px rgba(10, 18, 29, 0.25);
  animation: modal-in 0.2s ease-out both;
}

.requirement-help-head {
  min-height: 94px;
  padding: 18px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid #dde5e3;
  background: #fff;
}

.requirement-help-head > div {
  display: grid;
}

.requirement-help-head h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #293a4d;
  font-size: 20px;
}

.requirement-help-head h2 > span {
  color: #358470;
  font-size: 18px;
}

.requirement-help-head p {
  margin: 6px 0 0;
  color: #7b8795;
  font-size: 11px;
  line-height: 1.5;
}

.requirement-help-head button {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border: 1px solid #dce3e6;
  border-radius: 10px;
  color: #6d7a8b;
  background: #fff;
  font-size: 19px;
}

.requirement-help-list {
  padding: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.requirement-help-list article {
  min-height: 82px;
  padding: 14px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  border: 1px solid #dfe5e7;
  border-radius: 12px;
  background: #fff;
}

.requirement-help-list article > i {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: #526176;
  font-size: 11px;
  font-style: normal;
  font-weight: 820;
}

.requirement-help-list article.objective > i {
  background: #637fb1;
}

.requirement-help-list article.input > i {
  background: #32917b;
}

.requirement-help-list article.reference > i {
  background: #8d7956;
}

.requirement-help-list article > div {
  display: grid;
  gap: 5px;
}

.requirement-help-list strong {
  color: #34475a;
  font-size: 13px;
}

.requirement-help-list p {
  margin: 0;
  color: #69788a;
  font-size: 11px;
  line-height: 1.55;
}

.cad-result-drawer {
  width: min(860px, 100vw - 80px);
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 71;
  overflow-y: auto;
  background: #f7f8f8;
  box-shadow: -24px 0 60px rgba(10, 18, 29, 0.22);
  animation: drawer-in 0.25s ease-out;
}

.cad-drawer-head {
  min-height: 92px;
  padding: 0 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dde3e7;
  background: #fff;
}

.cad-drawer-head > div {
  display: grid;
}

.cad-drawer-head span {
  color: #39947f;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.cad-drawer-head h2 {
  margin: 5px 0 0;
  color: #2c394c;
  font-size: 18px;
}

.cad-drawer-head p {
  margin: 4px 0 0;
  color: #8b95a4;
  font-size: 8px;
}

.cad-drawer-head button {
  width: 36px;
  height: 36px;
  border: 1px solid #dfe4e8;
  border-radius: 10px;
  color: #6f7b8d;
  background: #fff;
  font-size: 19px;
}

.cad-viewer {
  margin: 18px;
  overflow: hidden;
  border: 1px solid #d9e1e6;
  border-radius: 15px;
  background: #fff;
}

.viewer-toolbar {
  min-height: 48px;
  padding: 0 11px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #e2e7eb;
}

.viewer-toolbar button {
  height: 29px;
  padding: 0 9px;
  border: 1px solid #e0e5e9;
  border-radius: 7px;
  color: #6c798b;
  background: #fff;
  font-size: 7px;
}

.viewer-toolbar button.active {
  border-color: #b7dcd4;
  color: #297f6b;
  background: #eff9f6;
}

.cad-canvas {
  height: 540px;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;
  color: #778da3;
  background: #f5f8fa;
}

.canvas-grid {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(114, 137, 156, 0.1) 1px, transparent 1px), linear-gradient(rgba(114, 137, 156, 0.1) 1px, transparent 1px);
  background-size: 24px 24px;
}

.cad-canvas > svg {
  width: 86%;
  position: relative;
  z-index: 1;
}

.coordinate-label {
  padding: 7px 9px;
  display: grid;
  position: absolute;
  z-index: 2;
  border: 1px solid #b8dcd4;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 5px 16px rgba(34, 65, 60, 0.1);
}

.coordinate-label span {
  color: #35917d;
  font-size: 6px;
  font-weight: 800;
}

.coordinate-label strong {
  margin-top: 3px;
  color: #526174;
  font-size: 8px;
}

.coordinate-label.point-a {
  left: 48%;
  bottom: 35%;
}

.coordinate-label.point-b {
  top: 22%;
  right: 14%;
}

.viewer-status {
  height: 30px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  gap: 6px;
  position: absolute;
  right: 14px;
  bottom: 14px;
  z-index: 2;
  border: 1px solid #cce5df;
  border-radius: 8px;
  color: #287d69;
  background: rgba(242, 250, 248, 0.94);
  font-size: 7px;
  font-weight: 700;
}

.viewer-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3bb99d;
}

.cad-result-metrics {
  margin: 0 18px 22px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.cad-result-metrics div {
  min-height: 72px;
  padding: 11px;
  display: grid;
  border: 1px solid #dce3e7;
  border-radius: 10px;
  background: #fff;
}

.cad-result-metrics span {
  color: #8b96a5;
  font-size: 7px;
}

.cad-result-metrics strong {
  margin-top: 5px;
  color: #435267;
  font-size: 10px;
}

.simulation-result-drawer {
  width: min(760px, 100vw - 80px);
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 71;
  overflow-y: auto;
  background: #f5f8f7;
  box-shadow: -24px 0 60px rgba(10, 18, 29, 0.22);
  animation: drawer-in 0.25s ease-out;
}

.simulation-drawer-head {
  min-height: 104px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid #dce4e2;
  background: #fff;
}

.simulation-drawer-head > div {
  min-width: 0;
  display: grid;
}

.simulation-drawer-head span {
  color: #2e8b75;
  font-size: 9px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.simulation-drawer-head h2 {
  margin: 4px 0 0;
  color: #293a4e;
  font-size: 22px;
}

.simulation-drawer-head p {
  margin: 4px 0 0;
  color: #7c8998;
  font-size: 11px;
  line-height: 1.45;
}

.simulation-drawer-head > button {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border: 1px solid #dce3e6;
  border-radius: 10px;
  color: #6d7a8b;
  background: #fff;
  font-size: 19px;
}

.simulation-drawer-body {
  padding: 18px;
}

.simulation-process-section {
  padding: 15px;
  border: 1px solid #dce5e2;
  border-radius: 13px;
  background: #fff;
}

.simulation-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
}

.simulation-section-head > div {
  display: grid;
}

.simulation-section-head span {
  color: #2f8b75;
  font-size: 8px;
  font-weight: 830;
  letter-spacing: 0.09em;
}

.simulation-section-head strong {
  margin-top: 3px;
  color: #34465a;
  font-size: 15px;
}

.simulation-section-head > p {
  max-width: 390px;
  margin: 0;
  color: #7b8898;
  font-size: 9px;
  line-height: 1.45;
  text-align: right;
}

.simulation-process-track {
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(3, 1.06fr) repeat(2, 0.91fr);
  gap: 7px;
  position: relative;
}

.simulation-process-track::before {
  content: "";
  height: 2px;
  position: absolute;
  top: 15px;
  right: 7%;
  left: 7%;
  background: linear-gradient(90deg, #59b39d, #7ca9ce 62%, #5eb49e);
}

.simulation-process-stage {
  min-width: 0;
  padding: 0 7px 8px;
  display: grid;
  align-content: start;
  position: relative;
  border: 1px solid transparent;
  border-radius: 9px;
  background: #f8faf9;
}

.simulation-process-stage.rechecked {
  background: #f5f7fb;
}

.simulation-process-stage.priority {
  border-color: #abd7cd;
  background: #f0f9f6;
  box-shadow: 0 6px 16px rgba(41, 126, 107, 0.08);
}

.simulation-process-stage.priority.rechecked {
  border-color: #bdc7e8;
  background: #f1f3fb;
  box-shadow: 0 6px 16px rgba(79, 99, 163, 0.08);
}

.simulation-process-node {
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.simulation-process-node span {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 3px solid #fff;
  border-radius: 50%;
  color: #fff;
  background: #338b76;
  box-shadow: 0 0 0 1px #acd5cc;
  font-size: 8px;
  font-weight: 830;
}

.simulation-process-stage.rechecked .simulation-process-node span {
  background: #6279b7;
  box-shadow: 0 0 0 1px #c3cceb;
}

.simulation-process-node i {
  color: #28836e;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
}

.simulation-process-title {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.simulation-process-title strong {
  color: #36485c;
  font-size: 11px;
}

.simulation-process-title em {
  padding: 2px 4px;
  border-radius: 4px;
  color: #267d69;
  background: #dff2ed;
  font-size: 7px;
  font-style: normal;
  font-weight: 830;
}

.simulation-process-stage > small {
  margin-top: 2px;
  overflow: hidden;
  color: #7a8797;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simulation-process-stage > p {
  min-height: 30px;
  margin: 5px 0 0;
  color: #697788;
  font-size: 9px;
  line-height: 1.35;
}

.simulation-process-iteration {
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3px;
}

.simulation-process-iteration span,
.simulation-process-iteration em {
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.simulation-process-iteration span {
  color: #287d69;
  background: #e6f4f0;
}

.simulation-process-iteration em {
  color: #748294;
  background: #edf0f3;
}

.simulation-process-stage.rechecked .simulation-process-iteration span {
  color: #5e70ab;
  background: #e9ecf8;
}

.simulation-process-stage > b {
  margin-top: 4px;
  overflow: hidden;
  color: #2d4358;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simulation-recovery {
  margin-top: 11px;
  padding: 11px;
  border: 1px solid #e8ddd0;
  border-radius: 10px;
  background: #fffbf6;
}

.simulation-recovery-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.simulation-recovery-head span {
  color: #997044;
  font-size: 8px;
  font-weight: 830;
  letter-spacing: 0.08em;
}

.simulation-recovery-head strong {
  color: #635746;
  font-size: 11px;
}

.simulation-recovery-story {
  margin-top: 8px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 7px;
  background: #f7f2eb;
}

.simulation-recovery-story span {
  color: #74695d;
  font-size: 8px;
  font-weight: 760;
  white-space: nowrap;
}

.simulation-recovery-story span.ai {
  color: #8d6133;
  font-weight: 850;
}

.simulation-recovery-story span.pass {
  color: #267c68;
  font-weight: 850;
}

.simulation-recovery-story i {
  color: #b3a18e;
  font-size: 8px;
  font-style: normal;
}

.simulation-ai-decision {
  margin: 6px 0 0;
  padding: 6px 8px;
  border-left: 3px solid #bc8548;
  border-radius: 0 6px 6px 0;
  color: #715c43;
  background: #fff7ec;
  font-size: 8.5px;
  font-weight: 720;
  line-height: 1.35;
}

.simulation-recovery-flow {
  margin-top: 8px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18px minmax(0, 1fr) 18px minmax(0, 1fr);
  align-items: center;
  gap: 5px;
}

.simulation-recovery-step {
  min-width: 0;
  min-height: 94px;
  padding: 8px;
  display: grid;
  align-content: center;
  border: 1px solid #e6e0d9;
  border-radius: 8px;
  background: #fff;
}

.simulation-recovery-step.fail {
  border-color: #efd4cf;
  background: #fff8f7;
}

.simulation-recovery-step.pass {
  border-color: #cde2dc;
  background: #f5fbf9;
}

.simulation-recovery-step span {
  color: #93704b;
  font-size: 8px;
  font-weight: 820;
}

.simulation-recovery-step.fail span {
  color: #a24f46;
}

.simulation-recovery-step.pass span {
  color: #277c68;
}

.simulation-recovery-step strong {
  margin-top: 3px;
  color: #4d5969;
  font-size: 10px;
}

.simulation-recovery-step p {
  margin: 3px 0 0;
  color: #7c8794;
  font-size: 9px;
  line-height: 1.35;
}

.simulation-recovery-step small {
  margin-top: 5px;
  padding-top: 5px;
  color: #6f7a88;
  border-top: 1px dashed #ddd9d2;
  font-size: 8px;
  font-weight: 650;
  line-height: 1.4;
}

.simulation-recovery-step.fail small {
  color: #8d5c55;
  border-top-color: #ead4d0;
}

.simulation-recovery-step.pass small {
  color: #367866;
  border-top-color: #d4e4df;
}

.simulation-recovery-flow > i {
  color: #aa9275;
  font-size: 11px;
  font-style: normal;
}

.simulation-final-section {
  margin-top: 18px;
}

.simulation-final-section .simulation-result-summary {
  margin-top: 10px;
}

.simulation-result-summary {
  min-height: 92px;
  padding: 15px 16px;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border: 1px solid #bfddd5;
  border-radius: 13px;
  color: #287a67;
  background: linear-gradient(110deg, #eaf7f3, #fff 72%);
  box-shadow: 0 8px 22px rgba(35, 112, 94, 0.07);
}

.simulation-result-summary.running {
  color: #596fae;
  border-color: #cbd3ee;
  background: linear-gradient(110deg, #f0f2fb, #fff 72%);
}

.simulation-result-mark {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #fff;
  background: #2b8d76;
}

.simulation-result-summary.running .simulation-result-mark {
  background: #6175b7;
}

.simulation-result-mark svg {
  width: 23px;
  height: 23px;
}

.simulation-result-mark i {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.simulation-result-summary > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.simulation-result-summary span {
  font-size: 9px;
  font-weight: 820;
  letter-spacing: 0.07em;
}

.simulation-result-summary strong {
  margin-top: 3px;
  color: #29465a;
  font-size: 17px;
}

.simulation-result-summary small {
  margin-top: 4px;
  overflow: hidden;
  color: #718191;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simulation-result-summary > em {
  padding: 6px 9px;
  border-radius: 999px;
  color: #fff;
  background: #2b8d76;
  font-size: 10px;
  font-style: normal;
  font-weight: 820;
}

.simulation-result-summary.running > em {
  background: #6175b7;
}

.simulation-result-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.simulation-result-item {
  min-width: 0;
  min-height: 142px;
  padding: 12px 13px;
  display: grid;
  align-content: start;
  border: 1px solid #dfe6e4;
  border-radius: 11px;
  background: #fff;
}

.simulation-result-item.caution {
  border-color: #eadbc4;
  background: #fffbf5;
}

.simulation-result-item.priority {
  border-color: #bfded6;
  background: linear-gradient(135deg, #f7fcfa, #fff 68%);
  box-shadow: 0 6px 16px rgba(38, 121, 101, 0.055);
}

.simulation-result-item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.simulation-result-item-head > div {
  min-width: 0;
  display: grid;
}

.simulation-result-tool-line {
  display: flex;
  align-items: center;
  gap: 5px;
}

.simulation-result-tool-line i {
  padding: 2px 4px;
  border-radius: 4px;
  color: #267d69;
  background: #dff2ed;
  font-size: 7px;
  font-style: normal;
  font-weight: 830;
}

.simulation-result-item-head span {
  color: #338772;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.07em;
}

.simulation-result-item-head strong {
  margin-top: 2px;
  color: #46566a;
  font-size: 11px;
}

.simulation-result-item-head em {
  padding: 3px 6px;
  border-radius: 999px;
  color: #287c68;
  background: #e6f5f1;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
}

.simulation-result-item.caution .simulation-result-item-head em {
  color: #8a652e;
  background: #f8ecd9;
}

.simulation-result-comparison {
  margin-top: 9px;
  padding: 8px;
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border-radius: 8px;
  background: #f5f8f8;
}

.simulation-result-item.caution .simulation-result-comparison {
  background: #faf4ea;
}

.simulation-result-comparison > div {
  min-width: 0;
  display: grid;
}

.simulation-result-comparison span {
  color: #84909d;
  font-size: 8px;
  font-weight: 700;
}

.simulation-result-comparison strong {
  margin-top: 2px;
  overflow: hidden;
  color: #58677a;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simulation-result-comparison .result strong {
  color: #2e465b;
  font-size: 14px;
}

.simulation-result-item.priority .simulation-result-item-head strong {
  color: #344b5d;
  font-size: 12px;
}

.simulation-result-item.priority .simulation-result-comparison .result strong {
  color: #24465a;
  font-size: 17px;
}

.simulation-result-item.priority .simulation-result-comparison > b {
  font-size: 10px;
}

.simulation-result-comparison > i {
  color: #9aa7b2;
  font-size: 10px;
  font-style: normal;
}

.simulation-result-comparison > b {
  padding: 4px 6px;
  border-radius: 6px;
  color: #237c68;
  background: #e1f2ed;
  font-size: 9px;
  white-space: nowrap;
}

.simulation-result-item.caution .simulation-result-comparison > b {
  color: #88642d;
  background: #f4e5cf;
}

.simulation-result-item > b {
  margin-top: 8px;
  color: #293d52;
  font-size: 18px;
}

.simulation-result-item > small {
  margin-top: 3px;
  color: #6174b2;
  font-size: 10px;
  font-weight: 700;
}

.simulation-result-item > p {
  margin: 5px 0 0;
  color: #7a8796;
  font-size: 10px;
  line-height: 1.4;
}

.simulation-result-footer {
  margin-top: 12px;
  padding: 13px 14px;
  display: block;
  border: 1px solid #dce4e2;
  border-radius: 11px;
  background: #fff;
}

.simulation-result-footer-head {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.simulation-result-footer-head > div {
  min-width: 0;
  display: grid;
}

.simulation-result-footer span {
  color: #368873;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.simulation-result-footer strong {
  margin-top: 3px;
  color: #4c5b6e;
  font-size: 11px;
}

.simulation-result-footer small {
  margin-top: 3px;
  color: #8a96a4;
  font-size: 9px;
}

.simulation-footer-actions {
  display: flex;
  align-items: center;
  gap: 7px;
}

.simulation-footer-actions > button,
.simulation-footer-actions > a {
  height: 36px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #c5ddd7;
  border-radius: 9px;
  color: #287d69;
  background: #eff8f5;
  font-size: 10px;
  font-weight: 760;
  text-decoration: none;
}

.simulation-footer-actions > a {
  border-color: #314b60;
  color: #fff;
  background: #314b60;
}

.simulation-footer-actions > button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.simulation-result-use-flow {
  margin-top: 10px;
  padding-top: 10px;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) 16px minmax(0, 0.8fr) 16px minmax(0, 0.9fr) 16px minmax(0, 0.8fr);
  align-items: center;
  gap: 5px;
  border-top: 1px solid #e4e9e7;
}

.simulation-result-use-step {
  min-width: 0;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  opacity: 0.72;
}

.simulation-result-use-step > i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border: 1px solid #cbd5d2;
  border-radius: 50%;
  color: #6e7f7a;
  background: #f5f7f7;
  font-size: 8px;
  font-style: normal;
  font-weight: 820;
}

.simulation-result-use-step.done {
  opacity: 1;
}

.simulation-result-use-step.done > i {
  color: #fff;
  border-color: #2e8b75;
  background: #2e8b75;
}

.simulation-result-use-step > div {
  min-width: 0;
  display: grid;
}

.simulation-result-use-step span {
  color: #84918f;
  font-size: 7px;
}

.simulation-result-use-step strong {
  margin-top: 1px;
  overflow: hidden;
  color: #45576a;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simulation-result-use-step small {
  margin-top: 2px;
  overflow: hidden;
  color: #84919e;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.simulation-result-use-flow > em {
  color: #9cacaa;
  font-size: 10px;
  font-style: normal;
}

.combination-explorer,
.linked-data-ecosystem,
.agent-contract-pipeline,
.simulation-suite,
.autonomous-feedback-loop {
  margin-top: 18px;
  padding: 18px;
  border: 1px solid #dde3e7;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.035);
}

.combination-head,
.ecosystem-head,
.simulation-suite-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.combination-head > div,
.ecosystem-head > div,
.simulation-suite-head > div,
.contract-head {
  display: grid;
}

.combination-head span,
.ecosystem-head span,
.simulation-suite-head span,
.contract-head span,
.feedback-loop-title span {
  color: #39927f;
  font-size: 9px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.combination-head strong,
.ecosystem-head strong,
.simulation-suite-head strong,
.contract-head strong,
.feedback-loop-title strong {
  margin-top: 5px;
  color: #334156;
  font-size: 14px;
}

.combination-head > em {
  flex: 0 0 auto;
  padding: 9px 12px;
  border: 1px solid #d6e8e3;
  border-radius: 9px;
  color: #5d6a7c;
  background: #f3faf8;
  font-size: 11px;
  font-style: normal;
  font-weight: 680;
}

.combination-head > em strong {
  margin: 0;
  color: #23806b;
  font-size: 16px;
}

.variable-equation {
  margin-top: 15px;
  display: flex;
  align-items: stretch;
  gap: 7px;
}

.design-variable {
  min-width: 0;
  padding: 11px 10px;
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: 8px;
  border: 1px solid #e1e6ea;
  border-radius: 11px;
  background: #fafbfc;
}

.variable-symbol,
.source-symbol,
.simulation-symbol {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 8px;
  color: #246f60;
  background: #e1f3ee;
  font-weight: 840;
}

.variable-symbol {
  width: 27px;
  height: 27px;
  font-size: 10px;
}

.design-variable > div:last-child {
  min-width: 0;
  display: grid;
}

.design-variable span {
  color: #788699;
  font-size: 9px;
}

.design-variable strong {
  margin-top: 2px;
  color: #354459;
  font-size: 13px;
}

.design-variable small {
  margin-top: 2px;
  overflow: hidden;
  color: #929dab;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.variable-equation > i {
  display: grid;
  place-items: center;
  color: #a0a9b5;
  font-size: 12px;
  font-style: normal;
}

.combination-result {
  min-width: 116px;
  padding: 10px 13px;
  display: grid;
  align-content: center;
  border-radius: 11px;
  color: #fff;
  background: linear-gradient(145deg, #2b394f, #172237);
}

.combination-result span {
  color: #b8c2d0;
  font-size: 8px;
}

.combination-result strong {
  margin-top: 2px;
  font-size: 19px;
  letter-spacing: -0.02em;
}

.combination-result small {
  margin-top: 1px;
  color: #82d7c4;
  font-size: 7px;
}

.alternative-generation-flow {
  margin-top: 12px;
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(5, 1fr auto) 1fr;
  align-items: center;
  gap: 7px;
  border: 1px solid #e5e9ec;
  border-radius: 12px;
  background: #f8faf9;
}

.generation-step {
  min-width: 0;
  display: grid;
}

.generation-step span {
  color: #758397;
  font-size: 9px;
}

.generation-step strong {
  margin-top: 3px;
  color: #27374c;
  font-size: 20px;
  letter-spacing: -0.025em;
}

.generation-step small {
  margin-top: 2px;
  color: #939eac;
  font-size: 8px;
  line-height: 1.35;
}

.generation-step.pending {
  opacity: 0.42;
}

.alternative-generation-flow > svg {
  width: 17px;
  height: 17px;
  color: #9aa6b3;
}

.linked-data-ecosystem {
  padding-bottom: 16px;
}

.ecosystem-head p,
.simulation-suite-head p {
  max-width: 390px;
  margin: 0;
  color: #7b8798;
  font-size: 10px;
  line-height: 1.55;
  text-align: right;
}

.data-source-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px;
}

.data-source-card {
  min-width: 0;
  min-height: 102px;
  padding: 11px;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-content: center;
  gap: 9px;
  border: 1px solid #e2e6ea;
  border-radius: 11px;
  background: #fafbfc;
}

.source-symbol {
  width: 30px;
  height: 30px;
  font-size: 8px;
}

.data-source-card > div:last-child {
  min-width: 0;
  display: grid;
}

.data-source-card strong {
  color: #3a485c;
  font-size: 11px;
}

.data-source-card span {
  margin-top: 3px;
  color: #7d8999;
  font-size: 9px;
  line-height: 1.35;
}

.data-source-card small {
  margin-top: 6px;
  color: #32917d;
  font-size: 8px;
  line-height: 1.35;
}

.agent-contract-pipeline {
  padding: 18px;
}

.contract-head {
  grid-template-columns: 1fr auto;
  align-items: end;
}

.contract-head strong {
  grid-column: 1;
  grid-row: 2;
}

.contract-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.agent-contract {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dfe5e8;
  border-radius: 12px;
  background: #fbfcfc;
}

.contract-agent {
  min-height: 48px;
  padding: 9px 11px;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  align-items: center;
  gap: 1px 8px;
  border-bottom: 1px solid #e4e8eb;
  background: #f5f8f8;
}

.contract-agent > span {
  width: 25px;
  height: 25px;
  display: grid;
  grid-row: 1/3;
  place-items: center;
  border-radius: 7px;
  color: #fff;
  background: #2a3a50;
  font-size: 8px;
  font-weight: 780;
}

.contract-agent strong {
  color: #354459;
  font-size: 11px;
}

.contract-agent em {
  overflow: hidden;
  color: #789084;
  font-size: 8px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contract-flow {
  min-height: 108px;
  padding: 10px;
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) auto minmax(0, 1.25fr) auto minmax(0, 0.92fr);
  align-items: center;
  gap: 4px;
}

.contract-flow > div {
  min-width: 0;
  display: grid;
  align-content: start;
}

.contract-flow span {
  color: #8995a4;
  font-size: 8px;
  font-weight: 780;
  letter-spacing: 0.06em;
}

.contract-flow strong {
  margin-top: 5px;
  color: #4a586b;
  font-size: 9px;
  font-weight: 620;
  line-height: 1.45;
}

.contract-flow .decision {
  padding: 8px;
  border-radius: 8px;
  background: #eef7f4;
}

.contract-flow .decision span {
  color: #318774;
}

.contract-flow > i {
  color: #a5aeb9;
  font-size: 9px;
  font-style: normal;
}

.contract-handoff {
  min-height: 48px;
  padding: 8px 11px;
  display: grid;
  border-top: 1px solid #e5e9ec;
  background: #fff;
}

.contract-handoff span {
  color: #909aa8;
  font-size: 8px;
}

.contract-handoff strong {
  margin-top: 3px;
  color: #527267;
  font-size: 10px;
}

.simulation-check-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;
}

.simulation-check {
  min-width: 0;
  padding: 12px;
  border: 1px solid #e1e6e9;
  border-radius: 12px;
  background: #fafbfc;
}

.simulation-check-head {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}

.simulation-symbol {
  width: 32px;
  height: 32px;
  font-size: 11px;
}

.simulation-check-head > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.simulation-check-head strong {
  color: #354459;
  font-size: 11px;
}

.simulation-check-head span {
  margin-top: 2px;
  color: #8a95a4;
  font-size: 8px;
}

.simulation-check-head em {
  padding: 4px 6px;
  border-radius: 6px;
  color: #277965;
  background: #e2f3ee;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.simulation-transition {
  margin-top: 11px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
}

.simulation-state {
  min-width: 0;
  min-height: 58px;
  padding: 8px;
  display: grid;
  align-content: center;
  border-radius: 8px;
}

.simulation-state span {
  font-size: 8px;
  font-weight: 760;
}

.simulation-state strong {
  margin-top: 4px;
  font-size: 9px;
  line-height: 1.35;
}

.simulation-state.fail {
  color: #9a4c45;
  background: #fff0ee;
}

.simulation-state.pass {
  color: #277563;
  background: #eaf7f3;
}

.simulation-transition > i {
  color: #98a4b2;
  font-size: 10px;
  font-style: normal;
}

.autonomous-feedback-loop {
  padding-bottom: 12px;
}

.feedback-loop-title {
  display: grid;
}

.feedback-loop-flow {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr) auto) minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.feedback-loop-node {
  min-width: 0;
  min-height: 78px;
  padding: 11px;
  display: grid;
  align-content: center;
  border: 1px solid #dfe5e8;
  border-radius: 10px;
  background: #f8fafb;
}

.feedback-loop-node > span {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  color: #607085;
  background: #e7ebef;
  font-size: 8px;
  font-weight: 780;
}

.feedback-loop-node strong {
  margin-top: 7px;
  color: #3a485c;
  font-size: 10px;
}

.feedback-loop-node small {
  margin-top: 3px;
  color: #8995a3;
  font-size: 9px;
  line-height: 1.35;
}

.feedback-loop-node.fail {
  border-color: #efd5d1;
  background: #fff9f8;
}

.feedback-loop-node.fail > span {
  color: #a74b42;
  background: #f9e5e2;
}

.feedback-loop-node.redesign {
  border-color: #eadcc6;
  background: #fffbf5;
}

.feedback-loop-node.redesign > span {
  color: #8a6431;
  background: #f6ead7;
}

.feedback-loop-node.pass {
  border-color: #cfe6df;
  background: #f5fbf9;
}

.feedback-loop-node.pass > span {
  color: #247663;
  background: #ddf2ec;
}

.feedback-loop-flow > i {
  color: #99a5b2;
  font-size: 11px;
  font-style: normal;
}

.feedback-return {
  margin-top: 4px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  color: #a07035;
}

.feedback-return svg {
  width: min(74%, 650px);
  height: 28px;
}

.feedback-return span {
  margin-top: -3px;
  font-size: 8px;
  font-weight: 680;
}

/* Readability scale for the AI-first workspace */
.platform-identity strong {
  font-size: 15px;
}

.platform-identity small,
.project-context,
.header-actions button {
  font-size: 11px;
}

.run-status {
  font-size: 10px;
}

.journey-step {
  min-width: 132px;
}

.journey-step strong {
  font-size: 12px;
}

.journey-step small {
  font-size: 9px;
}

.journey-step > span em {
  font-size: 10px;
}

.hero-badge {
  font-size: 9px;
}

.input-hero h1 {
  font-size: 38px;
}

.input-hero p {
  font-size: 14px;
}

.constellation-agent strong {
  font-size: 9.5px;
}

.constellation-agent small {
  font-size: 8px;
}

.composer-agent strong {
  font-size: 13px;
}

.composer-agent small {
  font-size: 10px;
}

.composer-top > em,
.file-chip,
.add-file {
  font-size: 10px;
}

.conversation-composer textarea {
  font-size: 14px;
}

.run-button-copy span {
  font-size: 11px;
}

.run-button-copy small {
  font-size: 8px;
}

.quick-prompts > span,
.quick-prompts strong {
  font-size: 10px;
}

.quick-prompts small {
  font-size: 8px;
}

.approval-agent > div:last-child span,
.stage-heading > div:nth-child(2) > span,
.story-head span,
.summary-card-head span {
  font-size: 9px;
}

.approval-agent strong {
  font-size: 15px;
}

.approval-head > em {
  font-size: 9px;
}

.brief-copy > span {
  font-size: 8px;
}

.brief-copy strong {
  font-size: 13px;
}

.brief-copy p,
.brief-source strong {
  font-size: 9px;
}

.brief-source span,
.brief-source small,
.requirement-item-evidence span {
  font-size: 8px;
}

.requirement-item-evidence p {
  font-size: 9px;
}

.guide-copy strong {
  font-size: 12px;
}

.guide-copy p,
.classification-item strong,
.requirement-summary > p,
.approval-evidence > div,
.approval-evidence button {
  font-size: 10px;
}

.classification-item span,
.classification-item small,
.requirement-summary span,
.requirement-item-head select,
.requirement-item label > span,
.requirement-item-foot small,
.requirement-item-foot button {
  font-size: 9px;
}

.requirement-confidence span,
.evidence-title em {
  font-size: 8px;
}

.requirement-confidence strong {
  font-size: 10px;
}

.requirement-review strong {
  font-size: 9px;
}

.requirement-review p,
.requirement-review button {
  font-size: 8px;
}

.group-identity strong {
  font-size: 12px;
}

.group-identity span,
.group-count em,
.group-count span {
  font-size: 8px;
}

.requirement-item label input {
  font-size: 13px;
}

.approval-action > div strong {
  font-size: 11px;
}

.approval-action > div span,
.approval-action > button {
  font-size: 10px;
}

.stage-heading h1 {
  font-size: 26px;
}

.stage-heading p {
  font-size: 12px;
}

.heading-progress span,
.queue-head span,
.queue-agent > div small,
.queue-agent > em,
.thinking-label span,
.thinking-label em,
.output-copy > span {
  font-size: 9px;
}

.queue-head strong {
  font-size: 12px;
}

.queue-agent > div strong {
  font-size: 11px;
}

.live-agent-head > div:nth-child(2) span {
  font-size: 9px;
}

.live-agent-head h2 {
  font-size: 20px;
}

.live-agent-head p,
.output-copy p {
  font-size: 10px;
}

.confidence-chip span,
.decision-card span {
  font-size: 8px;
}

.decision-card strong,
.output-metric span,
.output-metric small {
  font-size: 9px;
}

.decision-card small {
  font-size: 8px;
}

.output-copy strong {
  font-size: 15px;
}

.output-metric strong {
  font-size: 14px;
}

.feed-head strong,
.story-head strong {
  font-size: 13px;
}

.feed-head span,
.message-meta span,
.message-meta time,
.story-event span,
.story-event small {
  font-size: 9px;
}

.message-meta strong,
.message-content p,
.story-event strong {
  font-size: 11px;
}

.message-tags em {
  font-size: 8px;
}

.exploration-stage span,
.exploration-stage small,
.iteration-selector button > span,
.iteration-selector button > small,
.variable-change > span,
.iteration-metric span,
.iteration-metric small {
  font-size: 9px;
}

.iteration-selector button > strong {
  font-size: 12px;
}

.iteration-title h2 {
  font-size: 16px;
}

.variable-change em {
  font-size: 10px;
}

.iteration-metric strong {
  font-size: 16px;
}

.design-option-top span,
.design-option-top em,
.design-score small,
.design-key-metrics span,
.criterion-head span,
.criterion-head strong,
.criterion > small,
.select-indicator {
  font-size: 9px;
}

.design-option h2 {
  font-size: 18px;
}

.design-option > p {
  font-size: 10px;
}

.design-key-metrics strong {
  font-size: 10px;
}

.result-hero-copy > span,
.result-score > span,
.result-score small,
.summary-card-head > em,
.result-criterion small,
.result-component span,
.verified-metric span,
.verified-metric small,
.result-tool > div:nth-child(2) span,
.result-tool > div:nth-child(2) small,
.result-tool > em,
.final-approval > div:first-child span,
.agent-feedback span {
  font-size: 8px;
}

.result-hero p,
.result-summary-card > p,
.result-criterion span,
.result-criterion strong {
  font-size: 10px;
}

.summary-card-head h2 {
  font-size: 16px;
}

.result-component strong,
.result-tool > div:nth-child(2) strong {
  font-size: 10px;
}

.verified-metric strong {
  font-size: 14px;
}

.final-approval > div:first-child strong,
.agent-feedback input {
  font-size: 11px;
}

/* ReviewOps readability pass: input through final decision */
.journey-step strong {
  font-size: 13px;
}

.journey-step small,
.journey-step > span em,
.hero-badge {
  font-size: 10px;
}

.constellation-agent strong {
  font-size: 11px;
}

.constellation-agent small {
  font-size: 10px;
}

.composer-agent strong {
  font-size: 14px;
}

.composer-agent small,
.composer-top > em,
.file-chip,
.add-file,
.run-button-copy small,
.quick-prompts > span,
.quick-prompts strong,
.quick-prompts small {
  font-size: 10px;
}

.conversation-composer textarea {
  font-size: 15px;
}

.run-button-copy span {
  font-size: 12px;
}

.approval-agent > div:last-child span,
.stage-heading > div:nth-child(2) > span,
.story-head span,
.summary-card-head span {
  font-size: 10px;
}

.approval-agent strong {
  font-size: 16px;
}

.approval-head > em {
  font-size: 10px;
}

.brief-copy > span,
.brief-source span,
.brief-source small,
.project-information-head span,
.project-information-body span,
.brief-pipeline em,
.brief-pipeline strong {
  font-size: 10px;
}

.brief-copy strong,
.project-information-head strong {
  font-size: 14px;
}

.brief-copy p,
.brief-source strong,
.project-information-head small,
.project-information-source p,
.project-information-handoff strong,
.project-information-handoff small {
  font-size: 11px;
}

.project-information-body label input {
  font-size: 14px;
}

.guide-copy strong,
.group-identity strong {
  font-size: 13px;
}

.guide-copy p,
.classification-item strong,
.requirement-summary > p,
.approval-evidence > div,
.approval-evidence button,
.approval-action > div span,
.approval-action > button {
  font-size: 11px;
}

.classification-item span,
.classification-item small,
.requirement-summary span,
.requirement-item-head select,
.requirement-item label > span,
.requirement-item-foot small,
.requirement-item-foot button,
.requirement-confidence span,
.evidence-title em,
.requirement-item-evidence span,
.group-identity span,
.group-count em,
.group-count span {
  font-size: 10px;
}

.requirement-confidence strong,
.requirement-item-evidence p,
.requirement-review strong,
.requirement-review p,
.requirement-review button {
  font-size: 11px;
}

.requirement-item label input {
  font-size: 14px;
}

.requirement-routing span,
.requirement-routing-agents em,
.requirement-routing-purposes li {
  font-size: 10px;
}

.processing-chain em,
.processing-chain strong,
.processing-chain i {
  font-size: 9px;
}

.approval-action > div strong {
  font-size: 12px;
}

.stage-heading h1 {
  font-size: 28px;
}

.stage-heading p {
  font-size: 13px;
}

.heading-progress span,
.queue-head span,
.queue-agent > div small,
.queue-agent > em,
.thinking-label span,
.thinking-label em,
.output-copy > span,
.confidence-chip span,
.decision-card span,
.decision-card small,
.output-metric span,
.output-metric small {
  font-size: 10px;
}

.queue-head strong,
.queue-agent > div strong {
  font-size: 13px;
}

.live-agent-head > div:nth-child(2) span {
  font-size: 10px;
}

.live-agent-head h2 {
  font-size: 22px;
}

.live-agent-head p,
.output-copy p {
  font-size: 12px;
}

.decision-card strong {
  font-size: 11px;
}

.output-copy strong {
  font-size: 17px;
}

.output-metric strong {
  font-size: 15px;
}

.feed-head strong,
.story-head strong {
  font-size: 14px;
}

.feed-head span,
.message-meta span,
.message-meta time,
.story-event span,
.story-event small,
.message-tags em {
  font-size: 10px;
}

.message-meta strong,
.message-content p,
.story-event strong {
  font-size: 12px;
}

.combination-head span,
.ecosystem-head span,
.simulation-suite-head span,
.contract-head span,
.feedback-loop-title span {
  font-size: 10px;
}

.design-variable span,
.design-variable small,
.combination-result span,
.combination-result small,
.generation-step span,
.generation-step small,
.data-source-card span,
.data-source-card small,
.contract-agent em,
.contract-flow span,
.contract-handoff span,
.simulation-check-head span,
.simulation-check-head em,
.simulation-state span,
.feedback-loop-node > span,
.feedback-return span {
  font-size: 10px;
}

.design-variable strong,
.data-source-card strong,
.contract-agent strong,
.contract-handoff strong,
.simulation-check-head strong,
.feedback-loop-node strong {
  font-size: 12px;
}

.contract-flow strong,
.simulation-state strong,
.feedback-loop-node small {
  font-size: 11px;
}

.ecosystem-head p,
.simulation-suite-head p {
  font-size: 12px;
}

.exploration-stage span,
.exploration-stage small,
.iteration-selector button > span,
.iteration-selector button > small,
.variable-change > span,
.iteration-metric span,
.iteration-metric small {
  font-size: 10px;
}

.iteration-selector button > strong {
  font-size: 13px;
}

.iteration-title h2 {
  font-size: 18px;
}

.variable-change em {
  font-size: 11px;
}

.iteration-metric strong {
  font-size: 17px;
}

.evaluation-overview-head span,
.evaluation-overview-head p,
.evaluation-overview-head > em,
.evaluation-funnel-node span,
.evaluation-funnel-node small,
.confidence-method > div:first-child span,
.confidence-weights span {
  font-size: 10px;
}

.evaluation-agent-mark {
  font-size: 11px;
}

.evaluation-overview-head strong {
  font-size: 14px;
}

.evaluation-funnel-node strong {
  font-size: 17px;
}

.confidence-method > div:first-child strong,
.confidence-weights strong {
  font-size: 11px;
}

.recommendation-badge span {
  font-size: 10px;
}

.recommendation-badge strong {
  font-size: 18px;
}

.design-option-top span,
.design-option-top em,
.design-score small,
.design-key-metrics span,
.criterion-head span,
.criterion-head strong,
.criterion > small,
.select-indicator {
  font-size: 10px;
}

.design-option h2 {
  font-size: 20px;
}

.design-score > span {
  font-size: 10px;
}

.recommendation-reason span,
.design-tradeoff span,
.design-pros-cons > div > span,
.design-confidence-head span,
.confidence-factor span,
.confidence-factor strong {
  font-size: 9px;
}

.recommendation-reason p,
.design-tradeoff strong,
.design-pros-cons em,
.design-confidence-head strong,
.design-confidence > p {
  font-size: 11px;
}

.design-confidence-head > em {
  font-size: 18px;
}

.design-key-metrics strong {
  font-size: 12px;
}

.selected-summary span,
.selected-summary small {
  font-size: 10px;
}

.selected-summary strong {
  font-size: 13px;
}

.compare-action > button,
.final-approval-actions > button,
.final-approval-actions > a {
  font-size: 11px;
}

.result-hero h1 {
  font-size: 26px;
}

.result-hero-copy > span,
.result-score > span,
.result-score small,
.summary-card-head > em,
.result-criterion small,
.result-component span,
.verified-metric span,
.verified-metric small,
.result-tool > div:nth-child(2) span,
.result-tool > div:nth-child(2) small,
.result-tool > em,
.final-approval > div:first-child span,
.agent-feedback span {
  font-size: 10px;
}

.result-score em {
  font-size: 11px;
}

.result-hero p,
.result-summary-card > p,
.result-criterion span,
.result-criterion strong {
  font-size: 12px;
}

.summary-card-head h2 {
  font-size: 18px;
}

.result-component strong,
.result-tool > div:nth-child(2) strong {
  font-size: 12px;
}

.verified-metric strong {
  font-size: 16px;
}

.final-approval > div:first-child strong,
.agent-feedback input {
  font-size: 13px;
}

.feedback-avatar,
.agent-feedback > button {
  font-size: 11px;
}

.cad-drawer-head span,
.viewer-status,
.cad-result-metrics span {
  font-size: 10px;
}

.cad-drawer-head h2 {
  font-size: 20px;
}

.cad-drawer-head p,
.cad-result-metrics strong,
.coordinate-label strong {
  font-size: 12px;
}

.coordinate-label span {
  font-size: 10px;
}

/* Step 06 · compare first, inspect details on demand */
.compare-experience .stage-heading {
  min-height: 72px;
}

.compare-experience .recommendation-badge {
  min-width: 176px;
  padding: 7px 10px;
  border: 1px solid #d6e7e2;
  border-radius: 10px;
  text-align: left;
  background: #f4faf8;
}

.compare-experience .recommendation-badge span {
  color: #3b816f;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.compare-experience .recommendation-badge strong {
  margin-top: 1px;
  color: #21816b;
  font-size: 15px;
  line-height: 1;
}

.compare-experience .recommendation-badge small {
  margin-top: 3px;
  color: #697989;
  font-size: 7px;
  line-height: 1.3;
}

.finalist-rationale {
  margin-top: 5px;
  display: block;
  color: #5f7083;
  font-size: 9px;
  line-height: 1.35;
}

.comparison-summary {
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid #dbe2e6;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.035);
}

.comparison-summary-head {
  min-height: 52px;
  padding: 5px 12px;
  display: grid;
  grid-template-columns: minmax(280px, 1.1fr) auto minmax(300px, 1fr);
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e7eaed;
  background: linear-gradient(105deg, #f1f9f7, #fff 56%);
}

.decision-summary-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 9px;
}

.decision-summary-main > div:last-child {
  min-width: 0;
  display: grid;
}

.decision-ai {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  color: #fff;
  background: #24836e;
  box-shadow: 0 5px 14px rgba(36, 131, 110, 0.18);
  font-size: 10px;
  font-weight: 820;
}

.comparison-summary-head span {
  color: #27836f;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.comparison-summary-head h2 {
  margin: 2px 0 0;
  color: #2e3d51;
  font-size: 15px;
}

.decision-summary-main p {
  margin: 2px 0 0;
  color: #8591a0;
  font-size: 9px;
  line-height: 1.35;
}

.decision-summary-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}

.comparison-summary-head .decision-summary-chips span {
  padding: 4px 6px;
  border: 1px solid #d3e6e1;
  border-radius: 999px;
  color: #397967;
  background: #fff;
  font-size: 8px;
  font-weight: 730;
  letter-spacing: 0;
  white-space: nowrap;
}

.score-formula-compact {
  min-width: 0;
  padding-left: 12px;
  display: grid;
  border-left: 1px solid #dce8e5;
  cursor: help;
}

.score-formula-compact strong {
  margin-top: 3px;
  overflow: hidden;
  color: #3f5064;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.score-formula-compact em {
  margin-top: 3px;
  color: #7f8d9d;
  font-size: 8px;
  font-style: normal;
}

.comparison-matrix {
  min-width: 760px;
}

.comparison-row {
  min-height: 25px;
  display: grid;
  grid-template-columns: 124px repeat(3, minmax(0, 1fr));
  border-top: 1px solid #edf0f2;
}

.comparison-row:first-child {
  border-top: 0;
}

.matrix-label,
.matrix-value,
.matrix-design,
.matrix-confidence,
.score-calculation {
  min-width: 0;
  padding: 2px 12px;
  display: flex;
  align-items: center;
  border-left: 1px solid #edf0f2;
}

.matrix-label {
  border-left: 0;
  color: #788597;
  background: #fafbfc;
  font-size: 10px;
  font-weight: 720;
}

.matrix-head {
  min-height: 36px;
}

.matrix-head .matrix-label {
  color: #566579;
}

.matrix-design {
  justify-content: flex-start;
  gap: 7px;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  color: #49586c;
  text-align: left;
  background: #fff;
}

.matrix-design:hover,
.matrix-design.selected {
  background: #f1f9f7;
}

.matrix-design span {
  padding: 3px 6px;
  border-radius: 999px;
  color: #527062;
  background: #edf4f1;
  font-size: 9px;
  font-weight: 750;
}

.matrix-design strong {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.matrix-design em {
  margin-left: auto;
  color: #293c50;
  font-size: 12px;
  font-style: normal;
  font-weight: 820;
}

.score-calculation-row {
  min-height: 53px;
  background: #fbfcfd;
}

.score-label {
  display: grid;
  align-content: center;
}

.score-label strong {
  color: #536276;
  font-size: 9px;
}

.score-label span {
  margin-top: 2px;
  color: #929daa;
  font-size: 7px;
}

.score-calculation {
  display: grid;
  align-content: center;
  gap: 2px;
}

.score-equation {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.score-equation strong {
  color: #44556a;
  font-size: 12px;
}

.score-adjustment {
  padding: 2px 4px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border: 0;
  border-radius: 4px;
  color: #217c69;
  background: #e8f6f2;
  font-size: 9px;
  font-weight: 760;
  cursor: help;
}

.score-adjustment.negative {
  color: #9b672b;
  background: #faf1e4;
}

.score-adjustment:focus-visible {
  outline: 2px solid rgba(92, 124, 250, 0.35);
  outline-offset: 1px;
}

.score-adjustment i {
  width: 12px;
  height: 12px;
  display: grid;
  place-items: center;
  border: 1px solid currentColor;
  border-radius: 50%;
  color: inherit;
  font-size: 7px;
  font-style: normal;
  opacity: 0.72;
}

.score-equation i {
  color: #9aa4af;
  font-size: 8px;
  font-style: normal;
}

.score-equation .score-adjustment i {
  color: inherit;
  font-size: 7px;
}

.score-equation em {
  color: #293d52;
  font-size: 15px;
  font-style: normal;
  font-weight: 830;
}

.score-calculation > small {
  overflow: hidden;
  color: #8290a0;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metric-label {
  gap: 5px;
}

.metric-label strong {
  color: #667589;
  font-size: 10px;
}

.metric-label > span {
  padding: 2px 4px;
  border-radius: 4px;
  color: #778698;
  background: #edf1f4;
  font-size: 8px;
  font-weight: 750;
}

.metric-label > em {
  margin-left: auto;
  color: #526dd1;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.ai-priority-row {
  box-shadow: inset 3px 0 #6a7fe0;
}

.ai-priority-row .matrix-label {
  background: #f2f4fc;
}

.ai-priority-row .matrix-value {
  background: #f7f8fd;
  box-shadow: inset 0 1px #e6e9f8, inset 0 -1px #e6e9f8;
}

.matrix-value {
  position: relative;
  gap: 3px;
  color: #647286;
}

.matrix-value strong {
  color: #718093;
  font-size: 11px;
  font-weight: 620;
}

.matrix-value > span {
  color: #9aa3ae;
  font-size: 9px;
}

.matrix-value small {
  display: none;
}

.matrix-value em {
  margin-left: auto;
  padding: 2px 5px;
  border-radius: 999px;
  color: #187762;
  background: #e8f6f2;
  font-size: 8px;
  font-style: normal;
  font-weight: 760;
}

.matrix-value.best {
  background: transparent;
}

.matrix-value.best strong {
  color: #718093;
}

.ai-priority-row .matrix-value strong {
  color: #3e4f91;
  font-size: 13px;
  font-weight: 820;
}

.ai-priority-row .matrix-value.best {
  background: #eef8f5;
}

.ai-priority-row .matrix-value.best strong {
  color: #167963;
}

.adjustment-summary-row {
  min-height: 30px;
  background: #f8f9fc;
}

.adjustment-label {
  display: grid;
  align-content: center;
}

.adjustment-label strong {
  color: #536276;
  font-size: 9px;
}

.adjustment-label span {
  margin-top: 2px;
  color: #929daa;
  font-size: 7px;
}

.adjustment-summary {
  min-width: 0;
  padding: 3px 12px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 6px;
  position: relative;
  border: 0;
  border-left: 1px solid #edf0f2;
  color: #536276;
  text-align: left;
  background: transparent;
}

.adjustment-summary::before,
.adjustment-summary::after {
  position: absolute;
  z-index: 20;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.adjustment-summary::after {
  content: attr(data-tooltip);
  right: 10px;
  bottom: calc(100% + 7px);
  left: 10px;
  padding: 8px 9px;
  border: 1px solid #d9e1e7;
  border-radius: 8px;
  color: #4e5e72;
  text-align: left;
  background: #fff;
  box-shadow: 0 8px 22px rgba(32, 46, 64, 0.14);
  font-size: 8px;
  font-weight: 620;
  line-height: 1.45;
  transform: translateY(3px);
}

.adjustment-summary::before {
  content: "";
  width: 7px;
  height: 7px;
  bottom: calc(100% + 4px);
  left: 20px;
  border-right: 1px solid #d9e1e7;
  border-bottom: 1px solid #d9e1e7;
  background: #fff;
  transform: translateY(3px) rotate(45deg);
}

.adjustment-summary:hover,
.adjustment-summary:focus,
.adjustment-summary:focus-visible {
  z-index: 21;
}

.adjustment-summary:focus,
.adjustment-summary:focus-visible {
  outline: 2px solid rgba(67, 139, 123, 0.35);
  outline-offset: -2px;
}

.adjustment-summary:hover::before,
.adjustment-summary:hover::after,
.adjustment-summary:focus::before,
.adjustment-summary:focus::after,
.adjustment-summary:focus-visible::before,
.adjustment-summary:focus-visible::after {
  opacity: 1;
}

.adjustment-summary:hover::after,
.adjustment-summary:focus::after,
.adjustment-summary:focus-visible::after {
  transform: translateY(0);
}

.adjustment-summary:hover::before,
.adjustment-summary:focus::before,
.adjustment-summary:focus-visible::before {
  transform: translateY(0) rotate(45deg);
}

.adjustment-summary:hover {
  background: #f0f4fb;
}

.adjustment-summary strong {
  padding: 2px 4px;
  border-radius: 4px;
  color: #237c69;
  background: #e8f5f1;
  font-size: 9px;
}

.adjustment-summary.negative strong {
  color: #98652b;
  background: #faefe1;
}

.adjustment-summary span {
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adjustment-summary em {
  color: #77879a;
  font-size: 7px;
  font-style: normal;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.confidence-row {
  min-height: 40px;
  background: #fbfcfd;
}

.confidence-label {
  gap: 6px;
  cursor: help;
}

.confidence-label span {
  width: auto;
  height: 16px;
  padding: 0 5px;
  display: grid;
  place-items: center;
  border: 1px solid #cfd7de;
  border-radius: 999px;
  color: #6e7b8c;
  background: #fff;
  font-size: 9px;
}

.matrix-confidence {
  gap: 7px;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  color: #2b806c;
  text-align: left;
  background: transparent;
}

.matrix-confidence:hover {
  background: #eff8f5;
}

.matrix-confidence strong {
  font-size: 13px;
}

.matrix-confidence span {
  color: #6e7e8e;
  font-size: 9px;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.candidate-detail-heading {
  min-height: 44px;
  margin-top: 9px;
  display: grid;
  grid-template-columns: 34px auto 1fr;
  align-items: center;
  gap: 10px;
}

.section-step {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 1px solid #dbe1e6;
  border-radius: 9px;
  color: #617084;
  background: #fff;
  font-size: 10px;
  font-weight: 800;
}

.candidate-detail-heading > div:nth-child(2) {
  display: grid;
}

.candidate-detail-heading span {
  color: #2e816d;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.candidate-detail-heading h2 {
  margin: 2px 0 0;
  color: #354459;
  font-size: 14px;
}

.candidate-detail-heading p {
  margin: 0;
  color: #8591a1;
  font-size: 9px;
  text-align: right;
}

.design-comparison {
  margin-top: 4px;
  align-items: start;
}

.design-option {
  min-height: 0;
  padding: 14px;
  display: grid;
  gap: 11px;
  border-radius: 14px;
  cursor: pointer;
  outline: 0;
}

.design-option.selected {
  border-color: #3eae95;
  background: linear-gradient(145deg, #effaf7 0, #fff 58%);
  box-shadow: 0 16px 38px rgba(32, 126, 106, 0.16), inset 0 0 0 1px #69c3af;
}

.design-option.selected .design-name h2,
.design-option.selected .design-score-line strong {
  color: #176f5d;
}

.design-option.selected .design-key-metrics div {
  border-color: #d7ebe6;
  background: #f4faf8;
}

.design-option.recommended.selected::before {
  height: 6px;
  right: 13px;
  left: 13px;
  background: linear-gradient(90deg, #5272dd, #28ad8f);
  box-shadow: 0 3px 9px rgba(52, 149, 128, 0.18);
}

.design-option:focus-visible {
  border-color: #6283df;
  box-shadow: 0 0 0 3px rgba(92, 124, 250, 0.18);
}

.design-option h2 {
  margin: 3px 0 0;
  font-size: 17px;
}

.design-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.design-name {
  min-width: 0;
}

.design-name > span {
  color: #8792a1;
  font-size: 9px;
  font-weight: 760;
  letter-spacing: 0.06em;
}

.quick-select {
  min-width: 72px;
  height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  border: 1px solid #d9e0e5;
  border-radius: 9px;
  color: #667488;
  background: #fff;
  font-size: 10px;
  font-weight: 730;
  cursor: pointer;
}

.quick-select i {
  width: 9px;
  height: 9px;
  border: 1px solid #9ea9b5;
  border-radius: 50%;
}

.quick-select:hover,
.quick-select.selected {
  border-color: #98d1c4;
  color: #267d69;
  background: #edf8f5;
}

.design-option.recommended .quick-select {
  border-color: #83cdbd;
  color: #1f7d68;
  background: #e9f7f3;
  box-shadow: 0 4px 11px rgba(39, 132, 111, 0.12);
}

.design-option.recommended .quick-select.selected {
  border-color: #21836d;
  color: #fff;
  background: #21836d;
  box-shadow: 0 6px 15px rgba(33, 131, 109, 0.22);
}

.design-option.recommended .quick-select.selected i {
  border: 2px solid #21836d;
  background: #fff;
  box-shadow: 0 0 0 1px #fff;
}

.quick-select.selected i {
  border: 2px solid #fff;
  background: #31aa90;
  box-shadow: 0 0 0 1px #31aa90;
}

.design-score-line {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid #edf0f2;
  border-bottom: 1px solid #edf0f2;
}

.design-score-line > div:first-child {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.design-score-line span {
  color: #8490a0;
  font-size: 9px;
}

.design-score-line strong {
  margin-left: 4px;
  color: #293b50;
  font-size: 21px;
  line-height: 1;
}

.design-score-line em {
  color: #96a0ac;
  font-size: 9px;
  font-style: normal;
}

.ai-recommendation {
  padding: 6px 9px;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  border: 1px solid #bee1d8;
  color: #247b68;
  background: #e4f5f0;
  box-shadow: 0 4px 11px rgba(40, 132, 111, 0.16);
}

.ai-recommendation i {
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #28846f;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.ai-recommendation span {
  color: inherit;
  font-weight: 770;
}

.design-key-metrics {
  margin-top: 0;
}

.design-key-metrics div {
  padding: 8px 7px;
  background: #fafbfc;
}

.design-key-metrics span {
  font-size: 9px;
}

.design-key-metrics strong {
  font-size: 11px;
}

.design-advantages {
  display: grid;
  gap: 4px;
}

.design-advantages > span {
  margin-bottom: 1px;
  color: #6e7b8e;
  font-size: 9px;
  font-weight: 760;
}

.design-advantages strong {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #59687c;
  font-size: 10px;
  font-weight: 570;
  line-height: 1.35;
}

.design-advantages i {
  color: #289078;
  font-size: 9px;
  font-style: normal;
}

.detail-trigger {
  min-height: 34px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e0e5e9;
  border-radius: 9px;
  color: #5c6c80;
  background: #fafbfc;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.detail-trigger:hover {
  border-color: #bdd9d2;
  color: #267b68;
  background: #f3f9f7;
}

.detail-trigger[aria-expanded=true] {
  border-color: #a9d1c7;
  color: #247b68;
  background: #eef8f5;
}

.detail-trigger i {
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
}

.design-detail-panel {
  margin-top: 8px;
  padding: 11px 12px 12px;
  border: 1px solid #dde5e3;
  border-radius: 12px;
  background: #fafcfb;
  box-shadow: 0 6px 18px rgba(33, 68, 60, 0.035);
  animation: stage-in 0.2s ease-out;
}

.design-detail-head,
.detail-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.design-detail-head > div,
.detail-section-head > div {
  display: grid;
}

.design-detail-head span,
.detail-section-head span {
  color: #348572;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.design-detail-head h2 {
  margin: 2px 0 0;
  color: #344358;
  font-size: 14px;
}

.design-detail-head-actions {
  display: flex !important;
  align-items: center;
  gap: 6px;
}

.design-detail-head-actions > button {
  height: 28px;
  border: 1px solid #dce2e6;
  border-radius: 7px;
  color: #728094;
  background: #fff;
}

.design-detail-head-actions .detail-select {
  padding: 0 9px;
  color: #257b68;
  border-color: #badad2;
  background: #f2faf7;
  font-size: 8px;
  font-weight: 760;
}

.design-detail-head-actions .detail-select.selected {
  color: #fff;
  border-color: #2b8974;
  background: #2b8974;
}

.design-detail-head-actions .detail-close {
  width: 28px;
  font-size: 18px;
}

.design-detail-compact-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1.15fr 0.9fr 1.15fr;
  align-items: stretch;
  gap: 7px;
}

.design-detail-compact-grid > article {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #e2e8e6;
  border-radius: 9px;
  background: #fff;
}

.design-detail-compact-grid .detail-section-head strong {
  font-size: 10px;
}

.design-detail-compact-grid .detail-section-head > em {
  font-size: 7px;
}

.detail-recommendation > p {
  margin: 6px 0 0;
  color: #566779;
  font-size: 9px;
  font-weight: 620;
  line-height: 1.4;
}

.detail-evidence-list {
  margin-top: 7px;
  display: grid;
  gap: 4px;
}

.detail-evidence-list > div {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
}

.detail-evidence-list span {
  padding: 2px 5px;
  border-radius: 4px;
  color: #277d69;
  background: #eaf6f2;
  font-size: 7px;
  font-weight: 800;
}

.detail-evidence-list .caution span {
  color: #8b692f;
  background: #faf1e4;
}

.detail-evidence-list strong {
  overflow: hidden;
  color: #687587;
  font-size: 8px;
  font-weight: 590;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-score-equation {
  margin-top: 7px;
  padding: 6px 8px;
  display: flex;
  align-items: baseline;
  gap: 5px;
  border-radius: 7px;
  background: #f5f7fb;
}

.detail-score-equation > span {
  color: #7f8b9a;
  font-size: 7px;
  font-weight: 700;
}

.detail-score-equation strong,
.detail-score-equation b {
  color: #34475c;
  font-size: 13px;
}

.detail-score-equation em {
  padding: 2px 4px;
  border-radius: 4px;
  color: #237c69;
  background: #e8f5f1;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.detail-score-equation em.negative {
  color: #98652b;
  background: #faefe1;
}

.detail-score-equation i {
  color: #9aa4b0;
  font-size: 8px;
  font-style: normal;
}

.score-reason-list {
  margin-top: 6px;
  display: grid;
  gap: 4px;
}

.score-reason-list > div {
  min-width: 0;
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr);
  gap: 6px;
}

.score-reason-list span {
  color: #5f71b1;
  font-size: 7px;
  font-weight: 790;
}

.score-reason-list p {
  margin: 0;
  color: #6d7989;
  font-size: 7px;
  line-height: 1.35;
}

.design-detail-decision {
  margin-top: 11px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.design-detail-decision article {
  padding: 10px 11px;
  display: grid;
  gap: 4px;
  border: 1px solid #dce8e5;
  border-radius: 10px;
  background: #f3f9f7;
}

.design-detail-decision article.tradeoff {
  border-color: #e7e0d6;
  background: #fbf8f3;
}

.design-detail-decision span {
  color: #31816e;
  font-size: 9px;
  font-weight: 800;
}

.design-detail-decision .tradeoff span {
  color: #8a704b;
}

.design-detail-decision strong {
  color: #536477;
  font-size: 10px;
  font-weight: 620;
  line-height: 1.5;
}

.score-adjustment-evidence {
  margin-top: 8px;
  padding: 9px 11px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  border: 1px solid #dfe4f1;
  border-radius: 10px;
  background: #f7f8fc;
}

.score-adjustment-result {
  padding-right: 14px;
  display: flex;
  align-items: baseline;
  gap: 5px;
  border-right: 1px solid #dfe4ec;
}

.score-adjustment-result > span {
  margin-right: 3px;
  color: #748297;
  font-size: 8px;
  font-weight: 720;
}

.score-adjustment-result strong,
.score-adjustment-result b {
  color: #34465b;
  font-size: 15px;
}

.score-adjustment-result em {
  padding: 2px 4px;
  border-radius: 4px;
  color: #237c69;
  background: #e8f5f1;
  font-size: 9px;
  font-style: normal;
  font-weight: 780;
}

.score-adjustment-result em.negative {
  color: #98652b;
  background: #faefe1;
}

.score-adjustment-result i {
  color: #9aa4b0;
  font-size: 8px;
  font-style: normal;
}

.score-adjustment-copy {
  min-width: 0;
  display: grid;
}

.score-adjustment-copy span {
  color: #5b70c8;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.05em;
}

.score-adjustment-copy strong {
  margin-top: 3px;
  color: #58677b;
  font-size: 9px;
  font-weight: 620;
  line-height: 1.45;
}

.design-detail-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.design-detail-grid > article {
  min-width: 0;
  padding: 11px;
  border: 1px solid #e2e7ea;
  border-radius: 10px;
  background: #fbfcfd;
}

.detail-section-head strong {
  margin-top: 3px;
  color: #445568;
  font-size: 12px;
}

.detail-section-head > em {
  color: #8c98a6;
  font-size: 8px;
  font-style: normal;
}

.detail-confidence .confidence-factor-grid {
  margin-top: 10px;
}

.detail-confidence .confidence-factor span,
.detail-confidence .confidence-factor strong {
  font-size: 9px;
}

.confidence-weight-note {
  margin-top: 9px;
  padding-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-top: 1px solid #e4e8eb;
}

.confidence-weight-note span {
  padding: 3px 5px;
  border-radius: 5px;
  color: #708092;
  background: #eef2f4;
  font-size: 8px;
}

.design-detail-compact-grid .detail-confidence .confidence-factor-grid {
  margin-top: 7px;
  gap: 5px 7px;
}

.design-detail-compact-grid .detail-confidence .confidence-factor span,
.design-detail-compact-grid .detail-confidence .confidence-factor strong {
  font-size: 7px;
}

.design-detail-compact-grid .detail-confidence .confidence-factor > i {
  height: 2px;
}

.design-detail-compact-grid .confidence-weight-note {
  margin-top: 6px;
  padding-top: 6px;
  gap: 3px;
}

.design-detail-compact-grid .confidence-weight-note span {
  padding: 2px 4px;
  font-size: 6px;
}

.detail-factor-list {
  margin-top: 9px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
}

.detail-factor-list > div {
  min-width: 0;
}

.detail-factor-list span {
  color: #2d806d;
  font-size: 9px;
  font-weight: 780;
}

.detail-factor-list .cons span {
  color: #986d39;
}

.detail-factor-list p {
  margin: 5px 0 0;
  color: #667488;
  font-size: 9px;
  line-height: 1.4;
}

.detail-performance .criteria-list {
  margin-top: 9px;
  gap: 7px;
}

.detail-performance .criterion-head span,
.detail-performance .criterion-head strong,
.detail-performance .criterion > small {
  font-size: 9px;
}

.compare-action {
  margin-top: 12px;
  padding: 0;
  display: block;
  overflow: hidden;
}

.selection-summary-card {
  border: 1.5px solid #bcd7d0;
  background: #f7faf9;
  box-shadow: 0 14px 34px rgba(31, 94, 78, 0.11);
}

.selection-summary-header {
  min-height: 62px;
  padding: 10px 14px;
  display: grid;
  grid-template-columns: 34px minmax(170px, 1fr) auto;
  align-items: center;
  gap: 10px;
  border-bottom: 0;
  background: transparent;
}

.selection-summary-header .section-step {
  border-color: #c8dfd9;
  color: #247c68;
  background: #fff;
}

.selection-heading {
  min-width: 0;
  display: grid;
  align-content: center;
}

.selection-heading > span,
.selection-context span {
  color: #8793a2;
  font-size: 9px;
}

.selection-heading > strong {
  margin-top: 4px;
  color: #334257;
  font-size: 14px;
}

.selection-heading > em {
  width: fit-content;
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 999px;
  color: #277b68;
  background: #eaf6f2;
  font-size: 8px;
  font-style: normal;
  font-weight: 750;
}

.selection-context {
  min-width: 0;
  padding: 0 14px 12px;
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 10px;
  background: transparent;
}

.selection-context > div {
  min-width: 0;
  padding: 8px 10px;
  display: grid;
  align-content: start;
  border-radius: 0;
}

.selection-reason-block {
  background: transparent;
}

.selection-outcome-block {
  border-left: 1px solid #dce4e1;
  background: transparent;
}

.selection-reason-block > span {
  color: #287f6b;
  font-weight: 800;
}

.selection-outcome-block > span {
  color: #5d70b5;
  font-weight: 800;
}

.selection-reasons {
  margin: 6px 0 0;
  padding: 0;
  display: grid;
  gap: 4px;
  list-style: none;
}

.selection-reasons li {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #4e6173;
  font-size: 10.5px;
  font-weight: 650;
}

.selection-reasons li::before {
  content: "✓";
  color: #279079;
  font-size: 9px;
  font-weight: 840;
}

.selection-outcome-metrics {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.selection-outcome-metrics strong {
  padding: 4px 7px;
  border: 1px solid #dce1f1;
  border-radius: 6px;
  color: #53647d;
  background: #fff;
  font-size: 9.5px;
  font-weight: 700;
}

.compare-action-buttons {
  display: grid;
  align-content: center;
  gap: 4px;
}

.compare-action-buttons button {
  min-height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 730;
  white-space: nowrap;
}

.compare-action-buttons svg {
  width: 16px;
  height: 16px;
}

.reoptimize-toggle {
  min-height: 27px !important;
  border: 0;
  color: #758295;
  background: transparent;
  font-size: 9px !important;
}

.reoptimize-toggle:hover {
  color: #267b68;
  background: transparent;
}

.selection-workflow {
  padding: 10px 14px 12px;
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  grid-column: 1/-1;
  border-top: 1px solid #e5e9ec;
  background: #f1f6f4;
}

.selection-workflow-head {
  display: grid;
}

.selection-workflow-head span {
  color: #2d826e;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.selection-workflow-head strong {
  margin-top: 3px;
  color: #536276;
  font-size: 10px;
}

.selection-workflow-head small {
  margin-top: 2px;
  color: #87958f;
  font-size: 7px;
  line-height: 1.3;
}

.selection-workflow-track {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr) 24px minmax(0, 1fr);
  align-items: center;
}

.workflow-stage {
  min-width: 0;
  min-height: 36px;
  padding: 3px 5px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #536276;
  text-align: left;
  opacity: 0.62;
}

.workflow-stage.active {
  padding: 5px 9px;
  border-radius: 8px;
  color: #267c69;
  background: #e3f2ee;
  box-shadow: inset 3px 0 #39a68e;
  opacity: 1;
}

.workflow-stage.active > div > em {
  width: fit-content;
  margin-bottom: 1px;
  color: #23816c;
  font-size: 6px;
  font-style: normal;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.workflow-stage.queued > i {
  color: #83928d;
}

.workflow-stage > i {
  width: 24px;
  flex: 0 0 auto;
  color: #277d69;
  font-size: 16px;
  font-style: normal;
  font-weight: 820;
}

.workflow-stage > div {
  min-width: 0;
  display: grid;
}

.workflow-stage strong {
  font-size: 9px;
}

.workflow-stage small {
  margin-top: 2px;
  overflow: hidden;
  color: #8a96a5;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selection-workflow-track > em {
  height: 1px;
  position: relative;
  color: transparent;
  background: #cbd8d5;
  font-size: 0;
}

.selection-workflow-track > .workflow-stage.active + em {
  background: linear-gradient(90deg, #63b9a5, #cbd8d5);
}

.selection-workflow-track > em::after {
  content: "";
  width: 5px;
  height: 5px;
  position: absolute;
  top: -2px;
  right: 0;
  border-top: 1px solid #8da79f;
  border-right: 1px solid #8da79f;
  transform: rotate(45deg);
}

.confirm-selection {
  border: 0;
  color: #fff;
  background: #202c40;
  box-shadow: 0 7px 18px rgba(31, 44, 64, 0.14);
}

.reoptimization-request {
  min-height: 56px;
  padding: 12px 14px;
  display: grid;
  grid-template-columns: 34px 1fr auto;
  align-items: center;
  gap: 9px;
  grid-column: 1/-1;
  border-top: 1px solid #e5e9ec;
}

.reoptimization-request > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.reoptimization-request span {
  color: #7c8999;
  font-size: 9px;
}

.reoptimization-request input {
  width: 100%;
  margin-top: 3px;
  border: 0;
  outline: 0;
  color: #435165;
  background: transparent;
  font-size: 12px;
}

.reoptimization-request > button {
  height: 34px;
  padding: 0 11px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  background: #273449;
  font-size: 10px;
  font-weight: 720;
}

.reoptimization-request > button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

/* Step 06 · readability pass */
.compare-experience .stage-heading > div:nth-child(2) > span {
  font-size: 11px;
}

.compare-experience .stage-heading p {
  font-size: 11px;
}

.compare-experience .recommendation-badge span,
.compare-experience .recommendation-badge small {
  font-size: 9px;
}

.compare-experience .recommendation-badge strong {
  font-size: 17px;
}

.compare-experience .comparison-summary-head span {
  font-size: 10px;
}

.compare-experience .comparison-summary-head h2 {
  font-size: 16px;
}

.compare-experience .decision-summary-main p,
.compare-experience .score-formula-compact strong {
  font-size: 10px;
}

.compare-experience .score-formula-compact em,
.compare-experience .comparison-summary-head .decision-summary-chips span {
  font-size: 9px;
}

.compare-experience .matrix-label,
.compare-experience .metric-label strong {
  font-size: 11px;
}

.compare-experience .metric-label > span,
.compare-experience .metric-label > em {
  font-size: 9px;
}

.compare-experience .matrix-design span {
  font-size: 10px;
}

.compare-experience .matrix-design strong,
.compare-experience .matrix-design em {
  font-size: 13px;
}

.compare-experience .matrix-value strong {
  font-size: 12px;
}

.compare-experience .ai-priority-row .matrix-value strong {
  font-size: 14px;
}

.compare-experience .matrix-value > span,
.compare-experience .matrix-value em {
  font-size: 9px;
}

.compare-experience .adjustment-label strong,
.compare-experience .adjustment-summary strong {
  font-size: 10px;
}

.compare-experience .adjustment-label span,
.compare-experience .adjustment-summary em {
  font-size: 8px;
}

.compare-experience .adjustment-summary span,
.compare-experience .adjustment-summary::after {
  font-size: 9px;
}

.compare-experience .candidate-detail-heading span {
  font-size: 9px;
}

.compare-experience .candidate-detail-heading h2 {
  font-size: 16px;
}

.compare-experience .candidate-detail-heading p {
  font-size: 10px;
}

.compare-experience .design-name > span,
.compare-experience .design-score-line span,
.compare-experience .design-score-line em {
  font-size: 10px;
}

.compare-experience .design-option h2 {
  font-size: 18px;
}

.compare-experience .quick-select,
.compare-experience .ai-recommendation span {
  font-size: 11px;
}

.compare-experience .design-score-line strong {
  font-size: 23px;
}

.compare-experience .design-key-metrics span,
.compare-experience .design-advantages > span {
  font-size: 10px;
}

.compare-experience .design-key-metrics strong {
  font-size: 12px;
}

.compare-experience .design-advantages strong,
.compare-experience .detail-trigger {
  font-size: 11px;
}

.compare-experience .design-detail-head span,
.compare-experience .detail-section-head span {
  font-size: 10px;
}

.compare-experience .design-detail-head h2 {
  font-size: 16px;
}

.compare-experience .design-detail-head-actions .detail-select {
  font-size: 10px;
}

.compare-experience .design-detail-compact-grid .detail-section-head strong {
  font-size: 12px;
}

.compare-experience .design-detail-compact-grid .detail-section-head > em {
  font-size: 9px;
}

.compare-experience .detail-recommendation > p {
  font-size: 10px;
  line-height: 1.5;
}

.compare-experience .detail-evidence-list span,
.compare-experience .score-reason-list span {
  font-size: 9px;
}

.compare-experience .detail-evidence-list strong {
  overflow: visible;
  font-size: 9.5px;
  line-height: 1.35;
  text-overflow: clip;
  white-space: normal;
}

.compare-experience .design-detail-compact-grid .detail-confidence .confidence-factor span,
.compare-experience .design-detail-compact-grid .detail-confidence .confidence-factor strong,
.compare-experience .design-detail-compact-grid .confidence-weight-note span {
  font-size: 8.5px;
}

.compare-experience .detail-score-equation > span,
.compare-experience .detail-score-equation em,
.compare-experience .detail-score-equation i {
  font-size: 9px;
}

.compare-experience .detail-score-equation strong,
.compare-experience .detail-score-equation b {
  font-size: 15px;
}

.compare-experience .score-reason-list {
  gap: 6px;
}

.compare-experience .score-reason-list > div {
  grid-template-columns: 84px minmax(0, 1fr);
}

.compare-experience .score-reason-list p {
  font-size: 9px;
  line-height: 1.4;
}

.compare-experience .selection-heading > span,
.compare-experience .selection-context span {
  font-size: 10px;
}

.compare-experience .selection-heading > strong {
  font-size: 16px;
}

.compare-experience .selection-heading > em,
.compare-experience .selection-reasons li,
.compare-experience .compare-action-buttons button {
  font-size: 11px;
}

.compare-experience .selection-outcome-metrics strong {
  font-size: 10.5px;
}

.compare-experience .selection-workflow-head span,
.compare-experience .workflow-stage.active > div > em {
  font-size: 8px;
}

.compare-experience .selection-workflow-head strong,
.compare-experience .workflow-stage strong {
  font-size: 11px;
}

.compare-experience .selection-workflow-head small,
.compare-experience .workflow-stage small {
  font-size: 9px;
}

.compare-experience .reoptimize-toggle,
.compare-experience .reoptimization-request span {
  font-size: 10px !important;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}
@keyframes stage-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes drawer-in {
  from {
    opacity: 0;
    transform: translateX(32px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
/* Cross-stage design QA: shared hierarchy, spacing and component semantics */
.stage-heading h1,
.input-hero.review-mode h1,
.result-hero h1 {
  color: #1e293b;
  font-size: 28px;
  line-height: 1.25;
  letter-spacing: -0.025em;
}

.stage-heading > div:nth-child(2) > span,
.combination-head span,
.ecosystem-head span,
.simulation-suite-head span,
.contract-head span,
.feedback-loop-title span,
.candidate-detail-heading > div > span,
.result-output-heading span {
  color: var(--qa-accent);
  font-size: 10px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.stage-heading p,
.ecosystem-head p,
.simulation-suite-head p,
.candidate-detail-heading p,
.result-output-heading p {
  color: var(--qa-muted);
  line-height: 1.5;
}

.conversation-composer,
.requirement-review,
.combination-explorer,
.agent-queue,
.live-agent-work,
.linked-data-ecosystem,
.agent-contract-pipeline,
.collaboration-feed,
.collaboration-story,
.simulation-suite,
.autonomous-feedback-loop,
.iteration-selector,
.iteration-inspector,
.comparison-summary,
.selection-summary-card,
.result-hero,
.result-summary-card,
.result-metrics-card,
.result-tools,
.final-approval {
  border-radius: var(--qa-panel-radius);
}

.combination-explorer,
.linked-data-ecosystem,
.agent-contract-pipeline,
.simulation-suite,
.autonomous-feedback-loop,
.agent-queue,
.live-agent-work,
.collaboration-feed,
.collaboration-story,
.iteration-selector,
.iteration-inspector,
.result-summary-card,
.result-metrics-card {
  border-color: var(--qa-line);
  box-shadow: 0 8px 24px rgba(33, 43, 57, 0.04);
}

.design-variable,
.generation-step,
.data-source-card,
.agent-contract,
.simulation-check,
.feedback-loop-node,
.decision-card,
.output-metric,
.verified-metric,
.result-tool {
  border-radius: var(--qa-card-radius);
}

.combination-explorer,
.linked-data-ecosystem,
.agent-contract-pipeline,
.simulation-suite,
.autonomous-feedback-loop,
.execution-layout,
.collaboration-layout,
.optimization-layout,
.result-layout {
  margin-top: 16px;
}

.review-command-actions > button,
.stage-next button {
  min-height: 40px;
  padding: 0 13px;
  border-radius: var(--qa-control-radius);
  font-size: 11px;
}

.quick-select {
  height: 36px;
  border-radius: var(--qa-control-radius);
}

.detail-trigger {
  min-height: 36px;
  border-radius: var(--qa-control-radius);
}

.run-agents,
.review-run,
.confirm-selection,
.final-approval-actions > button {
  color: #fff;
  background: #202c40;
}

.collab-live,
.converged-chip {
  border-color: #cfe3de;
  color: var(--qa-accent);
  background: #f1f9f7;
  font-size: 9px;
}

.converged-chip span {
  color: #708b84;
  font-size: 8px;
}

.converged-chip strong {
  color: var(--qa-accent);
  font-size: 11px;
}

.stage-next {
  margin-top: 16px;
  padding: 12px 0 0;
  border-top: 1px solid #e5e9ec;
  color: var(--qa-muted);
  font-size: 10px;
}

.stage-next button {
  border-color: #d6dee3;
  color: #41536a;
  background: #fff;
}

.design-option.selected,
.quick-select.selected,
.detail-trigger[aria-expanded=true] {
  border-color: #3eae95;
}

.design-option.recommended.selected::before {
  background: linear-gradient(90deg, #278b75, #42b99f);
}

/* ReviewOps tgogfniaxkwdrozgfszfpethctegqyho: compact workflow context header. */
.agent-platform:not(.landing-mode) {
  --workflow-grid-max: 1560px;
  --workflow-grid-inset: 16px;
  --workflow-grid-gap: 16px;
  --workflow-space-1: 8px;
  --workflow-space-2: 16px;
  --workflow-space-3: 24px;
  --workflow-type-label: 10px;
  --workflow-type-body: 12px;
  --workflow-type-card: 14px;
  --workflow-type-section: 16px;
  --workflow-type-page: 24px;
}

.agent-platform:not(.landing-mode) > .platform-header {
  height: 56px;
  padding-right: 24px;
  padding-left: 24px;
}

.agent-platform:not(.landing-mode) > .platform-header .platform-identity strong {
  font-size: var(--workflow-type-section);
}

.agent-platform:not(.landing-mode) > .platform-header .platform-identity small {
  font-size: var(--workflow-type-label);
}

.agent-platform:not(.landing-mode) > .platform-header .project-context {
  font-size: var(--workflow-type-body);
}

.agent-platform:not(.landing-mode) > .platform-header .project-context em {
  font-size: 9px;
}

.agent-platform:not(.landing-mode) > .platform-header .run-status {
  height: 36px;
  font-size: var(--workflow-type-label);
}

.agent-platform:not(.landing-mode) > .platform-header .header-actions button {
  height: 40px;
  padding-right: 14px;
  padding-left: 14px;
  font-size: 11px;
}

.agent-platform:not(.landing-mode) > .platform-header .header-actions .icon-action {
  width: 40px;
  padding: 0;
}

.workflow-page-intro {
  width: min(100% - var(--workflow-grid-inset) * 2, var(--workflow-grid-max));
  max-width: none;
  min-height: 0;
  margin: var(--workflow-space-1) auto;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: var(--workflow-space-2);
}

.workflow-page-number {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border: 1px solid #cee2dd;
  border-radius: 10px;
  color: #2b806d;
  background: #f0f8f6;
  font-size: var(--workflow-type-label);
  font-weight: 820;
}

.workflow-page-copy {
  min-width: 0;
  display: grid;
}

.workflow-page-copy > span {
  color: #368372;
  font-size: var(--workflow-type-label);
  font-weight: 820;
  line-height: 1.5;
  letter-spacing: 0.11em;
}

.workflow-page-copy h1 {
  margin: 0;
  color: #1e293b;
  font-size: var(--workflow-type-page);
  font-weight: 780;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.workflow-page-copy p {
  margin: 4px 0 0;
  color: #738094;
  font-size: var(--workflow-type-body);
  line-height: 1.5;
}

.agent-platform:not(.landing-mode) > .run-context-bar {
  width: min(100% - var(--workflow-grid-inset) * 2, var(--workflow-grid-max));
  max-width: none;
  height: 42px;
  min-height: 42px;
  margin: 0 auto;
  padding: 4px var(--workflow-space-1);
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: center;
  gap: 8px;
  border-radius: 12px;
}

.run-context-project,
.agent-platform:not(.landing-mode) .run-context-id {
  min-width: 0;
  padding: 0 var(--workflow-space-1);
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: var(--workflow-space-1);
  justify-content: flex-start;
}

.run-context-project {
  grid-column: span 3;
  border-right: 1px solid #e6ebed;
}

.run-context-project > span,
.agent-platform:not(.landing-mode) .run-context-id > span {
  color: #84909f;
  font-size: 9px;
  font-weight: 820;
  line-height: 1.2;
  letter-spacing: 0.11em;
}

.run-context-project > strong {
  margin-top: 0;
  overflow: hidden;
  color: #26384c;
  font-size: var(--workflow-type-body);
  font-weight: 740;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-platform:not(.landing-mode) .run-context-id {
  grid-column: span 3;
  padding-right: 12px;
  border-right: 1px solid #e6ebed;
}

.agent-platform:not(.landing-mode) .run-context-id > span {
  flex: 0 0 auto;
}

.agent-platform:not(.landing-mode) .run-context-id > strong {
  margin-top: 0;
  align-self: center;
  overflow: hidden;
  font-size: var(--workflow-type-body);
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-platform:not(.landing-mode) .run-context-id > em {
  margin: 0 0 0 auto;
  align-self: center;
  line-height: 1.2;
  white-space: nowrap;
  font-size: 9px;
}

.agent-platform:not(.landing-mode) .run-handoff-card {
  padding: 0 var(--workflow-space-1);
  display: flex;
  grid-column: span 6;
  align-items: center;
  gap: var(--workflow-space-2);
  border: 0;
  border-radius: 8px;
}

.agent-platform:not(.landing-mode) .run-handoff-card .handoff-heading {
  justify-content: flex-start;
  gap: var(--workflow-space-1);
  line-height: 1.2;
  white-space: nowrap;
}

.agent-platform:not(.landing-mode) .run-handoff-card .handoff-heading span,
.agent-platform:not(.landing-mode) .run-handoff-card .handoff-heading em {
  font-size: 9px;
}

.agent-platform:not(.landing-mode) .handoff-route {
  margin-top: 0;
  overflow: hidden;
  font-size: 10px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-platform:not(.landing-mode) > .journey-navigation {
  min-height: 48px;
  margin-top: var(--workflow-space-1);
  padding: var(--workflow-space-1) 0;
  top: 56px;
}

.agent-platform:not(.landing-mode) .journey-track {
  width: min(100% - var(--workflow-grid-inset) * 2, var(--workflow-grid-max));
  max-width: none;
}

.agent-platform:not(.landing-mode) .journey-step {
  min-width: 120px;
  padding: 3px 4px;
  gap: var(--workflow-space-1);
}

.agent-platform:not(.landing-mode) .journey-step > span {
  width: 24px;
  height: 24px;
}

.agent-platform:not(.landing-mode) .journey-step > span svg {
  width: 14px;
  height: 14px;
}

.agent-platform:not(.landing-mode) .journey-step > span em {
  font-size: 9px;
}

.agent-platform:not(.landing-mode) .journey-step strong {
  font-size: 11px;
  white-space: nowrap;
}

.agent-platform:not(.landing-mode) .journey-step small {
  display: none;
}

.agent-platform:not(.landing-mode) .journey-line.done {
  height: 2px;
  background: #72c8b5;
}

.agent-platform:not(.landing-mode) .journey-step.active {
  position: relative;
  padding-right: 8px;
  padding-left: 8px;
  border: 1px solid #8fcfbe;
  border-radius: 999px;
  color: #1f6f61;
  background: #eaf7f3;
  box-shadow: 0 3px 9px rgba(47, 139, 118, 0.1);
  opacity: 1;
}

.agent-platform:not(.landing-mode) .journey-step.active::after {
  content: "";
  height: 3px;
  position: absolute;
  right: 8px;
  bottom: -8px;
  left: 8px;
  border-radius: 999px;
  background: #2f8b76;
}

.agent-platform:not(.landing-mode) .journey-step.active > span {
  border: 2px solid #1f6f61;
  color: #fff;
  background: #1f6f61;
  box-shadow: 0 0 0 3px rgba(47, 139, 118, 0.13);
}

.agent-platform:not(.landing-mode) .journey-step.active strong {
  color: #174d43;
  font-weight: 820;
}

.agent-platform:not(.landing-mode) > .journey-main {
  width: min(100% - var(--workflow-grid-inset) * 2, var(--workflow-grid-max));
  max-width: none;
  padding: var(--workflow-space-3) 0 80px;
}

.input-experience.review-mode,
.input-experience.review-mode .requirement-approval {
  max-width: none;
}

.input-hero.review-mode .review-attention {
  margin-top: 0;
  padding: var(--workflow-space-2);
  gap: var(--workflow-space-2);
}

.input-hero.review-mode .review-attention-icon {
  width: 40px;
  height: 40px;
  font-size: var(--workflow-type-section);
}

.input-hero.review-mode .review-attention-copy {
  gap: 4px;
}

.input-hero.review-mode .review-attention-copy strong {
  font-size: var(--workflow-type-card);
}

.input-hero.review-mode .review-attention-copy p {
  font-size: var(--workflow-type-body);
}

.input-hero.review-mode .review-attention > button {
  min-height: 40px;
  padding: 0 var(--workflow-space-2);
  font-size: var(--workflow-type-body);
}

.input-hero.review-mode .review-attention + .review-overview-group {
  margin-top: var(--workflow-space-2);
}

.review-overview-group {
  margin-top: 0;
  padding: var(--workflow-space-2);
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: stretch;
  gap: var(--workflow-space-2);
  border: 1px solid #cfe2dd;
  border-radius: 14px;
  background: linear-gradient(112deg, #f1f9f7, rgba(255, 255, 255, 0.96) 72%);
  box-shadow: 0 7px 18px rgba(42, 91, 79, 0.045);
}

.review-overview-group .review-lead {
  margin-top: 0;
  padding: var(--workflow-space-2);
  grid-column: span 5;
  border: 0;
  border-radius: 10px;
  background: transparent;
  box-shadow: none;
}

.review-overview-group .review-summary {
  margin-top: 0;
  padding: 0 0 0 var(--workflow-space-2);
  grid-column: span 7;
  align-items: stretch;
  gap: var(--workflow-space-1);
  border-top: 0;
  border-left: 1px solid #dce9e5;
}

.review-overview-group .review-stat {
  height: 100%;
  min-height: 80px;
  padding: var(--workflow-space-2);
  border-radius: 12px;
}

.review-overview-group .review-stat span {
  font-size: var(--workflow-type-label);
  white-space: nowrap;
}

.review-overview-group .review-stat strong {
  font-size: 28px;
}

.review-overview-group .review-lead-mark {
  width: 40px;
  height: 40px;
}

.review-overview-group .review-lead-copy > span,
.review-overview-group .review-lead-confidence span {
  font-size: var(--workflow-type-label);
}

.review-overview-group .review-lead-copy > strong {
  margin-top: 4px;
  font-size: 18px;
}

.input-hero.review-mode .review-overview-group .review-lead-copy p {
  margin-top: var(--workflow-space-1);
  font-size: var(--workflow-type-body);
  line-height: 1.5;
}

.review-overview-group .review-lead-confidence {
  min-width: 144px;
  padding: var(--workflow-space-1) var(--workflow-space-2);
}

.review-overview-group .review-lead-confidence strong {
  margin-top: 4px;
  font-size: 24px;
}

.input-experience.review-mode .requirement-approval {
  margin-top: var(--workflow-space-2);
}

.input-experience.review-mode .review-commandbar {
  min-height: 64px;
  padding: var(--workflow-space-1) var(--workflow-space-2);
  gap: var(--workflow-space-2);
}

.input-experience.review-mode .project-information {
  padding: var(--workflow-space-2);
  gap: var(--workflow-space-2);
}

.input-experience.review-mode .requirement-groups {
  padding: var(--workflow-space-2);
  gap: var(--workflow-space-2);
}

.input-experience.review-mode .requirement-group-head {
  min-height: 64px;
  padding: var(--workflow-space-2);
}

.input-experience.review-mode .requirement-grid {
  padding: 0 var(--workflow-space-2) var(--workflow-space-2);
  gap: var(--workflow-space-1);
}

.input-experience.review-mode .requirement-item-summary {
  min-height: 80px;
  padding: 12px var(--workflow-space-2);
  gap: 12px;
}

.input-experience.review-mode .review-help-trigger {
  min-height: 32px;
  padding: 0 12px;
  font-size: 11px;
}

.input-experience.review-mode .review-command-state {
  gap: var(--workflow-space-1);
}

.input-experience.review-mode .review-command-state > span {
  font-size: var(--workflow-type-body);
}

.input-experience.review-mode .review-command-state > strong {
  font-size: var(--workflow-type-section);
}

.input-experience.review-mode .review-command-state > em {
  padding: 5px var(--workflow-space-1);
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .review-command-guide {
  gap: var(--workflow-space-1);
}

.input-experience.review-mode .review-command-guide > span {
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .review-command-guide > em {
  padding: 4px var(--workflow-space-1);
  font-size: 9px;
}

.input-experience.review-mode .review-command-actions {
  gap: var(--workflow-space-1);
}

.input-experience.review-mode .review-command-actions > button {
  min-height: 40px;
  padding: 0 var(--workflow-space-2);
  font-size: var(--workflow-type-body);
}

.input-experience.review-mode .project-information-head {
  grid-template-columns: 40px minmax(0, 1fr) auto;
  gap: 12px;
}

.input-experience.review-mode .project-information-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .project-information-head span,
.input-experience.review-mode .project-information-body span {
  font-size: 9px;
}

.input-experience.review-mode .project-information-head strong {
  margin-top: 4px;
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .project-information-head > em {
  padding: 6px 10px;
  font-size: 9px;
}

.input-experience.review-mode .project-information-body {
  gap: var(--workflow-space-2);
}

.input-experience.review-mode .project-information-body > label,
.input-experience.review-mode .project-information-source {
  min-height: 64px;
  padding: var(--workflow-space-1) var(--workflow-space-2);
  border-radius: 10px;
}

.input-experience.review-mode .project-information-body label input {
  height: 28px;
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .project-information-source p {
  margin-top: 4px;
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .group-identity {
  gap: 12px;
}

.input-experience.review-mode .group-identity > i {
  width: 32px;
  height: 32px;
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .group-identity strong {
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .group-identity span {
  margin-top: 4px;
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .group-head-actions {
  gap: 12px;
}

.input-experience.review-mode .group-count em {
  padding: 4px var(--workflow-space-1);
  font-size: 9px;
}

.input-experience.review-mode .group-count strong {
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .group-count span {
  font-size: 9px;
}

.input-experience.review-mode .group-chevron {
  width: 28px;
  height: 28px;
}

.input-experience.review-mode .item-summary-copy span,
.input-experience.review-mode .item-summary-value span,
.input-experience.review-mode .item-summary-kind > span,
.input-experience.review-mode .item-summary-confidence > span,
.input-experience.review-mode .item-summary-review > span {
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .item-summary-copy strong,
.input-experience.review-mode .item-summary-value strong {
  margin-top: var(--workflow-space-1);
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .item-summary-value {
  padding-left: 12px;
}

.input-experience.review-mode .item-summary-value strong {
  font-size: 15px;
}

.input-experience.review-mode .item-summary-kind > em,
.input-experience.review-mode .item-summary-review > em {
  margin-top: 6px;
  padding: 4px var(--workflow-space-1);
  font-size: var(--workflow-type-label);
}

.input-experience.review-mode .item-summary-confidence strong {
  margin-top: 6px;
  font-size: var(--workflow-type-section);
}

.input-experience.review-mode .item-summary-toggle {
  gap: var(--workflow-space-1);
}

.input-experience.review-mode .item-summary-toggle span {
  font-size: 11px;
}

.input-experience.review-mode .item-summary-toggle i {
  width: 28px;
  height: 28px;
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .requirement-item-detail {
  padding: var(--workflow-space-2);
}

.input-experience.review-mode .requirement-interpretation {
  padding: var(--workflow-space-2);
  gap: var(--workflow-space-1);
}

.input-experience.review-mode .interpretation-heading span,
.input-experience.review-mode .interpretation-label > span {
  font-size: 11px;
}

.input-experience.review-mode .interpretation-heading strong {
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .interpretation-source,
.input-experience.review-mode .interpretation-result {
  min-height: 96px;
  padding: 12px var(--workflow-space-2);
}

.input-experience.review-mode .interpretation-source > p,
.input-experience.review-mode .interpretation-result > p {
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .approval-action {
  padding: var(--workflow-space-2);
  gap: var(--workflow-space-2);
}

.input-experience.review-mode .approval-action > div strong {
  font-size: var(--workflow-type-card);
}

.input-experience.review-mode .approval-action > div span {
  margin-top: 4px;
  font-size: 11px;
}

.input-experience.review-mode .approval-action > button {
  min-height: 40px;
  padding: 0 var(--workflow-space-2);
  font-size: var(--workflow-type-body);
}

@keyframes modal-in {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 12px)) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@media (max-width: 1180px) {
  :host {
    min-width: 0;
  }
  .journey-step {
    min-width: 104px;
  }
  .journey-step small {
    display: none;
  }
  .run-context-bar {
    margin-right: auto;
    margin-left: auto;
  }
  .workflow-page-intro {
    margin-right: auto;
    margin-left: auto;
  }
  .agent-platform:not(.landing-mode) > .run-context-bar {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .review-overview-group {
    grid-template-columns: 1fr;
  }
  .review-overview-group .review-lead,
  .review-overview-group .review-summary {
    grid-column: 1;
  }
  .review-overview-group .review-summary {
    padding: var(--workflow-space-2) 0 0;
    border-top: 1px solid #dce9e5;
    border-left: 0;
  }
  .requirement-guide {
    grid-template-columns: 38px minmax(220px, 0.8fr) minmax(400px, 1.4fr);
  }
  .requirement-grid {
    grid-template-columns: 1fr;
  }
  .agent-constellation {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  .agent-constellation::before,
  .constellation-core {
    display: none;
  }
  .constellation-agent,
  .constellation-agent:nth-of-type(n) {
    width: 100%;
    grid-column: auto;
    grid-row: auto;
  }
  .collaboration-layout {
    grid-template-columns: 1fr 310px;
  }
  .data-source-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .variable-equation {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .variable-equation > i {
    display: none;
  }
  .combination-result {
    grid-column: 1/-1;
  }
}
@media (max-width: 860px) {
  .platform-header {
    padding: 0 16px;
    grid-template-columns: 1fr auto;
  }
  .mobile-menu {
    display: grid !important;
    width: 32px;
    height: 32px;
    place-items: center;
    border: 1px solid #dde3e8;
    border-radius: 9px;
    background: #fff;
  }
  .mobile-menu svg {
    width: 17px;
  }
  .project-context {
    display: none;
  }
  .journey-navigation {
    overflow-x: auto;
  }
  .journey-track {
    min-width: 780px;
  }
  .journey-main {
    padding-right: 16px;
    padding-left: 16px;
  }
  .run-context-bar {
    margin-right: 16px;
    margin-left: 16px;
  }
  .workflow-page-intro {
    min-width: 780px;
    margin-right: 16px;
    margin-left: 16px;
  }
  .agent-platform:not(.landing-mode) > .run-context-bar {
    min-width: 780px;
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .review-summary {
    grid-template-columns: 1fr 1fr;
  }
  .review-lead {
    grid-template-columns: 38px 1fr;
  }
  .review-lead-confidence {
    grid-column: 2;
    min-width: 0;
    padding: 8px 0 0;
    grid-template-columns: 1fr auto;
    align-items: center;
    justify-items: start;
    border-top: 1px solid #dce9e5;
    border-left: 0;
  }
  .review-lead-confidence strong {
    margin: 0;
    justify-self: end;
  }
  .review-stat.review-needed {
    grid-column: 1/-1;
  }
  .review-commandbar {
    align-items: stretch;
    flex-direction: column;
  }
  .review-command-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .review-command-actions > button {
    justify-content: center;
  }
  .review-command-actions .review-run {
    grid-column: 1/-1;
  }
  .requirement-help-modal {
    width: calc(100vw - 24px);
    max-height: calc(100vh - 24px);
  }
  .requirement-help-list {
    grid-template-columns: 1fr;
  }
  .review-attention {
    grid-template-columns: 34px minmax(0, 1fr);
    align-items: start;
  }
  .review-attention > button {
    width: fit-content;
    grid-column: 2;
  }
  .request-brief,
  .requirement-guide {
    grid-template-columns: 38px 1fr;
  }
  .project-information-body {
    grid-template-columns: 1fr;
  }
  .requirement-routing-meta {
    grid-template-columns: 1fr;
  }
  .requirement-routing-purposes {
    padding-top: 6px;
    padding-left: 0;
    border-top: 1px solid #dce9e5;
    border-left: 0;
  }
  .brief-source,
  .classification-guide {
    grid-column: 2;
  }
  .classification-guide {
    grid-template-columns: 1fr 1fr;
  }
  .requirement-summary,
  .requirement-grid {
    grid-template-columns: 1fr;
  }
  .requirement-item-summary {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr) 34px;
    align-items: start;
  }
  .item-summary-copy {
    grid-column: 1;
    grid-row: 1;
  }
  .item-summary-value {
    grid-column: 2;
    grid-row: 1;
  }
  .item-summary-kind {
    grid-column: 1;
    grid-row: 2;
  }
  .item-summary-confidence {
    grid-column: 2;
    grid-row: 2;
  }
  .item-summary-review {
    padding-top: 7px;
    display: flex;
    grid-column: 1/3;
    grid-row: 3;
    align-items: center;
    gap: 8px;
    border-top: 1px solid #e7ebed;
  }
  .item-summary-review > em {
    margin-top: 0;
  }
  .item-summary-toggle {
    min-width: 34px;
    grid-column: 3;
    grid-row: 1/4;
    align-self: center;
  }
  .item-summary-toggle span {
    display: none;
  }
  .requirement-item-detail {
    padding-left: 13px;
  }
  .requirement-edit-grid {
    grid-template-columns: 1fr;
  }
  .interpretation-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .interpretation-comparison {
    grid-template-columns: 1fr;
  }
  .interpretation-arrow {
    grid-template-columns: auto auto;
    place-content: center;
  }
  .interpretation-arrow > span {
    transform: rotate(90deg);
  }
  .requirement-summary > p {
    grid-column: 1/-1;
  }
  .evaluation-funnel {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .evaluation-funnel > i {
    min-height: 12px;
    transform: rotate(90deg);
  }
  .confidence-method {
    display: grid;
  }
  .confidence-weights {
    justify-content: flex-start;
  }
  .execution-layout,
  .collaboration-layout,
  .optimization-layout,
  .result-layout {
    grid-template-columns: 1fr;
  }
  .result-conclusion-strip {
    grid-template-columns: 1fr 1fr;
  }
  .result-output-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .agent-queue {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .queue-head {
    grid-column: 1/-1;
  }
  .collaboration-story,
  .collaboration-feed {
    height: auto;
  }
  .design-comparison {
    grid-template-columns: 1fr;
  }
  .design-option {
    min-height: 0;
  }
  .comparison-summary {
    overflow-x: auto;
  }
  .comparison-summary-head {
    width: 760px;
  }
  .design-detail-decision,
  .design-detail-grid,
  .design-detail-compact-grid,
  .selection-context {
    grid-template-columns: 1fr;
  }
  .selection-summary-header {
    grid-template-columns: 34px 1fr;
  }
  .compare-action-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column: 1/-1;
  }
  .selection-context > div + div {
    margin-top: 0;
    padding: 8px 10px;
    border-top: 1px solid #dce4e1;
    border-left: 0;
  }
  .score-adjustment-evidence,
  .selection-workflow {
    grid-template-columns: 1fr;
  }
  .candidate-detail-heading {
    grid-template-columns: 34px 1fr;
  }
  .candidate-detail-heading p {
    grid-column: 2;
    text-align: left;
  }
  .selection-workflow-track {
    grid-template-columns: 1fr;
  }
  .selection-workflow-track > em {
    width: 1px;
    height: 14px;
    justify-self: center;
  }
  .selection-workflow-track > em::after {
    top: auto;
    right: -2px;
    bottom: 0;
    transform: rotate(135deg);
  }
  .score-adjustment-result {
    padding-right: 0;
    padding-bottom: 8px;
    border-right: 0;
    border-bottom: 1px solid #dfe4ec;
  }
  .reoptimization-request {
    grid-column: 1;
  }
  .combination-head,
  .ecosystem-head,
  .simulation-suite-head {
    display: grid;
  }
  .ecosystem-head p,
  .simulation-suite-head p {
    margin-top: 8px;
    text-align: left;
  }
  .variable-equation,
  .data-source-grid,
  .contract-grid,
  .simulation-check-grid {
    grid-template-columns: 1fr 1fr;
  }
  .alternative-generation-flow,
  .feedback-loop-flow {
    grid-template-columns: 1fr;
  }
  .alternative-generation-flow > svg,
  .feedback-loop-flow > i {
    transform: rotate(90deg);
    justify-self: center;
  }
  .result-tools {
    grid-template-columns: 1fr;
  }
  .cad-result-drawer,
  .simulation-result-drawer {
    width: 100vw;
  }
  .simulation-result-grid {
    grid-template-columns: 1fr;
  }
  .simulation-section-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }
  .simulation-section-head > p {
    max-width: none;
    text-align: left;
  }
  .simulation-process-track,
  .simulation-recovery-flow {
    grid-template-columns: 1fr;
  }
  .simulation-process-track::before {
    display: none;
  }
  .simulation-recovery-flow > i {
    transform: rotate(90deg);
    justify-self: center;
  }
  .simulation-recovery-story {
    flex-wrap: wrap;
  }
  .simulation-result-footer {
    grid-template-columns: 1fr;
  }
  .simulation-result-footer-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .simulation-footer-actions {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }
  .simulation-footer-actions > button,
  .simulation-footer-actions > a {
    justify-content: center;
  }
  .simulation-result-use-flow {
    grid-template-columns: 1fr;
  }
  .simulation-result-use-flow > em {
    transform: rotate(90deg);
    justify-self: center;
  }
}
/* Cascade guard for the journey structures introduced after legacy density passes. */
.landing-section-heading {
  max-width: none;
  display: flex;
  align-items: end;
  justify-content: space-between;
}

.final-approval {
  display: grid;
  align-items: stretch;
  justify-content: initial;
}

.final-approval > .final-approval-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.final-approval-actions {
  justify-content: flex-end;
}

@media (max-width: 860px) {
  .landing-section-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .final-approval > .final-approval-heading {
    align-items: flex-start;
    flex-direction: column;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public runId: string = "NX4-PTG-2404";
    public activeProjectTitle: string = "NX4 Tailgate Actuator";
    public newRunMode: boolean = false;
    public readonly workspaceProjects: any = {
        "NX4-PTG-2404": "NX4 Tailgate Actuator",
        "EV9-FRK-1182": "EV9 Frunk Actuator",
        "SD-DRV-0831": "Sliding Door Drive",
        "GV7-SPL-0719": "GV70 Spoiler Lift"
    };
    public readonly workspaceProjectIds: any = {
        "NX4-PTG-2404": "NX4",
        "EV9-FRK-1182": "EV9",
        "SD-DRV-0831": "SD",
        "GV7-SPL-0719": "GV7"
    };
    public readonly runStorageKey: string = "mobility-ai-demo-run";
    public readonly activeRunStorageKey: string = "mobility-ai-active-run";
    public requestText: string = "";
    public composerFocusMode: boolean = false;
    public workflowStage: string = "empty";
    public selectedView: string = "agent";
    public selectedAlternative: number = 0;
    public detailAlternative: number = -1;
    public selectedIteration: number = 2;
    public analysisState: string = "idle";
    public analysisProgress: number = 0;
    public activePhase: number = -1;
    public assistantText: string = "";
    public showAssistant: boolean = false;
    public showCompareDrawer: boolean = false;
    public detailDrawer: string = "";
    public evidenceDeepLink: string = "";
    public expandedRequirementGroups: { [kind: string]: boolean } = {
        constraint: true,
        objective: true,
        input: true,
        reference: true
    };
    public requirementsConfirmed: boolean = false;
    public autoRedesign: boolean = true;
    public finalApproved: boolean = false;
    public simulationRunning: boolean = false;
    public journeyStep: number = 1;
    public readonly requirementReviewThreshold: number = 82;

    public journeyStages: any[] = [
        { number: 1, label: "자연어 입력", caption: "목표·자료 입력" },
        { number: 2, label: "요구사항 확정", caption: "분류·사용자 확인" },
        { number: 3, label: "설계·부품 생성", caption: "변수·부품 조합 탐색" },
        { number: 4, label: "Agent 작업 근거", caption: "입력·판단·Handoff" },
        { number: 5, label: "CAE·재설계", caption: "FAIL·수정·PASS" },
        { number: 6, label: "최적안 추천", caption: "최종 3개 평가" },
        { number: 7, label: "승인·산출물", caption: "Evidence·승인·보고서" }
    ];

    public serviceJourney: any[] = [
        { key: "input", number: "01", label: "자연어 입력", caption: "목표·제약·자료", owner: "사용자 → 요구사항 Agent", output: "설계 요청", workspaceStep: 1 },
        { key: "requirements", number: "02", label: "요구사항 확정", caption: "해석·분류·확인", owner: "요구사항 Agent + 사용자", output: "Design Brief", workspaceStep: 2 },
        { key: "design", number: "03", label: "설계·부품 생성", caption: "형상·부품·조합", owner: "기구학·부품선정·최적화 Agent", output: "설계 후보", workspaceStep: 3 },
        { key: "cae", number: "04", label: "CAE·자동 재설계", caption: "FAIL → 수정 → PASS", owner: "해석/검증 ↔ 최적화 Agent", output: "Validation Pack", workspaceStep: 5 },
        { key: "recommendation", number: "05", label: "최적안 추천", caption: "성능·원가·안전", owner: "평가/선정 Agent", output: "추천안 3개", workspaceStep: 6 },
        { key: "evidence", number: "06", label: "Evidence 검토", caption: "근거·버전·계보", owner: "사용자 검토", output: "Evidence Pack", platformSection: "evidence" },
        { key: "approval", number: "07", label: "최종 승인", caption: "Human Gate", owner: "승인 권한자", output: "Decision Record", workspaceStep: 7 },
        { key: "report", number: "08", label: "보고서·전달", caption: "검증·승인·BOM", owner: "Report Output", output: "Final Report", platformSection: "reports" }
    ];

    public extractedRequirements: any[] = [];
    public requirementGroups: any[] = [];

    public designVariables: any[] = [
        { label: "모터", count: 12, detail: "출력·토크·온도 등급", symbol: "M" },
        { label: "감속기", count: 5, detail: "감속비·효율·백래시", symbol: "G" },
        { label: "스핀들", count: 4, detail: "직경·Lead·행정", symbol: "S" },
        { label: "브라켓", count: 4, detail: "형상·소재·두께", symbol: "B" },
        { label: "장착 위치", count: 13, detail: "Point A/B 좌표 후보", symbol: "P" }
    ];

    public alternativeFlow: any[] = [
        { label: "변수 조합 탐색", value: "12,480", note: "12×5×4×4×13" },
        { label: "유효 조합", value: "614", note: "필수 조건 필터" },
        { label: "설계 대안 생성", value: "128", note: "CAD 구성안 생성" },
        { label: "CAE 시뮬레이션", value: "128", note: "4개 해석 병렬 실행" },
        { label: "PASS 후보", value: "27", note: "모든 조건 충족" },
        { label: "최종 추천", value: "3", note: "균형·원가·성능" }
    ];

    public linkedDataSources: any[] = [
        { name: "CAD", detail: "형상·좌표·질량 특성", agents: "요구사항 · 기구학 · 검증", symbol: "3D" },
        { name: "부품 DB", detail: "모터·감속기·스핀들", agents: "부품선정 · 최적화", symbol: "DB" },
        { name: "소재 DB", detail: "강도·피로·열 특성", agents: "최적화 · 해석/검증", symbol: "MAT" },
        { name: "CAE 데이터", detail: "구조·간섭·피로·열", agents: "해석/검증 · 최적화", symbol: "CAE" },
        { name: "시험/검증", detail: "실차 하중·수명 결과", agents: "해석/검증 · 평가/선정", symbol: "TEST" },
        { name: "전문가 지식", detail: "설계 규칙·실패 패턴", agents: "전 Agent 공유", symbol: "K" }
    ];

    public agentContracts: any[] = [
        {
            name: "요구사항 Agent",
            input: "자연어 · CAD · PDF · 이미지 · 카탈로그",
            decision: "의미·값·단위·출처 위치·모호성을 분류",
            output: "프로젝트 정보 · 필수 조건 · 최적화 목표 · 설계 파라미터 · 참고 자료",
            handoff: "Structured Design Brief v3",
            sources: "CAD · 전문가 지식"
        },
        {
            name: "기구학 Agent",
            input: "확정 조건 · CAD 좌표계",
            decision: "회전축·무게중심·운동 궤적 계산",
            output: "요구 추력 1,420 N · 장착 영역 18개",
            handoff: "Kinematic Model + Mount Zone",
            sources: "CAD · 시험/검증"
        },
        {
            name: "부품선정 Agent",
            input: "추력·온도·패키지 한계",
            decision: "호환성과 정격 여유 기준으로 필터링",
            output: "호환 부품 83개 · 조합 규칙",
            handoff: "Compatible Component Set",
            sources: "부품 DB · 소재 DB"
        },
        {
            name: "최적화 Agent",
            input: "부품 후보 · 장착 영역 · 목적함수",
            decision: "5개 변수의 12,480개 조합 탐색",
            output: "128개 설계 대안 · Pareto 순위",
            handoff: "Simulation Batch #128",
            sources: "부품 DB · 전문가 지식"
        },
        {
            name: "해석/검증 Agent",
            input: "128개 CAD 구성안 · 소재 물성",
            decision: "구조·간섭·피로·열 해석과 규칙 검증",
            output: "FAIL 원인 · PASS 후보 27개",
            handoff: "Validation Evidence Pack",
            sources: "CAE · 소재 DB · 시험 데이터"
        },
        {
            name: "평가/선정 Agent",
            input: "PASS 후보 · 비용 · 검증 근거",
            decision: "성능·원가·안전성·신뢰도 종합 평가",
            output: "균형형·원가형·성능형 3개",
            handoff: "사용자 설계안 선택 요청",
            sources: "시험/검증 · 전문가 지식"
        }
    ];

    public simulationChecks: any[] = [
        { name: "구조해석", tool: "Static Load", fail: "186 MPa · 안전율 1.41", pass: "142 MPa · 안전율 1.82", status: "PASS", symbol: "σ" },
        { name: "간섭 해석", tool: "Motion Clearance", fail: "Gate inner -2.1 mm", pass: "최소 간극 8.2 mm", status: "PASS", symbol: "↔" },
        { name: "피로 해석", tool: "Fatigue Life", fail: "92k cycles", pass: "125k cycles", status: "PASS", symbol: "∞" },
        { name: "열해석", tool: "Thermal Derating", fail: "-30°C 토크 여유 부족", pass: "-30~80°C 정격 충족", status: "PASS", symbol: "T" }
    ];

    public uploadedFiles: any[] = [];

    public agents: any[] = [
        { name: "요구사항 Agent", short: "요구사항", desc: "의미·근거 구조화", status: "waiting" },
        { name: "기구학 Agent", short: "기구학", desc: "축·궤적 모델링", status: "waiting" },
        { name: "부품선정 Agent", short: "부품선정", desc: "후보 부품 탐색", status: "waiting" },
        { name: "최적화 Agent", short: "최적화", desc: "조합·좌표 생성", status: "waiting" },
        { name: "해석/검증 Agent", short: "해석/검증", desc: "성능·간섭 검증", status: "waiting" },
        { name: "평가/선정 Agent", short: "평가/선정", desc: "근거 기반 순위화", status: "waiting" }
    ];

    public landingProcesses: any[] = [
        { symbol: "R", tone: "mint", name: "요구사항 Agent", description: "목표·제약·근거를 설계 조건으로 구조화", label: "Design Brief" },
        { symbol: "K", tone: "blue", name: "기구학 Agent", description: "축·궤적·장착 가능 영역 계산", label: "Kinematic Model" },
        { symbol: "P", tone: "sky", name: "부품선정 Agent", description: "호환 부품과 조합 규칙 탐색", label: "Component Set" },
        { symbol: "O", tone: "orange", name: "최적화 Agent", description: "설계 조합 생성과 FAIL 원인 반영", label: "Design Candidates" },
        { symbol: "V", tone: "violet", name: "해석/검증 Agent", description: "CAE 검증과 자동 재설계 요청", label: "Validation Pack" },
        { symbol: "E", tone: "green", name: "평가/선정 Agent", description: "Trade-off 평가와 최종안 추천", label: "Recommendation" }
    ];

    public landingMetrics: any[] = [
        { symbol: "01", tone: "mint", label: "요구사항 산출물", value: "Design Brief", note: "원문·해석·확정값 연결" },
        { symbol: "02", tone: "blue", label: "설계 산출물", value: "Design Set", note: "부품·형상·후보 비교" },
        { symbol: "03", tone: "violet", label: "검증 산출물", value: "Evidence Pack", note: "CAE 반복·판정 근거" },
        { symbol: "04", tone: "green", label: "최종 산출물", value: "Final Report", note: "승인·BOM·감사 기록" }
    ];

    public currentAgent: any = {
        name: "Agent Orchestrator",
        task: "자연어 요구사항이 입력되면 적합한 Agent 실행 계획을 구성합니다.",
        progress: 0,
        confidence: 0,
        started: "—",
        run: "입력 대기",
        status: "waiting"
    };

    public samplePrompts: any[] = [
        {
            label: "테일게이트 액추에이터",
            text: "NX4 전동식 테일게이트용 액추에이터를 설계해줘. 4.5초 이내 개방, 최대 72°, -30~80°C 환경에서 동작해야 하고 기존 브래킷 형상은 유지해줘."
        },
        {
            label: "원가 우선 재설계",
            text: "기존 장착 좌표를 유지하면서 BOM 원가를 12% 낮춰줘. 개폐 시간은 4.5초 이내, 안전율은 1.5 이상이어야 해."
        },
        {
            label: "슬라이딩 도어 드라이브",
            text: "전동 슬라이딩 도어용 드라이브를 설계해줘. 최대 하중 42kg, 개폐 시간 5초 이내, 비상 수동 개방력을 70N 이하로 맞춰줘."
        },
        {
            label: "스포일러 리프트 설계",
            text: "고속 주행용 액티브 스포일러 리프트를 설계해줘. 120km/h에서 자동 전개하고 2초 이내 작동, IP67과 10만 회 내구 조건을 만족해야 해."
        }
    ];

    public agentExecution: any[] = [
        { task: "입력한 요청과 자료에서 필수 조건·최적화 목표·설계 파라미터·참고 자료를 찾고 있습니다.", tool: "Document Parser · Semantic Classifier", confidence: 96 },
        { task: "회전축과 무게중심을 기준으로 장착 가능 영역과 운동 궤적을 모델링합니다.", tool: "Kinematics Modeler · Geometry Check", confidence: 94 },
        { task: "요구 토크·온도·패키지 제약에 맞는 호환 부품 후보를 탐색하고 있습니다.", tool: "Parts Graph · Compatibility Rules", confidence: 92 },
        { task: "부품 조합과 장착 좌표를 다목적으로 탐색해 Pareto 후보를 생성합니다.", tool: "Optimizer · Constraint Solver", confidence: 91 },
        { task: "Iteration 03 설계안의 하중·간섭·내구 제약을 교차 검증하고 있습니다.", tool: "Motion · Load · Interference", confidence: 93 },
        { task: "성능·원가·안전성·신뢰도 근거를 종합해 최종 후보를 순위화합니다.", tool: "Evidence Ranker · Confidence Check", confidence: 97 }
    ];

    public agentOutputs: any[] = [
        {
            label: "REQUIREMENT OUTPUT",
            title: "의미 기반 구조화 대기",
            summary: "자연어와 첨부 자료에서 요구사항을 찾고, 사용자 원문과 AI가 이해한 결과를 비교할 수 있게 정리합니다.",
            metrics: [
                { label: "분류 항목", value: "—", note: "입력 대기" },
                { label: "입력 출처", value: "—", note: "자연어·첨부 자료" },
                { label: "확인 필요", value: "—", note: "분석 후 표시" }
            ]
        },
        {
            label: "KINEMATICS OUTPUT",
            title: "장착 가능 영역·운동 모델 생성",
            summary: "회전축과 무게중심을 기준으로 72° 개방 궤적과 액추에이터 장착 가능 영역을 계산했습니다.",
            metrics: [
                { label: "목표 각도", value: "72°", note: "충족" },
                { label: "요구 추력", value: "1,420 N", note: "Peak" },
                { label: "장착 영역", value: "18개", note: "유효 좌표" }
            ]
        },
        {
            label: "COMPONENT OUTPUT",
            title: "호환 부품·조합 규칙 탐색",
            summary: "온도·토크·패키지 제약을 만족하는 모터·감속기·스핀들 후보와 호환 규칙을 생성했습니다.",
            metrics: [
                { label: "호환 부품", value: "83개", note: "카탈로그" },
                { label: "유효 후보", value: "614", note: "조합 필터" },
                { label: "제외 사유", value: "5종", note: "근거 기록" }
            ]
        },
        {
            label: "OPTIMIZATION OUTPUT",
            title: "12,480개 설계 조합 탐색",
            summary: "성능·원가·안전성 목적함수를 동시에 평가해 Pareto 상위 128개 해석 후보로 축소했습니다.",
            metrics: [
                { label: "전체 조합", value: "12,480", note: "100%" },
                { label: "유효 후보", value: "614", note: "4.9%" },
                { label: "해석 대상", value: "128", note: "Pareto" }
            ]
        },
        {
            label: "VALIDATION OUTPUT",
            title: "재설계안 CAE 검증",
            summary: "응력 초과와 간섭을 발견해 Bracket B를 수정하고 재해석하여 모든 하드 제약을 통과했습니다.",
            metrics: [
                { label: "최소 간극", value: "8.2 mm", note: "PASS" },
                { label: "안전율", value: "1.82", note: "≥ 1.5" },
                { label: "피로 수명", value: "125k", note: "cycles" }
            ]
        },
        {
            label: "EVALUATION OUTPUT",
            title: "근거 기반 최종 3안 선정",
            summary: "성능·원가·안전성·신뢰도를 종합 평가해 균형형·원가형·성능형 설계안을 순위화했습니다.",
            metrics: [
                { label: "최종 추천", value: "3개", note: "27개 PASS 중" },
                { label: "종합 점수", value: "94점", note: "균형형" },
                { label: "추천 Confidence", value: "97%", note: "4종 검증 근거 가중" }
            ]
        }
    ];

    public decisionSteps: any[] = [
        { type: "context", label: "Context", title: "자연어 입력 대기", detail: "설계 목표와 제약을 입력해주세요.", status: "waiting" },
        { type: "reason", label: "Decision", title: "실행 계획 대기", detail: "입력 후 담당 Agent를 결정합니다.", status: "waiting" },
        { type: "tool", label: "Tool Call", title: "도구 호출 대기", detail: "CAD·부품·CAE 도구 연결 준비", status: "waiting" },
        { type: "result", label: "Handoff", title: "Agent 전달 대기", detail: "검증된 컨텍스트만 전달합니다.", status: "waiting" }
    ];

    public parallelJobs: any[] = [
        { name: "Motion Solver", detail: "0–72° · 4.18 s", progress: 100, status: "PASS" },
        { name: "Load Analysis", detail: "Peak 1,240 N", progress: 100, status: "PASS" },
        { name: "Fatigue Check", detail: "125k cycles", progress: 82, status: "RUNNING" }
    ];

    public explorationSteps: any[] = [
        { label: "전체 조합", value: "12,480", ratio: "100%", tone: "slate" },
        { label: "유효 후보", value: "614", ratio: "4.9%", tone: "blue" },
        { label: "시뮬레이션", value: "128", ratio: "1.0%", tone: "violet" },
        { label: "최종 추천", value: "3", ratio: "0.02%", tone: "green" }
    ];

    public evaluationFunnel: any[] = [
        { label: "설계 조합 탐색", value: "12,480", note: "전체 설계 공간" },
        { label: "유효 후보", value: "614", note: "필수 조건 필터" },
        { label: "시뮬레이션", value: "128", note: "Pareto 상위 후보" },
        { label: "PASS", value: "27", note: "모든 검증 통과" },
        { label: "최종 추천", value: "3", note: "Trade-off 대표안" }
    ];

    public confidenceWeights: any[] = [
        { label: "시뮬레이션", value: 35 },
        { label: "시험 데이터", value: 25 },
        { label: "전문가 규칙", value: 20 },
        { label: "제약 충족", value: 20 }
    ];

    public comparisonCriteria: any[] = [
        { label: "성능", index: 0, weight: 25, bestIndex: 2, priority: false },
        { label: "원가", index: 1, weight: 35, bestIndex: 1, priority: true },
        { label: "안전성", index: 2, weight: 25, bestIndex: 2, priority: false },
        { label: "신뢰도", index: 3, weight: 15, bestIndex: 2, priority: false }
    ];

    public alternatives: any[] = [
        {
            rank: "01",
            type: "balanced",
            label: "균형형",
            title: "균형 최적안",
            score: 94,
            weightedScore: 93,
            scoreAdjustment: 1,
            scoreAdjustmentLabel: "AI 균형 보너스 +1",
            scoreAdjustmentReason: "전 평가축 88점 이상 · 제약조건 100% 충족",
            scoreAdjustmentShort: "균형 가점 · 모든 조건 충족",
            scoreAdjustmentTooltip: "가점 +1 · 필수조건을 모두 충족하고 평가축 간 편차가 작아 균형 보너스를 적용했습니다.",
            scoreAdjustmentCriteria: "필수조건을 모두 충족하고, 모든 평가축이 85점 이상이며, 평가축 간 최대 편차가 8점 이하여서 균형 보너스 +1점을 적용했습니다.",
            confidence: 97,
            torque: "31.8 Nm",
            time: "4.18 s",
            cost: "₩68,400",
            motor: "BLDC 24V / 180W",
            gear: "Planetary 42:1",
            spindle: "Ø12 / Lead 6",
            pointA: "(324, 118, 642)",
            pointB: "(512, 94, 388)",
            badge: "AI 추천",
            reason: "목표 성능을 모두 충족하면서 원가와 안전율의 균형이 가장 우수합니다.",
            recommendationSummary: "모든 필수조건을 충족했고 원가·성능·안전성의 균형이 가장 안정적입니다.",
            selectionReasons: ["제약조건 100% 충족", "원가·성능·안전성 균형 우수", "AI Confidence 97%"],
            detailEvidence: [
                { label: "충족", text: "모든 필수 제약조건과 목표 성능 통과", caution: false },
                { label: "균형", text: "성능·원가·안전성 전 평가축 88점 이상", caution: false },
                { label: "Trade-off", text: "최저 원가·최고 속도보다 전체 안정성을 우선", caution: true }
            ],
            scoreExplanations: [
                { label: "가중 점수 93", text: "원가 35%를 포함한 네 평가축이 고르게 높습니다." },
                { label: "AI 보정 +1", text: "필수조건 100%와 낮은 평가축 편차로 균형 가점을 적용했습니다." },
                { label: "최종 판단", text: "뚜렷한 취약 평가축이 없어 최종 추천했습니다." }
            ],
            expectedOutcome: "4.18초 개폐 · BOM ₩68,400 · 안전율 1.82 · 125k cycles",
            expectedOutcomeItems: ["4.18초 개폐", "BOM ₩68,400", "안전율 1.82", "125k cycles"],
            tradeoff: "최저 원가나 최고 속도 대신 전 평가축의 안정적인 균형을 선택",
            pros: ["제약조건 100% 충족", "원가·성능·안전성의 균형", "시험 데이터와 높은 일치"],
            cons: ["원가형보다 ₩8,600 높음", "성능형보다 개방 시간이 0.36 s 느림"],
            confidenceFactors: [
                { label: "시뮬레이션 통과율", value: 100 },
                { label: "시험 데이터 일치율", value: 96 },
                { label: "전문가 규칙 만족도", value: 92 },
                { label: "제약조건 충족률", value: 100 }
            ],
            criteria: [
                { label: "성능", value: 96, note: "4.18 s · 31.8 Nm" },
                { label: "원가", value: 88, note: "목표 대비 -4.2%" },
                { label: "안전성", value: 95, note: "안전율 1.82" },
                { label: "신뢰도", value: 93, note: "125k cycles" }
            ]
        },
        {
            rank: "02",
            type: "cost",
            label: "원가형",
            title: "원가 절감안",
            score: 89,
            weightedScore: 90,
            scoreAdjustment: -1,
            scoreAdjustmentLabel: "AI 안전 여유 보정 -1",
            scoreAdjustmentReason: "안전율 1.56으로 필수 하한 1.5에 근접",
            scoreAdjustmentShort: "안전 여유 감점 · 하한 1.5 근접",
            scoreAdjustmentTooltip: "감점 -1 · 안전율 1.56이 필수 하한 1.5에 가까워 안전 여유 감점을 적용했습니다.",
            scoreAdjustmentCriteria: "안전율 여유가 필수 하한 대비 10% 이내이면 위험 근접 보정을 적용합니다. 안전율 1.56은 하한 1.5 대비 약 4% 여유라서 -1점입니다.",
            confidence: 92,
            torque: "31.9 Nm",
            time: "4.43 s",
            cost: "₩59,800",
            motor: "BLDC 24V / 160W",
            gear: "Planetary 48:1",
            spindle: "Ø12 / Lead 5",
            pointA: "(321, 116, 640)",
            pointB: "(508, 97, 392)",
            badge: "-12.6%",
            reason: "성능 한계 내에서 표준 부품 비중을 높여 BOM 원가를 가장 크게 절감합니다.",
            recommendationSummary: "모든 필수조건과 최저 원가를 달성했지만 안전 여유가 작아 추가 검증이 필요합니다.",
            selectionReasons: ["제약조건 100% 충족", "BOM 원가 16.3% 절감", "AI Confidence 92%"],
            detailEvidence: [
                { label: "원가", text: "BOM ₩59,800으로 목표 대비 16.3% 절감", caution: false },
                { label: "조달", text: "표준 부품 비중이 높고 모든 필수조건 충족", caution: false },
                { label: "Trade-off", text: "안전율 1.56으로 필수 하한 1.5에 근접", caution: true }
            ],
            scoreExplanations: [
                { label: "가중 점수 90", text: "원가 98점이 강점이나 안전성·신뢰도가 상대적으로 낮습니다." },
                { label: "AI 보정 -1", text: "안전 여유가 필수 하한 대비 약 4%라 감점했습니다." },
                { label: "최종 판단", text: "최저 원가가 우선일 때 유리하지만 추가 안전 검증이 필요합니다." }
            ],
            expectedOutcome: "목표 대비 원가 -16.3% · 4.43초 개폐 · 안전율 1.56",
            expectedOutcomeItems: ["원가 -16.3%", "4.43초 개폐", "안전율 1.56", "105k cycles"],
            tradeoff: "안전 여유와 개방 속도를 일부 낮추고 원가 절감 효과를 극대화",
            pros: ["BOM 원가 최저", "표준 부품 비중이 높아 조달 용이", "모든 필수 조건 충족"],
            cons: ["안전율 1.56으로 여유가 작음", "개방 시간이 4.43 s로 목표 상한에 근접"],
            confidenceFactors: [
                { label: "시뮬레이션 통과율", value: 94 },
                { label: "시험 데이터 일치율", value: 88 },
                { label: "전문가 규칙 만족도", value: 86 },
                { label: "제약조건 충족률", value: 100 }
            ],
            criteria: [
                { label: "성능", value: 86, note: "4.43 s · 31.9 Nm" },
                { label: "원가", value: 98, note: "목표 대비 -16.3%" },
                { label: "안전성", value: 87, note: "안전율 1.56" },
                { label: "신뢰도", value: 84, note: "105k cycles" }
            ]
        },
        {
            rank: "03",
            type: "performance",
            label: "성능형",
            title: "성능 우선안",
            score: 87,
            weightedScore: 89,
            scoreAdjustment: -2,
            scoreAdjustmentLabel: "AI 목표 초과 보정 -2",
            scoreAdjustmentReason: "BOM 원가가 목표보다 7.1% 높아 정책 감점",
            scoreAdjustmentShort: "원가 초과 감점 · BOM +7.1%",
            scoreAdjustmentTooltip: "감점 -2 · BOM 원가가 목표를 7.1% 초과해 목표 초과 감점을 적용했습니다.",
            scoreAdjustmentCriteria: "핵심 최적화 목표를 5% 넘게 벗어나면 목표 초과 보정 -2점을 적용합니다. BOM 원가가 목표보다 7.1% 높아 해당 기준이 적용됐습니다.",
            confidence: 90,
            torque: "29.6 Nm",
            time: "3.82 s",
            cost: "₩76,200",
            motor: "BLDC 24V / 220W",
            gear: "Planetary 38:1",
            spindle: "Ø14 / Lead 7",
            pointA: "(326, 121, 645)",
            pointB: "(515, 91, 384)",
            badge: "고성능",
            reason: "응답 속도와 토크 여유가 가장 높아 혹한·노후 조건에서 성능 우위가 있습니다.",
            recommendationSummary: "성능·안전성·신뢰도는 가장 우수하지만 목표 원가를 초과해 이번 설계 우선순위와 차이가 있습니다.",
            selectionReasons: ["성능·안전성·신뢰도 최고", "개폐 시간 3.82초", "AI Confidence 90%"],
            detailEvidence: [
                { label: "성능", text: "개폐 3.82초와 안전율 2.04로 후보 중 최고", caution: false },
                { label: "내구", text: "150k cycles로 가장 긴 검증 수명 확보", caution: false },
                { label: "Trade-off", text: "BOM 목표 7.1% 초과와 소비전력·중량 증가", caution: true }
            ],
            scoreExplanations: [
                { label: "가중 점수 89", text: "성능은 최고지만 가중치 35%인 원가 점수가 72점입니다." },
                { label: "AI 보정 -2", text: "BOM 목표를 5% 넘게 초과해 정책 감점을 적용했습니다." },
                { label: "최종 판단", text: "최고 성능보다 원가 균형을 우선한 이번 목표와 차이가 있습니다." }
            ],
            expectedOutcome: "3.82초 개폐 · 안전율 2.04 · 150k cycles · 최고 성능 99점",
            expectedOutcomeItems: ["3.82초 개폐", "안전율 2.04", "150k cycles", "성능 99점"],
            tradeoff: "원가와 소비전력 상승을 감수하고 응답 속도·안전 여유를 확보",
            pros: ["개방 시간 3.82 s로 가장 빠름", "안전율 2.04로 최대", "150k cycles 내구 수명"],
            cons: ["BOM 원가가 균형형보다 ₩7,800 높음", "220W 모터로 소비전력과 중량 증가"],
            confidenceFactors: [
                { label: "시뮬레이션 통과율", value: 92 },
                { label: "시험 데이터 일치율", value: 86 },
                { label: "전문가 규칙 만족도", value: 82 },
                { label: "제약조건 충족률", value: 100 }
            ],
            criteria: [
                { label: "성능", value: 99, note: "3.82 s · 29.6 Nm" },
                { label: "원가", value: 72, note: "목표 대비 +7.1%" },
                { label: "안전성", value: 97, note: "안전율 2.04" },
                { label: "신뢰도", value: 96, note: "150k cycles" }
            ]
        }
    ];

    public activity: any[] = [];

    public flowEvents: any[] = [
        { time: "09:41:08", from: "요구사항", to: "기구학", action: "Constraint handoff", text: "8개 확정 제약과 CAD 기준 좌표계를 전달했습니다.", status: "done", iteration: "Run 01" },
        { time: "09:41:24", from: "기구학", to: "부품선정", action: "Model request", text: "회전축·무게중심과 최대 요구 추력 1,420 N을 전달했습니다.", status: "done", iteration: "Run 01" },
        { time: "09:42:03", from: "부품선정", to: "최적화", action: "Candidate response", text: "호환 부품 83개와 조합 가능 규칙을 반환했습니다.", status: "done", iteration: "Run 01" },
        { time: "09:43:17", from: "최적화", to: "해석/검증", action: "Simulation request", text: "614개 유효 후보 중 Pareto 상위 128개 해석을 요청했습니다.", status: "done", iteration: "Iter. 01" },
        { time: "09:45:42", from: "해석/검증", to: "최적화", action: "FAIL response", text: "브라켓 응력 186 MPa 초과와 Gate inner 간섭 2.1 mm를 발견했습니다.", status: "error", iteration: "Iter. 01" },
        { time: "09:47:11", from: "최적화", to: "해석/검증", action: "Redesign request", text: "브라켓 B Z+8 mm·감속비 40:1로 수정하고 재해석을 요청했습니다.", status: "retry", iteration: "Iter. 02" },
        { time: "09:50:36", from: "해석/검증", to: "평가/선정", action: "PASS response", text: "재해석 결과 간극 8.2 mm·안전율 1.82로 모든 제약을 통과했습니다.", status: "done", iteration: "Iter. 03" },
        { time: "09:51:20", from: "평가/선정", to: "사용자", action: "Decision request", text: "균형형·원가형·성능형 3개 안과 추천 근거를 비교 화면에 전달했습니다.", status: "active", iteration: "Iter. 03" }
    ];

    public optimizationHistory: any[] = [
        {
            iteration: "Iteration 01",
            status: "FAIL",
            title: "초기 설계 생성",
            change: "카탈로그 기준 초기 부품 조합 및 장착 좌표 생성",
            variables: ["감속비 36:1", "Lead 7 mm", "Point B Z=380"],
            result: "Gate inner 간섭 2.1 mm",
            metrics: { time: "3.96 s", torque: "36.8 Nm", clearance: "-2.1 mm", safety: "1.41" }
        },
        {
            iteration: "Iteration 02",
            status: "FAIL",
            title: "간섭 회피 재설계",
            change: "장착점 B를 Z +8 mm 이동하고 감속비 상향",
            variables: ["감속비 40:1", "Lead 6 mm", "Point B Z=388"],
            result: "간섭 해소 · 최대 토크 초과",
            metrics: { time: "4.06 s", torque: "35.4 Nm", clearance: "6.7 mm", safety: "1.58" }
        },
        {
            iteration: "Iteration 03",
            status: "PASS",
            title: "토크·내구 최적화",
            change: "모터 180W, 감속비 42:1 적용 및 Point B X +4 mm",
            variables: ["감속비 42:1", "Lead 6 mm", "Point B X=512"],
            result: "모든 성능·안전 제약 충족",
            metrics: { time: "4.18 s", torque: "31.8 Nm", clearance: "8.2 mm", safety: "1.82" }
        }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.applyWorkspaceContext();
        this.persistActiveRun();
        let evidenceKey = typeof location !== "undefined"
            ? new URLSearchParams(location.search).get("evidence") || ""
            : "";
        if (evidenceKey) {
            await this.loadCompletedDemo();
            await this.openLinkedEvidence(evidenceKey);
            return;
        }
        await this.service.render();
    }

    public applyWorkspaceContext() {
        if (typeof location === "undefined") return;
        let params = new URLSearchParams(location.search);
        let routeRunId = params.get("run") || params.get("project") || "";
        this.newRunMode = params.get("mode") === "new-run";
        if (!routeRunId && typeof localStorage !== "undefined") {
            try {
                routeRunId = localStorage.getItem(this.activeRunStorageKey) || "";
            } catch (error) {
                routeRunId = "";
            }
        }
        if (!this.workspaceProjects[routeRunId]) return;
        this.runId = routeRunId;
        this.activeProjectTitle = this.workspaceProjects[routeRunId];
    }

    public get activeProjectId() {
        return this.workspaceProjectIds[this.runId] || "—";
    }

    public get evidenceDeepLinkLabel() {
        let labels: any = {
            "design-brief": "Design Brief v3",
            "natural-language-input": "자연어 요구사항 원문",
            "source-cad": "NX4_tailgate.step · CAD",
            "motor-catalog": "motor_catalog.pdf · Data sheet",
            "design-components": "설계·부품 후보 생성",
            "simulation-batch": "Simulation Batch #128",
            "validation-pack": "Validation Pack v1.4",
            "candidate-rank": "Candidate Rank #03",
            "recommendation": "최적안 추천 3개"
        };
        return labels[this.evidenceDeepLink] || "Linked Evidence";
    }

    public async openLinkedEvidence(key: string) {
        let targets: any = {
            "design-brief": { step: 2 },
            "natural-language-input": { step: 2 },
            "source-cad": { step: 2 },
            "motor-catalog": { step: 2 },
            "design-components": { step: 3 },
            "simulation-batch": { step: 5, iteration: 2 },
            "validation-pack": { step: 5, iteration: 2, drawer: "simulation" },
            "candidate-rank": { step: 6, candidate: 0 },
            "recommendation": { step: 6, candidate: 0 }
        };
        let target = targets[key] || targets["design-brief"];
        this.evidenceDeepLink = key;
        this.journeyStep = target.step;
        this.finalApproved = true;
        this.detailDrawer = target.drawer || "";
        if (typeof target.iteration === "number") this.selectedIteration = target.iteration;
        if (typeof target.candidate === "number") this.detailAlternative = target.candidate;
        this.persistRunContext();
        await this.service.render();
        this.scrollJourneyTop();
    }

    public persistActiveRun() {
        if (typeof localStorage === "undefined") return;
        try {
            localStorage.setItem(this.activeRunStorageKey, this.runId);
        } catch (error) {
            // The dashboard Run ID remains visible when browser storage is restricted.
        }
    }

    public get runContextItems() {
        let contexts: any = {
            1: [
                { label: "입력 스냅샷", value: this.requestText.trim() ? "자연어 1건" : "입력 대기" },
                { label: "첨부 근거", value: `${this.uploadedFiles.length}개` },
                { label: "담당", value: "요구사항 Agent" },
                { label: "다음 단계", value: "요구사항 분석" }
            ],
            2: [
                { label: "요구사항", value: `${this.activeRequirementCount}개` },
                { label: "설계 파라미터", value: `${this.designInputCount}개` },
                { label: "확인 필요", value: `${this.reviewNeededCount}개` },
                { label: "입력 버전", value: "Design Brief v3" }
            ],
            3: [
                { label: "확정 요구사항", value: `${this.activeRequirementCount || 8}개` },
                { label: "설계 변수", value: `${this.designVariables.length}종` },
                { label: "탐색 조합", value: "12,480개" },
                { label: "해석 후보", value: "128개" }
            ],
            4: [
                { label: "참여 Agent", value: "6개" },
                { label: "Handoff", value: `${Math.min(6, Math.max(1, this.logDoneCount))}건` },
                { label: "해석 후보", value: "128개" },
                { label: "Evidence", value: "18개" }
            ],
            5: [
                { label: "Simulation", value: "128건" },
                { label: "검증 반복", value: "3회" },
                { label: "PASS 후보", value: "27개" },
                { label: "판정", value: "PASS" }
            ],
            6: [
                { label: "PASS 후보", value: "27개" },
                { label: "최종 추천", value: "3개" },
                { label: "현재 선택", value: this.selectedDesign.title },
                { label: "Confidence", value: `${this.selectedDesign.confidence}%` }
            ],
            7: [
                { label: "최종 추천안", value: this.selectedDesign.title },
                { label: "Approval", value: this.finalApproved ? "승인 완료" : "승인 대기" },
                { label: "Evidence", value: "Pack v1.4" },
                { label: "Output", value: "4종" }
            ]
        };
        return contexts[this.journeyStep] || contexts[1];
    }

    public get currentHandoff() {
        let handoffs: any = {
            1: { from: "사용자", to: "요구사항 Agent", payload: this.requestText.trim() ? "자연어 요청 · 첨부 근거" : "설계 목표 입력 대기", status: this.requestText.trim() ? "READY" : "WAITING" },
            2: { from: "요구사항 Agent", to: "사용자", payload: `Design Brief v3 · 요구사항 ${this.activeRequirementCount}개 · 설계 파라미터 ${this.designInputCount}개`, status: this.reviewNeededCount > 0 ? "REVIEW" : "READY" },
            3: { from: "요구사항 Agent", to: "기구학 Agent", payload: "확정 Design Brief v3 · CAD 좌표계 · 5종 설계 변수", status: this.requirementsConfirmed ? "DELIVERED" : "SAMPLE" },
            4: { from: "최적화 Agent", to: "해석/검증 Agent", payload: "Simulation Batch #128 · Pareto 후보 · 조합 근거", status: "DELIVERED" },
            5: { from: "해석/검증 Agent", to: "평가/선정 Agent", payload: "Validation Evidence Pack · PASS 후보 27개 · Iteration 03", status: "DELIVERED" },
            6: { from: "평가/선정 Agent", to: "사용자", payload: `추천안 3개 · ${this.selectedDesign.title} · 추천 근거`, status: "DECISION" },
            7: { from: "사용자", to: "Run Archive", payload: `${this.selectedDesign.title} · 승인 기록 · 결과 패키지`, status: this.finalApproved ? "APPROVED" : "PENDING" }
        };
        return handoffs[this.journeyStep] || handoffs[1];
    }

    public runPlatformLink(section: string) {
        return `/platform/${section}/${this.runId}`;
    }

    public statusTone(status: string) {
        let value = String(status || "").toLowerCase();
        if (["pass", "approved", "done", "ready", "delivered", "archived"].includes(value)) return "pass";
        if (["review", "decision", "pending"].includes(value)) return "review";
        if (["running", "active", "input"].includes(value)) return "running";
        if (["fail", "rejected", "error"].includes(value)) return "fail";
        if (value === "retry") return "retry";
        return "waiting";
    }

    public persistRunContext() {
        if (typeof localStorage === "undefined") return;
        try {
            let context = {
                runId: this.runId,
                project: this.designSubjectLabel || this.activeProjectTitle,
                journeyStep: this.journeyStep,
                stage: this.journeyStages[this.journeyStep - 1]?.label || "자연어 입력",
                status: this.workflowLabel,
                requirements: this.activeRequirementCount,
                designVariables: this.designVariables.length,
                simulationCandidates: 128,
                passCandidates: 27,
                recommendations: 3,
                selectedDesign: this.selectedDesign.title,
                approved: this.finalApproved,
                handoff: this.currentHandoff,
                updatedAt: new Date().toISOString()
            };
            localStorage.setItem(this.runStorageKey, JSON.stringify(context));
            localStorage.setItem(this.activeRunStorageKey, this.runId);
        } catch (error) {
            // Demo context remains available in-memory when browser storage is restricted.
        }
    }

    public get selectedDesign() {
        return this.alternatives[this.selectedAlternative];
    }

    public get detailedDesign() {
        return this.detailAlternative >= 0 ? this.alternatives[this.detailAlternative] : null;
    }

    public get selectedSimulationResults() {
        let profiles: any = {
            balanced: { stress: "142 MPa", safety: "1.82", structureMargin: "+21.3%", clearance: "8.2 mm", clearanceMargin: "+64.0%", fatigue: "125k cycles", fatigueMargin: "+25.0%", thermalMargin: "+8.0%", motionMargin: "+7.1%", torqueMargin: "+0.6%" },
            cost: { stress: "166 MPa", safety: "1.56", structureMargin: "+4.0%", clearance: "6.9 mm", clearanceMargin: "+38.0%", fatigue: "105k cycles", fatigueMargin: "+5.0%", thermalMargin: "+3.0%", motionMargin: "+1.6%", torqueMargin: "+0.3%" },
            performance: { stress: "128 MPa", safety: "2.04", structureMargin: "+36.0%", clearance: "9.4 mm", clearanceMargin: "+88.0%", fatigue: "150k cycles", fatigueMargin: "+50.0%", thermalMargin: "+14.0%", motionMargin: "+15.1%", torqueMargin: "+7.5%" }
        };
        let profile = profiles[this.selectedDesign.type] || profiles.balanced;
        return [
            { name: "운동 해석", tool: "Motion", value: this.selectedDesign.time, target: "≤ 4.50 s", margin: profile.motionMargin, note: "0–72° 전 구간 정상 작동", status: "PASS", caution: false, priority: true },
            { name: "최대 토크", tool: "Load", value: this.selectedDesign.torque, target: "≤ 32 Nm", margin: profile.torqueMargin, note: `${this.selectedDesign.motor} 구동 조건`, status: "PASS", caution: this.selectedDesign.type === "cost", priority: true },
            { name: "구조 해석", tool: "Static", value: `안전율 ${profile.safety}`, target: "≥ 1.50", margin: profile.structureMargin, note: `최대 등가응력 ${profile.stress}`, status: "PASS", caution: this.selectedDesign.type === "cost", priority: true },
            { name: "간섭 해석", tool: "Clearance", value: profile.clearance, target: "≥ 5 mm", margin: profile.clearanceMargin, note: "Gate inner 간섭 없음", status: "PASS", caution: false, priority: true },
            { name: "피로 해석", tool: "Fatigue", value: profile.fatigue, target: "≥ 100k cycles", margin: profile.fatigueMargin, note: "누적 손상 기준 통과", status: "PASS", caution: this.selectedDesign.type === "cost", priority: false },
            { name: "열 해석", tool: "Thermal", value: "정격 유지", target: "-30–80°C", margin: profile.thermalMargin, note: "저온 조건 토크 여유", status: "PASS", caution: this.selectedDesign.type === "cost", priority: false }
        ];
    }

    public get selectedSimulationTimeline() {
        let results = this.selectedSimulationResults;
        return [
            { step: "01", name: "Motion", tool: "Motion Solver", description: "개폐 궤적·시간·토크 계산", result: `${results[0].value} · ${results[1].value}`, iteration: "ITER.01", runCount: "총 1회", rechecked: false, priority: true },
            { step: "02", name: "Structure", tool: "Static Load", description: "하중·응력·안전율 검증", result: results[2].value, iteration: "ITER.03", runCount: "총 3회", rechecked: true, priority: true },
            { step: "03", name: "Clearance", tool: "Motion Clearance", description: "Gate inner 간섭·최소 간극", result: results[3].value, iteration: "ITER.03", runCount: "총 3회", rechecked: true, priority: true },
            { step: "04", name: "Fatigue", tool: "Fatigue Life", description: "100k cycle 누적 손상 평가", result: results[4].value, iteration: "ITER.03", runCount: "총 3회", rechecked: true, priority: false },
            { step: "05", name: "Thermal", tool: "Thermal Derating", description: "-30–80°C 모터 정격 검증", result: `${results[5].value} · ${results[5].margin}`, iteration: "ITER.03", runCount: "총 3회", rechecked: true, priority: false }
        ];
    }

    public get selectedSimulationRecovery() {
        let results = this.selectedSimulationResults;
        return [
            { tone: "fail", phase: "문제 발견 → 원인 분석", label: "ITER.01 · FAIL", title: "구조·간섭 위반 감지", detail: "안전율 1.41 · Gate inner -2.1 mm", reason: "원인 · 장착점 Z와 토크 전달비가 두 위반에 함께 영향" },
            { tone: "change", phase: "AI 판단 → 설계 변경", label: "AUTO REDESIGN", title: "설계 변수 자동 수정", detail: "Bracket B Z +8 mm · Lead 6 mm · 감속비 42:1", reason: "선택 이유 · 기존 패키지를 유지하며 구조·간극·토크 여유를 함께 회복하는 최소 변경" },
            { tone: "pass", phase: "재해석 → PASS", label: "ITER.03 · PASS", title: "변경안 재해석 통과", detail: `${results[2].value} · 최소 간극 ${results[3].value}`, reason: "종료 판단 · 필수조건 100%와 양의 Margin 확인" }
        ];
    }

    public get selectedSimulationAiDecision() {
        return "AI 선택 근거 · 기존 패키지를 유지하면서 구조 안전율·간극·토크 여유를 동시에 회복하는 최소 변경 조합";
    }

    public get selectedHistory() {
        return this.optimizationHistory[this.selectedIteration];
    }

    public get activeAgentOutput() {
        return this.agentOutputs[Math.max(0, this.activePhase)] || this.agentOutputs[0];
    }

    public get activeRequirementCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item)).length;
    }

    public get hardRequirementCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item) && item.kind === "constraint").length;
    }

    public get objectiveRequirementCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item) && item.kind === "objective").length;
    }

    public get designInputCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item) && item.kind === "input").length;
    }

    public get referenceRequirementCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item) && item.kind === "reference").length;
    }

    public get reviewNeededCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item) && item.needsReview).length;
    }

    public get reviewConfirmationCount() {
        return this.extractedRequirements.filter(item =>
            !item.excluded &&
            !this.isProjectInformation(item) &&
            (item.needsReview || item.reviewConfirmed)
        ).length;
    }

    public get allReviewItemsConfirmed() {
        let items = this.extractedRequirements.filter(item =>
            !item.excluded &&
            !this.isProjectInformation(item) &&
            (item.needsReview || item.reviewConfirmed)
        );
        return items.length > 0 && items.every(item => !item.needsReview && item.reviewConfirmed);
    }

    public requiresRequirementReview(confidence: number) {
        return Number(confidence) < this.requirementReviewThreshold;
    }

    public isProjectInformation(item: any) {
        return Boolean(item && (item.role === "project" || item.label === "설계 대상"));
    }

    public get projectInformation() {
        return this.extractedRequirements.find(item => !item.excluded && this.isProjectInformation(item));
    }

    public get hasActiveDesignBrief() {
        return Boolean(this.projectInformation) || this.activeRequirementCount > 0;
    }

    public rebuildRequirementGroups() {
        let groups = [
            { kind: "constraint", label: "필수 조건", description: "반드시 지켜야 하며, 못 지킨 설계안은 제외합니다.", symbol: "필" },
            { kind: "objective", label: "최적화 목표", description: "조건을 만족한 후보 중 더 좋은 안을 고르는 기준입니다.", symbol: "목" },
            { kind: "input", label: "설계 파라미터", description: "계산·부품선정·형상 생성에 사용하는 값입니다.", symbol: "값" },
            { kind: "reference", label: "참고 자료", description: "값과 형상을 확인할 때 기준이 되는 원본 자료입니다.", symbol: "자" }
        ];
        this.requirementGroups = groups
            .map(group => {
                let items = this.extractedRequirements.filter(item => !this.isProjectInformation(item) && item.kind === group.kind);
                return {
                    ...group,
                    items,
                    activeCount: items.filter(item => !item.excluded).length,
                    reviewCount: items.filter(item => !item.excluded && item.needsReview).length
                };
            })
            .filter(group => group.items.length > 0);
    }

    public get averageRequirementConfidence() {
        let active = this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item));
        if (active.length === 0) return 0;
        return Math.round(active.reduce((sum, item) => sum + Number(item.confidence || 0), 0) / active.length);
    }

    public get naturalLanguageRequirementCount() {
        return this.extractedRequirements.filter(item => !item.excluded && !this.isProjectInformation(item) && item.source === "자연어").length;
    }

    public get requirementBriefSummary() {
        let active = this.extractedRequirements.filter(item => !item.excluded);
        let target = active.find(item => item.label === "설계 대상");
        let subject = target ? `${target.value} 설계` : "입력한 설계 요청";
        let parts: string[] = [];
        if (this.hardRequirementCount > 0) parts.push(`필수 조건 ${this.hardRequirementCount}개`);
        if (this.objectiveRequirementCount > 0) parts.push(`최적화 목표 ${this.objectiveRequirementCount}개`);
        if (this.designInputCount > 0) parts.push(`설계 파라미터 ${this.designInputCount}개`);
        if (this.referenceRequirementCount > 0) parts.push(`참고 자료 ${this.referenceRequirementCount}개`);
        return `${subject}에서 ${parts.join("와 ") || "설계 정보"}를 찾았습니다. 원문과 AI가 이해한 결과가 같은지 확인해주세요.`;
    }

    public requirementInterpretation(item: any) {
        let label = item && item.label ? item.label : "요구사항";
        let value = String(item && item.value || "").trim();
        let comparison = value.match(/^(≤|≥|<|>)\s*(.+)$/);
        if (comparison) {
            let direction = {
                "≤": "이하(기준값 포함)",
                "≥": "이상(기준값 포함)",
                "<": "미만(기준값 제외)",
                ">": "초과(기준값 제외)"
            }[comparison[1]];
            return `대상은 “${label}”, 조건은 “${comparison[2]} ${direction}”로 이해했습니다.`;
        }
        if (value.includes("~")) {
            let range = value.replace(/\s*~\s*/, "부터 ");
            return `대상은 “${label}”, 허용 범위는 “${range}까지”로 이해했습니다.`;
        }
        if (item && item.kind === "objective") {
            return `대상은 “${label}”, 목표 방향은 “${value}”로 이해했습니다.`;
        }
        if (item && item.kind === "input") {
            return `대상은 “${label}”, 계산 입력값은 “${value}”로 이해했습니다.`;
        }
        if (item && item.kind === "reference") {
            return `자료 종류는 “${label}”, 사용할 원본은 “${value}”로 이해했습니다.`;
        }
        return `대상은 “${label}”, 반드시 지켜야 할 조건은 “${value}”로 이해했습니다.`;
    }

    public get designSubjectLabel() {
        let target = this.extractedRequirements.find(item => !item.excluded && item.label === "설계 대상");
        if (target) return target.value;
        if (this.requestText.trim()) return "요구사항 분석 준비";
        return this.activeProjectTitle;
    }

    public get flowStep() {
        if (this.workflowStage === "complete") return 4;
        if (this.workflowStage === "running") return 3;
        if (this.workflowStage === "parsing" || this.workflowStage === "review") return 2;
        return 1;
    }

    public get workflowLabel() {
        if (this.finalApproved) return "최종 확정";
        return {
            empty: "자연어 입력 대기",
            draft: "입력 감지",
            parsing: "요구사항 분석 중",
            review: "요구사항 확정 대기",
            running: "Agent 실행 중",
            complete: "추천 완료"
        }[this.workflowStage] || "입력 대기";
    }

    public get workflowTone() {
        if (this.finalApproved) return "pass";
        if (this.workflowStage === "complete" || this.workflowStage === "review") return "review";
        if (this.workflowStage === "parsing" || this.workflowStage === "running") return "running";
        return "pending";
    }

    public get logDoneCount() {
        return this.activity.filter(item => item.status === "done").length;
    }

    public get logActiveCount() {
        return this.activity.filter(item => item.status === "active").length;
    }

    public get logErrorCount() {
        return this.activity.filter(item => item.status === "error").length;
    }

    public explorationValue(index: number) {
        if (this.workflowStage === "complete") return this.explorationSteps[index].value;
        if (this.workflowStage === "review") return index === 0 ? "12,480" : "대기";
        if (this.workflowStage === "running") {
            if (index === 0) return "12,480";
            if (index === 1 && this.activePhase >= 2) return "614";
            if (index === 2 && this.activePhase >= 4) return "128";
            if (index === 3 && this.activePhase >= 5) return "3";
            return "탐색 중";
        }
        return "—";
    }

    public explorationRatio(index: number) {
        if (this.workflowStage === "complete") return this.explorationSteps[index].ratio;
        if (this.workflowStage === "review" && index === 0) return "예상 공간";
        if (this.workflowStage === "running" && this.explorationValue(index) !== "탐색 중") return this.explorationSteps[index].ratio;
        return "입력 후 계산";
    }

    public alternativeFlowValue(index: number) {
        if (this.workflowStage === "complete") return this.alternativeFlow[index].value;
        let unlockPhase = [0, 2, 3, 4, 4, 5][index];
        return this.activePhase >= unlockPhase ? this.alternativeFlow[index].value : "대기";
    }

    public statusLabel(status: string) {
        return { waiting: "대기", active: "실행", done: "완료", error: "오류" }[status] || status;
    }

    public requirementKindLabel(kind: string) {
        return {
            constraint: "필수 조건",
            objective: "최적화 목표",
            input: "설계 파라미터",
            reference: "참고 자료"
        }[kind] || "미분류";
    }

    public requirementDeliveryFor(label: string, kind: string, evidence: string = "") {
        let context = `${label || ""} ${evidence || ""}`;
        if (label === "설계 대상") {
            return {
                nextAgents: ["전체 설계 Agent"],
                purposes: ["프로젝트 범위 공유", "공통 컨텍스트 설정"],
                processingSteps: ["설계 대상 정규화", "프로젝트 컨텍스트 생성", "전체 Agent 전달"]
            };
        }
        if (/(?:중량|무게|질량|weight)/i.test(context) && !/(?:무게\s*중심|COG)/i.test(context)) {
            return {
                nextAgents: ["기구학 Agent", "부품선정 Agent"],
                purposes: ["추력 계산", "모터 용량 산출"],
                processingSteps: ["추력 계산", "모터 용량 산출"]
            };
        }
        if (/(?:COG|무게\s*중심|center\s*of\s*gravity)/i.test(context)) {
            return {
                nextAgents: ["기구학 Agent"],
                purposes: ["기구학 해석", "운동 안정성 검토"],
                processingSteps: ["무게중심 계산", "기구학 해석"]
            };
        }
        if (/(?:힌지|회전\s*축|장착점|장착\s*위치)/i.test(context)) {
            return {
                nextAgents: ["기구학 Agent", "상세설계 Agent"],
                purposes: ["회전축 계산", "장착 위치 생성"],
                processingSteps: ["회전축 계산", "장착 위치 생성"]
            };
        }
        if (/(?:하중\s*프로파일|하중\s*경로|작용\s*하중|피크\s*하중|load\s*profile|load\s*path)/i.test(context)) {
            return {
                nextAgents: ["해석/검증 Agent"],
                purposes: ["구조 해석", "안전율 검증"],
                processingSteps: ["하중 모델 생성", "구조 해석"]
            };
        }
        if (/(?:전압|voltage)/i.test(context)) {
            return {
                nextAgents: ["부품선정 Agent"],
                purposes: ["모터 후보 탐색", "부품 선정"],
                processingSteps: ["모터 후보 탐색", "부품 선정"]
            };
        }
        if (kind === "reference" && /(?:STEP|STP|3D\s*CAD|CAD\s*형상)/i.test(context)) {
            return {
                nextAgents: ["기구학 Agent", "상세설계 Agent"],
                purposes: ["형상 정보 추출", "CAD 모델 생성"],
                processingSteps: ["형상 인식", "CAD 모델 생성"]
            };
        }
        if (kind === "objective") {
            let costObjective = /원가|비용|BOM/i.test(context);
            return {
                nextAgents: ["최적화 Agent"],
                purposes: costObjective ? ["원가 목적함수 구성", "저원가 후보 순위화"] : ["목적함수 구성", "설계 후보 순위화"],
                processingSteps: costObjective ? ["목표 원가 정규화", "비용 함수 계산", "후보 순위화"] : ["목표 지표 정규화", "목적함수 계산", "후보 순위화"]
            };
        }
        if (kind === "reference") {
            if (/카탈로그|PDF|데이터시트/i.test(context)) {
                return {
                    nextAgents: ["부품선정 Agent"],
                    purposes: ["부품 사양 비교", "호환 후보 선정"],
                    processingSteps: ["문서 사양 추출", "정격 조건 필터", "부품 후보 생성"]
                };
            }
            if (/시험\s*데이터|TEST/i.test(context)) {
                return {
                    nextAgents: ["해석/검증 Agent"],
                    purposes: ["해석 기준 보정", "성능 검증"],
                    processingSteps: ["시험 데이터 정규화", "해석 결과 대조", "성능 검증"]
                };
            }
            if (/CAD|STEP|STP|DWG|DXF|3D|형상|이미지/i.test(context)) {
                return {
                    nextAgents: ["기구학 Agent", "상세설계 Agent"],
                    purposes: ["형상·좌표 추출", "CAD 모델 생성"],
                    processingSteps: ["자료 형상 인식", "기준 형상 추출", "CAD 모델 생성"]
                };
            }
            return {
                nextAgents: ["상세설계 Agent", "해석/검증 Agent"],
                purposes: ["설계 근거 조회", "결과 추적"],
                processingSteps: ["자료 구조화", "설계 근거 연결", "검증 이력 생성"]
            };
        }
        if (/(?:좌표|위치|개방\s*각도|동작\s*각도|개폐\s*시간|개방\s*시간|폐쇄\s*시간|동작\s*시간|속도|궤적)/i.test(context)) {
            return {
                nextAgents: ["기구학 Agent", "해석/검증 Agent"],
                purposes: ["운동 궤적 계산", "동작 성능 검증"],
                processingSteps: ["운동 조건 변환", "기구학 계산", "성능 검증"]
            };
        }
        if (/(?:전류|출력|토크|추력|작동력|모터|감속기|부품)/i.test(context)) {
            return {
                nextAgents: ["부품선정 Agent"],
                purposes: ["구동 요구량 계산", "부품 후보 탐색"],
                processingSteps: ["구동 조건 정규화", "모터 용량 산출", "부품 후보 생성"]
            };
        }
        if (/(?:하중|추력|안전율|응력|변형|강성|압력|피로|수명)/i.test(context)) {
            return {
                nextAgents: ["해석/검증 Agent"],
                purposes: ["구조 해석", "안전성 검증"],
                processingSteps: ["해석 조건 생성", "구조 해석", "안전성 판정"]
            };
        }
        if (/(?:온도|습도|방수|방진|보호\s*등급|IP\d+|소음|진동|시간|속도|효율)/i.test(context)) {
            return {
                nextAgents: ["부품선정 Agent", "해석/검증 Agent"],
                purposes: ["환경 등급 필터링", "성능 검증"],
                processingSteps: ["환경 조건 변환", "정격 부품 필터", "성능 검증"]
            };
        }
        if (/(?:재질|소재|두께|직경|길이|폭|높이|반경|치수|형상|외형|패키지|간극|세척|조작|편의)/i.test(context)) {
            return {
                nextAgents: ["상세설계 Agent"],
                purposes: ["상세 치수 결정", "CAD 모델 생성"],
                processingSteps: ["설계 규칙 변환", "치수 파라미터 생성", "CAD 모델 생성"]
            };
        }
        if (kind === "input") {
            return {
                nextAgents: ["상세설계 Agent", "기구학 Agent"],
                purposes: ["계산 모델 구성", "CAD 파라미터 적용"],
                processingSteps: ["단위·좌표 정규화", "설계 변수 생성", "계산 모델 전달"]
            };
        }
        return {
            nextAgents: ["상세설계 Agent", "해석/검증 Agent"],
            purposes: ["설계안 필터링", "충족 여부 검증"],
            processingSteps: ["조건식 변환", "설계안 필터 적용", "충족 여부 검증"]
        };
    }

    public applyRequirementDelivery(item: any) {
        let delivery = this.requirementDeliveryFor(item.label, item.kind, item.evidence);
        item.nextAgents = delivery.nextAgents;
        item.purposes = delivery.purposes;
        item.processingSteps = delivery.processingSteps;
        item.usage = delivery.purposes.join(" · ");
        item.role = item.label === "설계 대상" ? "project" : "design-data";
        return item;
    }

    public inferRequirementKind(clause: string) {
        if (/(?:최소화|최대화|최적화|우선|개선|향상|낮춰|낮추|줄여|줄이|절감|높여|높이|선호|중요|좋겠|원하|바라)/.test(clause)) return "objective";
        if (/(?:반드시|필수|해야|되어야|이어야|가능해야|워야|아야|어야|여야|이내|이하|이상|미만|초과|최대|최소|금지|않아야|유지|그대로|변경하지|바꾸지|(?:변경하면|바꾸면)\s*안|넘지)/.test(clause)) return "constraint";
        if (/(?:COG|무게\s*중심|힌지|회전\s*축|장착점|좌표|하중\s*경로|관성|재질|소재|두께|직경|치수|질량)/i.test(clause)) return "input";
        if (/(?:CAD|STEP|STP|DWG|DXF|PDF|카탈로그|데이터시트|시험\s*데이터|이미지)/i.test(clause)) return "reference";
        return "unclassified";
    }

    public inferSemanticLabel(clause: string, kind: string, valueToken: string = "") {
        let semanticPatterns = [
            { pattern: /힌지.*(?:좌표|위치|축)|(?:좌표|위치|축).*힌지/i, label: "힌지 위치" },
            { pattern: /무게\s*중심|COG|center\s*of\s*gravity/i, label: "무게중심(COG)" },
            { pattern: /모터|motor/i, label: "모터 사양" },
            { pattern: /STEP|STP|DWG|DXF|CAD|3D\s*모델/i, label: "CAD 형상 모델" },
            { pattern: /부품\s*카탈로그|catalog/i, label: "부품 카탈로그" },
            { pattern: /시험\s*데이터|test\s*data/i, label: "시험 데이터" },
            { pattern: /PDF|데이터시트|data\s*sheet/i, label: "PDF 사양 자료" },
            { pattern: /참고\s*이미지|PNG|JPG|JPEG/i, label: "참고 이미지" },
            { pattern: /무게\s*중심|COG|center\s*of\s*gravity/i, label: "무게중심(COG)" },
            { pattern: /힌지.*(?:좌표|위치|축)|(?:좌표|위치|축).*힌지/i, label: "힌지 위치" },
            { pattern: /회전\s*축|회전축|기준\s*축/i, label: "회전축" },
            { pattern: /하중\s*경로|load\s*path/i, label: "하중 경로" },
            { pattern: /온도.*(?:편차|차이)|(?:편차|차이).*온도/i, label: "온도 편차" },
            { pattern: /개폐.*시간|개방.*시간|닫.*시간|폐쇄.*시간|응답.*시간|주기|cycle\s*time/i, label: "동작 시간" },
            { pattern: /온도|temperature/i, label: "동작 온도" },
            { pattern: /각도|회전|개방.*(?:도|°)/i, label: "동작 각도" },
            { pattern: /토크|torque/i, label: "토크" },
            { pattern: /안전율|safety\s*factor/i, label: "안전율" },
            { pattern: /간극|클리어런스|clearance|여유\s*간격/i, label: "최소 간극" },
            { pattern: /피로|내구.*수명|반복.*수명|cycle\s*life/i, label: "내구 수명" },
            { pattern: /하중|load/i, label: "작용 하중" },
            { pattern: /추력|작동력|force/i, label: "요구 작동력" },
            { pattern: /중량|무게|경량|weight/i, label: "중량" },
            { pattern: /원가|비용|cost|BOM/i, label: "원가" },
            { pattern: /소음|noise|dB/i, label: "소음" },
            { pattern: /진동|vibration/i, label: "진동" },
            { pattern: /전압|voltage/i, label: "동작 전압" },
            { pattern: /전류|current/i, label: "동작 전류" },
            { pattern: /출력|전력|power/i, label: "정격 출력" },
            { pattern: /효율|efficiency/i, label: "효율" },
            { pattern: /속도|velocity|speed/i, label: "동작 속도" },
            { pattern: /가속도|acceleration/i, label: "가속도" },
            { pattern: /압력|pressure/i, label: "압력" },
            { pattern: /유량|flow\s*rate/i, label: "유량" },
            { pattern: /습도|humidity/i, label: "동작 습도" },
            { pattern: /강성|stiffness/i, label: "강성" },
            { pattern: /응력|stress/i, label: "허용 응력" },
            { pattern: /변형|deflection|deformation/i, label: "허용 변형" },
            { pattern: /재질|소재|material/i, label: "재질" },
            { pattern: /좌표|장착.*(?:점|위치)|위치|position/i, label: "위치 좌표" },
            { pattern: /치수|길이|폭|높이|직경|두께|반경|dimension/i, label: "주요 치수" },
            { pattern: /형상|외형|패키지|envelope/i, label: "형상 조건" },
            { pattern: /방수|방진|IP\d+/i, label: "보호 등급" },
            { pattern: /비가|우천|강우|빗물/i, label: "우천 동작 조건" },
            { pattern: /충격|impact/i, label: "충격 내성" },
            { pattern: /사용자|조작|편의|ergonomic/i, label: "사용 편의성" },
            { pattern: /세척|청소|세정|washable/i, label: "세척 용이성" },
            { pattern: /유지\s*보수|정비|serviceability|maintenance/i, label: "유지보수성" },
            { pattern: /간섭|interference/i, label: "간섭 방지" },
            { pattern: /외관|스타일|고급|미관|디자인/i, label: "외관 품질" },
            { pattern: /신뢰성|신뢰도|reliability/i, label: "신뢰성" }
        ];
        let matched = semanticPatterns.find(item => item.pattern.test(clause));
        if (matched) {
            if (kind === "objective") {
                if (/최소화|낮춰|낮추|줄여|줄이|절감/.test(clause)) return `${matched.label} 최소화`;
                if (/최대화|높여|높이|향상|개선/.test(clause)) return `${matched.label} 향상`;
                return `${matched.label} 최적화`;
            }
            if (/(?:유지(?!\s*보수)|그대로|변경하지|바꾸지|변경하면\s*안|바꾸면\s*안)/.test(clause)) return `${matched.label} 유지`;
            return matched.label;
        }

        let unitPatterns = [
            { pattern: /°\s*(?:C|F)|℃/i, label: "동작 온도" },
            { pattern: /°|도/i, label: "각도" },
            { pattern: /(?:초|sec(?:ond)?s?|\bs\b)/i, label: "시간" },
            { pattern: /N\s*[·.]?\s*m|Nm/i, label: "토크" },
            { pattern: /\bN\b/i, label: "하중" },
            { pattern: /\b(?:kg|g)\b/i, label: "중량" },
            { pattern: /\bdB\b/i, label: "소음" },
            { pattern: /\bV\b/i, label: "전압" },
            { pattern: /\bA\b/i, label: "전류" },
            { pattern: /\bW\b/i, label: "출력" },
            { pattern: /(?:mm|cm|m)\b/i, label: "치수" },
            { pattern: /(?:원|₩|\$)/i, label: "원가" },
            { pattern: /(?:회|cycles?)\b/i, label: "반복 수명" }
        ];
        let unitMatch = unitPatterns.find(item => item.pattern.test(valueToken));
        if (unitMatch) return kind === "objective" ? `${unitMatch.label} 최적화` : unitMatch.label;

        let withoutValue = clause.replace(valueToken, " ");
        let subject = withoutValue
            .replace(/^(?:그리고|또한|단|다만|기존|신규)\s*/g, "")
            .replace(/(?:은|는|이|가|을|를|에서|으로|로)(?=\s|$)/g, " ")
            .replace(/(?:설계해줘|개발해줘|만들어줘|유지해줘|해주세요|최소화|최대화|최적화|반드시|필수|이내|이하|이상|미만|초과|되어야|이어야|않아야|해야|워야|아야|어야|여야|해줘|개선|향상|낮춰|낮추|줄여|줄이|절감|높여|높이|좋겠어요|좋겠|원해요|원해|원합니다|원하|바랍니다|바라|최대|최소)/g, " ")
            .replace(/\s+/g, " ")
            .trim();
        if (subject.length > 24) subject = subject.slice(0, 24).trim();
        if (subject.length > 1) {
            if (kind === "objective") {
                if (/최소화|낮춰|낮추|줄여|줄이|절감/.test(clause)) return `${subject} 최소화`;
                if (/최대화|높여|높이|향상|개선/.test(clause)) return `${subject} 향상`;
                return `${subject} 최적화`;
            }
            return subject;
        }
        return kind === "constraint" ? "충족 조건"
            : kind === "objective" ? "개선 목표"
            : kind === "reference" ? "참고 자료"
            : "설계 데이터";
    }

    public isSentenceLikeRequirementValue(value: string) {
        let clean = String(value || "").replace(/\s+/g, " ").trim();
        if (!clean) return false;
        if (clean.length > 34) return true;
        if (/(?:해주세요|해\s*주세요|해줘|해야|되어야|돼야|이어야|가능해야|워야|아야|어야|여야|하고\s*싶|원해|바랍니다?|되게|되도록|하면\s*돼|하면\s*됨|함|됨|돼|[가-힣]+(?:아|어|여|춰)\s*줘(?:요)?)(?:\s|$)/.test(clean)) return true;
        if (/(?:할\s*수|될\s*수|되는?\s*수준|하는?\s*수준|정도(?:로|면)?|곳(?:으로)?|걸로|것으로|따라가|보고\s*결정|기준으로\s*(?:잡|정|결정))/.test(clean)) return true;
        let particleCount = (clean.match(/(?:은|는|이|가|을|를|에서|에게|으로|로)(?=\s|[가-힣])/g) || []).length;
        let predicate = /(?:사용|적용|설정|지정|유지|변경|전달|동작|작동|충족|가능|필요|선정|선택|계산|검증|참고|분석|결정|구성|따라|제작|설계|개발)/.test(clean);
        return particleCount >= 2 && predicate;
    }

    public normalizePromptStructure(prompt: string) {
        let lines = String(prompt || "")
            .replace(/\r\n?/g, "\n")
            .replace(/[。]/g, ".")
            .replace(/[！]/g, "!")
            .replace(/[？]/g, "?")
            .split(/\n+/)
            .map(line => line.replace(/[ \t]+/g, " ").trim())
            .filter(Boolean);
        let blocks: string[] = [];
        let activeBullet = "";
        let flushBullet = () => {
            if (activeBullet) blocks.push(activeBullet.replace(/\s+/g, " ").trim());
            activeBullet = "";
        };

        lines.forEach(line => {
            let bullet = line.match(/^(?:[•●▪◦‣·*-]|\d+[.)])\s*(.+)$/);
            if (bullet) {
                flushBullet();
                activeBullet = bullet[1].trim();
                return;
            }
            if (activeBullet && !/[.!?]$/.test(activeBullet)) {
                activeBullet = `${activeBullet} ${line}`;
                return;
            }
            flushBullet();
            blocks.push(line);
        });
        flushBullet();
        return blocks.join("\n");
    }

    public normalizeRequirementValue(label: string, value: string, kind: string, evidence: string = "", source: string = "자연어") {
        let clean = String(value || "")
            .replace(/^[\s"'“”‘’,，:·]+|[\s"'“”‘’,，:·]+$/g, "")
            .replace(/\s+/g, " ")
            .trim();
        if (!clean || source !== "자연어" || label === "설계 대상") return clean;
        if (/확인 필요$/.test(clean)) return clean;

        let context = String(evidence || clean)
            .replace(/^[\s"'“”‘’,，:·]+|[\s"'“”‘’,，:·]+$/g, "")
            .replace(/\s+/g, " ")
            .trim();
        let structuredValue = /^(?:≤|≥|<|>)?\s*(?:₩\s*)?-?\d[\d,.]*(?:\s*~\s*-?\d[\d,.]*)?\s*(?:℃|°|s|ms|Nm|N|kg|g|mm|cm|m|kW|W|V|A|dB|MPa|kPa|Pa|bar|Hz|rpm|%|개|cycles?)?(?:\s*(?:절감|향상))?$/i;
        if (structuredValue.test(clean)
            || /^(?:IP\d{2}[A-Z]?|\([^)]{3,80}\)(?:\s*(?:mm|cm|m))?|\[[^\]]{3,80}\](?:\s*(?:mm|cm|m))?)$/i.test(clean)) {
            return clean;
        }
        if (/^COG 위치 추정 · 좌표 미제공$/.test(clean)
            || /^(?:(?:좌우 배치|좌측 구조|우측 구조|대칭|비대칭)(?: · )?)+$/.test(clean)
            || (clean.includes("→") && !this.isSentenceLikeRequirementValue(clean))) {
            return clean;
        }

        if (kind === "reference") {
            if (/CAD|STEP|STP|DWG|DXF|3D|형상/i.test(`${label} ${context}`)) return "입력문 언급 CAD 자료";
            if (/PDF|데이터시트|data\s*sheet/i.test(`${label} ${context}`)) return "입력문 언급 PDF 자료";
            if (/카탈로그|catalog/i.test(`${label} ${context}`)) return "입력문 언급 카탈로그";
            if (/시험\s*데이터|test\s*data/i.test(`${label} ${context}`)) return "입력문 언급 시험 데이터";
            if (/이미지|PNG|JPG|JPEG/i.test(`${label} ${context}`)) return "입력문 언급 이미지";
            return "참고 자료 유형 확인 필요";
        }

        if (kind === "objective") {
            if (/최소화|낮춰|낮추|줄여|줄이|절감/.test(`${clean} ${context}`)) return "최소화";
            if (/최대화/.test(`${clean} ${context}`)) return "최대화";
            if (/개선|향상|높여|높이/.test(`${clean} ${context}`)) return "향상";
            return /우선/.test(`${clean} ${context}`) ? "우선 최적화" : "최적화";
        }

        if (/재질|소재/.test(`${label} ${context}`)) {
            let knownMaterial = context.match(/((?:알루미늄(?:\s*합금)?|스테인리스(?:\s*스틸)?|탄소강|강철|마그네슘|티타늄|플라스틱|폴리카보네이트|고무|실리콘|CFRP|GFRP)(?:\s+[A-Za-z0-9][A-Za-z0-9._-]*)?|(?:SUS|AISI|SAE|AL|ABS|PC|PA)[-\s]?[A-Z0-9._-]+)/i);
            if (knownMaterial) return knownMaterial[1].trim();
            let assignedMaterial = context.match(/(?:재질|소재)(?:은|는|이|가|을|를|:|=)\s*([^,.;]{2,32}?)(?=\s*(?:로\s*(?:설정|지정|적용)|을\s*(?:사용|적용)|를\s*(?:사용|적용)|이어야|여야|해야|$))/);
            if (assignedMaterial && !this.isSentenceLikeRequirementValue(assignedMaterial[1])) return assignedMaterial[1].trim();
            return "재질 사양 확인 필요";
        }

        if (/회전\s*축|회전축|기준\s*축/.test(`${label} ${context}`)) {
            let axis = context.match(/\b([XYZ])\s*축(?:\s*기준)?/i);
            if (axis) return `${axis[1].toUpperCase()}축 기준`;
            let assignedAxis = context.match(/(?:회전\s*축|회전축|기준\s*축)(?:은|는|이|가)?\s*[:=]?\s*([^,.;]{1,30}?)(?=\s*(?:로\s*(?:설정|지정)|이어야|여야|해야|$))/);
            if (assignedAxis) return assignedAxis[1].trim();
            return "회전축 정의 확인 필요";
        }

        if (/하중\s*경로/.test(`${label} ${context}`)) {
            let path = context.match(/([가-힣A-Za-z0-9_-]{1,20})에서\s*([가-힣A-Za-z0-9_-]{1,20}?)(?:으)?로/);
            if (path) return `${path[1]} → ${path[2]}`;
            let assignedPath = context.match(/하중\s*경로(?:은|는|이|가)?\s*[:=]?\s*([^,.;]{2,40}?)(?=\s*(?:이어야|여야|해야|$))/);
            if (assignedPath) {
                let pathValue = assignedPath[1]
                    .replace(/\s*(?:로\s*)?(?:전달되게|전달되도록|전달|설정)(?:\s*(?:해줘|해주세요))?$/g, "")
                    .replace(/(?:으)?로$/g, "")
                    .trim();
                if (pathValue) return pathValue;
            }
            return "하중 전달 경로 확인 필요";
        }

        if (/(?:유지(?!\s*보수)|그대로|변경하지|바꾸지|변경\s*없이|변경하면\s*안|바꾸면\s*안)/.test(context)) {
            let preserved = context.match(/((?:기존|현재)\s+[^,.;]{1,32}?)(?:은|는|이|가|을|를)?\s*(?:유지(?!\s*보수)|그대로|변경하지|바꾸지|변경하면\s*안|바꾸면\s*안)/);
            if (preserved) {
                return `${preserved[1]
                    .replace(/(?:은|는|이|가|을|를)$/g, "")
                    .trim()} 유지`;
            }
            if (/위치|좌표|장착점/.test(`${label} ${context}`)) return "기존 위치 유지";
            if (/형상|외형|브래킷/.test(`${label} ${context}`)) return "기존 형상 유지";
            return "기존 사양 유지";
        }

        if (/세척|청소|세정/.test(`${label} ${context}`)) return "세척 가능";
        if (/유지\s*보수|정비/.test(`${label} ${context}`)) return "정비 용이성 확보";
        if (/비가|우천|강우|빗물/.test(`${label} ${context}`)) return "우천 환경 동작 필수";
        if (/충격/.test(`${label} ${context}`)) return "충격 내성 확보";
        if (/고온|저온/.test(context)) {
            if (/고온/.test(context) && /저온/.test(context)) return "고·저온 환경 동작 필수";
            return /고온/.test(context) ? "고온 환경 동작 필수" : "저온 환경 동작 필수";
        }
        if (/방수|방진/.test(`${label} ${context}`)) {
            if (/방수/.test(context) && /방진/.test(context)) return "방수·방진 성능 필수";
            return /방진/.test(context) ? "방진 성능 필수" : "방수 성능 필수";
        }
        if (/사용자|조작|편의|사용성/.test(`${label} ${context}`)) return "사용 편의성 확보";
        if (/외관|스타일|고급|미관/.test(`${label} ${context}`)) return "요구 외관 수준 충족";
        if (/신뢰성|신뢰도/.test(`${label} ${context}`)) return "신뢰성 확보";
        if (/(?:금지|않아야|없어야|불가)/.test(context)) {
            if (/간섭/.test(`${label} ${context}`)) return "간섭 없음";
            return "허용하지 않음";
        }

        let assignedValue = context.match(/(?:은|는|이|가)\s*[:=]?\s*([^,.;]{1,32}?)(?=\s*(?:이어야|여야|해야|되어야|돼야|로\s*(?:설정|지정|적용)|$))/);
        if (assignedValue) {
            let phrase = assignedValue[1]
                .replace(/\s*(?:가능|충족|동작|작동)(?:할|해야)?$/g, "")
                .trim();
            if (phrase && !/(?:해주세요|해줘|싶어|원해)$/.test(phrase)) return phrase;
        }

        return kind === "input" ? "값 확인 필요" : "충족 기준 확인 필요";
    }

    public splitRequirementClauses(text: string) {
        let clauses: string[] = [];
        let buffer = "";
        let depth = 0;
        let quote = "";
        let push = () => {
            let clean = buffer.trim();
            if (clean.length > 1) clauses.push(clean);
            buffer = "";
        };

        for (let index = 0; index < text.length; index++) {
            let char = text[index];
            let previous = text[index - 1] || "";
            let next = text[index + 1] || "";
            if (/['"“”‘’]/.test(char)) {
                if (!quote) quote = char;
                else quote = "";
                buffer += char;
                continue;
            }
            if (!quote && /[\(\[\{]/.test(char)) depth += 1;
            if (!quote && /[\)\]\}]/.test(char)) depth = Math.max(0, depth - 1);
            let decimalPoint = char === "." && /\d/.test(previous) && /\d/.test(next);
            let separator = !quote && depth === 0 && (
                /[\n!?;；]/.test(char)
                || (char === "." && !decimalPoint)
            );
            if (separator) push();
            else buffer += char;
        }
        push();

        return clauses.map(clause => clause.trim()).filter(clause => clause.length > 1);
    }

    public isMeaningfulRequirementUnit(value: string) {
        let clean = (value || "")
            .replace(/^[\s,，:·]+|[\s,，:·]+$/g, "")
            .replace(/^(?:그리고|또한|아울러|단|다만)\s*/g, "")
            .replace(/(?:하면서|하며|이고|이며|하고)$/g, "")
            .trim();
        if (clean.length < 2) return false;
        if (/^(?:싶(?:어|어요|습니다)?|원(?:해|해요|합니다)?|바랍(?:니다)?|부탁(?:해|해요|합니다)?|해(?:줘|주세요|요)?|해주세요|해야\s*해)$/.test(clean)) return false;
        if (/^(?:감사합니다?|고맙습니다?|안녕하세요?|잘\s*부탁드립니다?)$/.test(clean)) return false;
        let hasRequirementSignal = /\d/.test(clean)
            || /(?:설계|개발|제작|구현|만들|반드시|필수|해야|되어야|이어야|가능해야|워야|아야|어야|여야|이내|이하|이상|미만|초과|유지|금지|최소화|최대화|최적화|개선|향상|낮추|줄이|절감|높이|선호|중요|좋겠|COG|무게\s*중심|힌지|좌표|하중|재질|소재|치수|두께|직경|온도|각도|시간|속도|토크|원가|비용|소음|진동|중량|무게|효율|내구|세척|조작|형상|CAD|PDF|카탈로그|시험\s*데이터|해줘|해주세요)/i.test(clean);
        return hasRequirementSignal || clean.length >= 4;
    }

    public splitSemanticUnits(sentence: string) {
        let commaParts: string[] = [];
        let buffer = "";
        let depth = 0;
        let quote = "";
        let push = () => {
            let clean = buffer.trim();
            if (clean) commaParts.push(clean);
            buffer = "";
        };

        for (let index = 0; index < sentence.length; index++) {
            let char = sentence[index];
            let previous = sentence[index - 1] || "";
            let next = sentence[index + 1] || "";
            if (/['"“”‘’]/.test(char)) {
                if (!quote) quote = char;
                else quote = "";
                buffer += char;
                continue;
            }
            if (!quote && /[\(\[\{]/.test(char)) depth += 1;
            if (!quote && /[\)\]\}]/.test(char)) depth = Math.max(0, depth - 1);
            let thousandsComma = char === "," && /\d/.test(previous) && /\d/.test(next);
            if (!quote && depth === 0 && /[,，]/.test(char) && !thousandsComma) push();
            else buffer += char;
        }
        push();

        let merged: string[] = [];
        commaParts.forEach(part => {
            if (merged.length === 0) {
                merged.push(part);
                return;
            }
            let previous = merged[merged.length - 1];
            if (this.isMeaningfulRequirementUnit(previous) && this.isMeaningfulRequirementUnit(part)) {
                merged.push(part);
            } else {
                merged[merged.length - 1] = `${previous}, ${part}`;
            }
        });

        let splitConnectors = (value: string): string[] => {
            let connector = /(?:면\s*안\s*되(?:고|며)|(?:해야|되어야|돼야|이어야|여야|않아야)\s*(?:하고|하며)|하면서|하며|이고|이며|하고)(?=\s|[,，]|[가-힣A-Za-z0-9])/g;
            let match: RegExpExecArray | null;
            while ((match = connector.exec(value)) !== null) {
                let left = value.slice(0, match.index).trim();
                let right = value.slice(match.index + match[0].length).replace(/^[\s,，]+/, "").trim();
                let verbConjunction = match[0] === "이고" && /(?:줄|높|낮|늘)$/.test(left);
                let negativeConjunction = /^면\s*안\s*되/.test(match[0]);
                let obligationConjunction = /^(?:해야|되어야|돼야|이어야|여야|않아야)/.test(match[0]);
                let semanticLeft = negativeConjunction ? `${left}면 안 됨`
                    : obligationConjunction ? `${left}${match[0].match(/^(?:해야|되어야|돼야|이어야|여야|않아야)/)![0]} 함`
                    : verbConjunction ? value.slice(0, match.index + match[0].length).trim()
                    : left;
                if (this.isMeaningfulRequirementUnit(semanticLeft) && this.isMeaningfulRequirementUnit(right)) {
                    return [...splitConnectors(semanticLeft), ...splitConnectors(right)];
                }
                if (match[0].length === 0) connector.lastIndex += 1;
            }
            return [value];
        };

        return merged
            .flatMap(part => splitConnectors(part))
            .map(part => part
                .replace(/^(?:그리고|또한|아울러)\s*/g, "")
                .trim())
            .filter(part => this.isMeaningfulRequirementUnit(part));
    }

    public extractRequirementsFromPrompt(prompt: string) {
        let text = this.normalizePromptStructure(prompt);
        let sentences = this.splitRequirementClauses(text);
        let sentenceRecords = sentences.map((sentence, index) => ({
            sentence,
            location: `입력문 · 문장 ${index + 1}`,
            units: this.splitSemanticUnits(sentence)
        }));
        let requirements: any[] = [];

        let boundFor = (value: string, fallback: string = "") => {
            if (/미만/.test(value)) return "<";
            if (/초과|넘어야|커야/.test(value)) return ">";
            if (/이하|이내|최대|안에|내에|넘지|않도록/.test(value)) return "≤";
            if (/이상|최소|적어도|넘게/.test(value)) return "≥";
            return fallback;
        };
        let cleanStatement = (value: string) => value
            .replace(/^[\s,，:·]+|[\s,，:·]+$/g, "")
            .replace(/(?:해주세요|해\s*주세요|해줘요|해\s*줘요|부탁합니다)$/g, "")
            .replace(/\s+/g, " ")
            .trim();
        let add = (
            label: string,
            value: string,
            kind: string,
            confidence: number,
            evidence: string,
            source: string = "자연어",
            location: string = "",
            reviewReason: string = ""
        ) => {
            let cleanLabel = label.trim();
            let rawValue = String(value || "").trim();
            let cleanValue = this.normalizeRequirementValue(cleanLabel, value, kind, evidence, source);
            if (!cleanLabel || !cleanValue) return;
            if (source === "자연어" && (cleanLabel.length > 28 || this.isSentenceLikeRequirementValue(cleanLabel))) {
                cleanLabel = kind === "input" ? "해석 필요 설계값"
                    : kind === "reference" ? "해석 필요 참고 자료"
                    : kind === "objective" ? "해석 필요 최적화 목표"
                    : "해석 필요 필수 조건";
                confidence = Math.min(confidence, 62);
                reviewReason = "요구사항의 대상 이름을 명확히 분리하지 못했습니다.";
            }
            if (/^(?:싶어요?|원해요?|해주세요|해줘요?)$/.test(cleanValue)) return;
            let normalizationNeedsReview = /확인 필요$/.test(cleanValue);
            let sentenceLikeValue = source === "자연어" && this.isSentenceLikeRequirementValue(cleanValue);
            if (sentenceLikeValue) {
                cleanValue = kind === "input" ? "값 확인 필요"
                    : kind === "reference" ? "자료 유형 확인 필요"
                    : kind === "objective" ? "최적화 기준 확인 필요"
                    : "충족 기준 확인 필요";
                confidence = Math.min(confidence, 55);
                reviewReason = "요청 문장과 설계 값을 명확히 분리하지 못했습니다.";
                normalizationNeedsReview = true;
            }
            if (normalizationNeedsReview) {
                confidence = Math.min(confidence, rawValue === cleanValue ? 55 : 60);
                reviewReason = reviewReason || "문장에서 설계에 사용할 값을 특정하지 못했습니다.";
            }
            let duplicate = requirements.some(item => item.label === cleanLabel && item.value === cleanValue && item.source === source);
            if (duplicate) return;
            requirements.push(this.applyRequirementDelivery({
                id: `requirement-${requirements.length + 1}`,
                label: cleanLabel,
                value: cleanValue,
                source,
                evidence: evidence.trim(),
                location: location || (source === "자연어" ? "입력문 · 전체" : evidence),
                kind,
                confidence,
                needsReview: this.requiresRequirementReview(confidence),
                reviewReason: this.requiresRequirementReview(confidence) ? (reviewReason || "의미 또는 조건 방향이 명확한지 확인해주세요.") : "",
                reviewConfirmed: false,
                excluded: false,
                expanded: false
            }));
        };
        let objectiveMarkers = /(?:최소화|최대화|최적화|우선|개선|향상|낮춰|낮추|줄여|줄이|절감|높여|높이|선호|중요|좋겠|원하|바라)/;
        let obligationMarkers = /(?:반드시|필수|해야|되어야|이어야|가능해야|워야|아야|어야|여야|이내|이하|이상|미만|초과|금지|않아야|유지|그대로|변경하지|바꾸지|(?:변경하면|바꾸면)\s*안|넘지)/;
        let structuralMarkers = /(?:COG|무게\s*중심|힌지|회전\s*축|장착점|좌표|위치|하중\s*경로|하중|추력|관성|재질|소재|두께|직경|치수|질량|중량|토크|전압|전류|출력)/i;
        let referenceMarkers = /(?:CAD|STEP|STP|DWG|DXF|PDF|카탈로그|데이터시트|시험\s*데이터|이미지|도면)/i;
        let normalizedUnit = (raw: string) => {
            let compact = raw.replace(/\s+/g, "").toLowerCase();
            if (/^(?:°c|℃)$/.test(compact)) return "℃";
            if (/^(?:초|sec|second|seconds|s)$/.test(compact)) return "s";
            if (/^(?:n·m|n\.m|nm)$/.test(compact)) return "Nm";
            if (/^(?:회|cycle|cycles)$/.test(compact)) return "cycles";
            return raw.replace(/\s+/g, "");
        };
        let nearestDistance = (value: string, pattern: RegExp, index: number) => {
            let flags = pattern.ignoreCase ? "gi" : "g";
            let regex = new RegExp(pattern.source, flags);
            let match: RegExpExecArray | null;
            let distance = Number.MAX_SAFE_INTEGER;
            while ((match = regex.exec(value)) !== null) {
                distance = Math.min(distance, Math.abs(index - match.index));
                if (match[0].length === 0) regex.lastIndex += 1;
            }
            return distance;
        };
        let quantityInfo = (unitText: string, rawUnit: string, index: number, lowerValue: string = "") => {
            let unit = normalizedUnit(rawUnit);
            let compact = unit.toLowerCase();
            let temperatureDistance = nearestDistance(unitText, /(?:온도|저온|고온|열환경|temperature)/i, index);
            let angleDistance = nearestDistance(unitText, /(?:각도|개방|회전|기울기|angle)/i, index);
            let negativeRange = Number(lowerValue) < 0;
            let ambiguousReason = "";
            let label = "";
            let category = "performance";

            if (compact === "℃" || (/^(?:도|°)$/.test(unit) && (temperatureDistance < angleDistance || negativeRange))) {
                label = "동작 온도";
                unit = "℃";
            } else if (/^(?:도|°)$/.test(unit) && angleDistance < Number.MAX_SAFE_INTEGER) {
                label = /개방|열림/.test(unitText) ? "개방 각도" : "동작 각도";
                unit = "°";
            } else if (/^(?:도|°)$/.test(unit)) {
                label = "각도 또는 온도 범위";
                ambiguousReason = "'도'가 각도인지 온도인지 판단할 문맥이 부족합니다.";
            } else if (compact === "s" || /^(?:ms)$/.test(compact)) {
                label = /닫|폐쇄/.test(unitText) ? "폐쇄 시간" : /열|개방/.test(unitText) ? "개방 시간" : "동작 시간";
            } else if (compact === "nm") {
                label = "토크";
                category = "structural";
            } else if (/^n$/.test(compact)) {
                label = /추력|작동력/.test(unitText) ? "요구 작동력" : "작용 하중";
                category = "structural";
            } else if (/^(?:kg|g)$/.test(compact)) {
                label = "중량";
                category = "structural";
            } else if (/^(?:mm|cm|m)$/.test(compact)) {
                label = /간극|클리어런스|여유\s*간격/.test(unitText) ? "최소 간극"
                    : /두께/.test(unitText) ? "두께"
                    : /직경|지름/.test(unitText) ? "직경"
                    : /길이/.test(unitText) ? "길이"
                    : /폭|너비/.test(unitText) ? "폭"
                    : /높이/.test(unitText) ? "높이"
                    : /반경/.test(unitText) ? "반경"
                    : this.inferSemanticLabel(unitText, "input", rawUnit);
                category = "structural";
            } else if (/^(?:v)$/.test(compact)) {
                label = "동작 전압";
                category = "structural";
            } else if (/^(?:a)$/.test(compact)) {
                label = "동작 전류";
                category = "structural";
            } else if (/^(?:w|kw)$/.test(compact)) {
                label = "정격 출력";
                category = "structural";
            } else if (/^(?:db)$/.test(compact)) {
                label = "소음";
            } else if (/^(?:pa|kpa|mpa|bar)$/.test(compact)) {
                label = /응력/.test(unitText) ? "허용 응력" : "압력";
            } else if (/^(?:hz|rpm)$/.test(compact)) {
                label = "동작 속도";
            } else if (compact === "%") {
                label = /습도/.test(unitText) ? "동작 습도" : /효율/.test(unitText) ? "효율" : "비율";
            } else if (compact === "cycles") {
                label = "내구 수명";
            } else {
                label = this.inferSemanticLabel(unitText, "constraint", rawUnit);
                ambiguousReason = "단위와 물리량의 연결을 확인해주세요.";
            }

            let bound = boundFor(unitText);
            let kind = objectiveMarkers.test(unitText) ? "objective"
                : category === "structural" && !bound && !obligationMarkers.test(unitText) ? "input"
                : "constraint";
            let confidence = ambiguousReason ? 70
                : bound || obligationMarkers.test(unitText) ? 96
                : category === "structural" ? 90
                : 93;
            return { label, unit, kind, confidence, reviewReason: ambiguousReason };
        };

        sentenceRecords.forEach(record => {
            record.units.forEach((unit, unitIndex) => {
                let beforeCount = requirements.length;
                let location = record.location;
                let evidence = unit;
                let targetStatement = /(?:설계|개발|제작|구현|만들)/.test(unit);
                let quantityContext = unit;
                if (/°|도/.test(unit) && !/(?:온도|temperature|개방|열림|회전|각도)/i.test(unit)) {
                    let previousUnit = record.units[unitIndex - 1] || "";
                    if (/(?:온도|temperature|개방|열림|회전|각도)/i.test(previousUnit)) {
                        quantityContext = `${unit} ${previousUnit}`;
                    }
                }

                let cogEstimate = /(?:무게\s*중심|COG)/i.test(unit)
                    && /COG\s*위치/i.test(unit)
                    && /(?:같|추정|예상|일\s*것)/.test(unit);
                if (cogEstimate) {
                    add(
                        "무게중심(COG)",
                        "COG 위치 추정 · 좌표 미제공",
                        "input",
                        60,
                        evidence,
                        "자연어",
                        location,
                        "정확한 COG 좌표와 기준 좌표계를 확인해주세요."
                    );
                }

                if (/힌지/i.test(unit)) {
                    let hingeCount = unit.match(/(\d+)\s*개/);
                    if (hingeCount) {
                        add("힌지 수량", `${hingeCount[1]}개`, "input", 96, evidence, "자연어", location);
                    }
                    let hingeArrangement: string[] = [];
                    if (/좌우/.test(unit)) hingeArrangement.push("좌우 배치");
                    if (/좌측\s*(?:구조|배치|기준)/.test(unit)) hingeArrangement.push("좌측 구조");
                    else if (/우측\s*(?:구조|배치|기준)/.test(unit)) hingeArrangement.push("우측 구조");
                    if (/대칭/.test(unit) && !/비대칭/.test(unit)) hingeArrangement.push("대칭");
                    if (/비대칭/.test(unit)) hingeArrangement.push("비대칭");
                    if (hingeArrangement.length > 0) {
                        let mixedDirection = hingeArrangement.includes("좌우 배치")
                            && (hingeArrangement.includes("좌측 구조") || hingeArrangement.includes("우측 구조"));
                        add(
                            "힌지 배치",
                            hingeArrangement.join(" · "),
                            "input",
                            mixedDirection ? 68 : 92,
                            evidence,
                            "자연어",
                            location,
                            mixedDirection ? "‘좌우 배치’와 한쪽 방향 구조의 관계를 확인해주세요." : ""
                        );
                    }
                }

                if (/(?:하중\s*(?:변화\s*)?(?:경로|프로파일)|load\s*profile)/i.test(unit)) {
                    let stages: string[] = [];
                    let beforeMiddle = unit.split(/중간|중앙/)[0] || "";
                    if (/무거|무겁|하중.*(?:높|크)|증가/.test(beforeMiddle)) stages.push("초기 하중 높음");
                    if (/(?:중간|중앙)[^,.;]{0,30}(?:가볍|하중.*(?:낮|작))/.test(unit)) stages.push("중간 하중 낮음");
                    if (/(?:끝부분|끝|말기|후반)[^,.;]{0,40}(?:약간\s*)?(?:무거|무겁|하중.*(?:상승|증가|높))/.test(unit)) {
                        stages.push(/약간/.test(unit) ? "말기 하중 소폭 상승" : "말기 하중 상승");
                    }
                    let completeProfile = stages.length === 3;
                    add(
                        "개방 하중 프로파일",
                        stages.length > 0 ? stages.join(" → ") : "프로파일 구간 확인 필요",
                        "input",
                        completeProfile ? 76 : 58,
                        evidence,
                        "자연어",
                        location,
                        completeProfile
                            ? "정성 프로파일로 해석했습니다. 구간 경계와 하중 값을 확인해주세요."
                            : "하중 변화의 구간과 방향을 명확히 분리하지 못했습니다."
                    );
                }

                let mentionedReferences = [
                    { pattern: /(?:STEP|STP|DWG|DXF|CAD|3D\s*모델)/i, label: "CAD 형상 모델", value: "입력문에 언급된 CAD 자료" },
                    { pattern: /(?:부품\s*)?카탈로그|catalog/i, label: "부품 카탈로그", value: "입력문에 언급된 카탈로그" },
                    { pattern: /시험\s*데이터|test\s*data/i, label: "시험 데이터", value: "입력문에 언급된 시험 데이터" },
                    { pattern: /PDF|데이터시트|data\s*sheet/i, label: "PDF 사양 자료", value: "입력문에 언급된 PDF 자료" },
                    { pattern: /(?:참고\s*)?이미지|PNG|JPG|JPEG/i, label: "참고 이미지", value: "입력문에 언급된 이미지" }
                ];
                if (/(?:첨부|참고|기반|활용|분석)/.test(unit)) {
                    mentionedReferences
                        .filter(reference => reference.pattern.test(unit))
                        .forEach(reference => add(reference.label, reference.value, "reference", 88, evidence, "자연어", location));
                }

                let targetMatch = unit.match(/^(.{2,90}?)(?:을|를)\s*(?:설계|개발|제작|구현|만들)/);
                if (!targetMatch) {
                    let fallbackTarget = unit.match(/^(.{2,50}?)\s+(?:설계|개발|제작|구현)(?:하|해)/);
                    if (fallbackTarget && !/\d|(?:은|는|이|가)\s|(?:첨부|참고|기반)|(?:이내|이하|이상|미만|초과)/.test(fallbackTarget[1])) {
                        targetMatch = fallbackTarget;
                    }
                }
                if (targetMatch) {
                    let target = targetMatch[1]
                        .replace(/^(?:저는|우리는|새로운|신규|새)\s+/, "")
                        .replace(/^(?:목표는|요청은)\s*/, "")
                        .trim();
                    if (target.length > 1) add("설계 대상", target, "input", 98, evidence, "자연어", location);
                }

                let occupiedSpans: any[] = [];
                let coordinatePattern = /(COG|무게\s*중심|힌지\s*(?:좌표|위치|축)|회전\s*축|장착점|기준\s*좌표)(?:은|는|이|가)?\s*[:=]?\s*(\([^)]{3,80}\)|\[[^\]]{3,80}\])\s*(mm|cm|m)?/gi;
                let coordinateMatch: RegExpExecArray | null;
                while ((coordinateMatch = coordinatePattern.exec(unit)) !== null) {
                    let coordinateValue = `${coordinateMatch[2]}${coordinateMatch[3] ? ` ${coordinateMatch[3]}` : ""}`;
                    add(this.inferSemanticLabel(coordinateMatch[1], "input"), coordinateValue, "input", 97, evidence, "자연어", location);
                    occupiedSpans.push([coordinateMatch.index, coordinateMatch.index + coordinateMatch[0].length]);
                    if (coordinateMatch[0].length === 0) coordinatePattern.lastIndex += 1;
                }

                let explicitMaterial = unit.match(/((?:알루미늄(?:\s*합금)?|스테인리스(?:\s*스틸)?|탄소강|강철|마그네슘|티타늄|플라스틱|폴리카보네이트|고무|실리콘|CFRP|GFRP)(?:\s+[A-Za-z0-9][A-Za-z0-9._-]*)?|(?:SUS|AISI|SAE|AL|ABS|PC|PA)[-\s]?[A-Z0-9._-]+)/i);
                if (explicitMaterial && /재질|소재/.test(unit)) {
                    add("재질", explicitMaterial[1], "input", 96, evidence, "자연어", location);
                }

                let directInputMatch = unit.match(/(하중\s*경로|재질|소재|회전\s*축|힌지\s*축|기준\s*좌표계|관성\s*모멘트)(?:은|는|이|가)?\s*[:=]?\s*(.{2,80})/i);
                if (directInputMatch && !/\([^)]{3,80}\)|\[[^\]]{3,80}\]/.test(directInputMatch[2])) {
                    let inputValue = directInputMatch[2]
                        .replace(/(?:이야|야|입니다|이다|로\s*설정|로\s*해줘|해주세요)$/g, "")
                        .trim();
                    add(this.inferSemanticLabel(directInputMatch[1], "input"), inputValue, "input", 93, evidence, "자연어", location);
                }

                let addRange = (lower: string, upper: string, rawUnit: string, start: number, end: number, unitMismatch: boolean = false) => {
                    let info = quantityInfo(quantityContext, rawUnit, start, lower);
                    let spacer = /^(?:°|도|%)$/.test(info.unit) ? "" : " ";
                    let reviewReason = unitMismatch ? "범위의 시작값과 끝값 단위가 일치하는지 확인해주세요." : info.reviewReason;
                    add(
                        info.label,
                        `${lower}~${upper}${spacer}${info.unit}`,
                        info.kind,
                        unitMismatch ? 68 : info.confidence,
                        evidence,
                        "자연어",
                        location,
                        reviewReason
                    );
                    occupiedSpans.push([start, end]);
                };

                let fromToRangePattern = /(-?\d+(?:\.\d+)?)\s*(°\s*C|℃|도|°|ms|초|sec(?:ond)?s?|s|N\s*[·.]?\s*m|Nm|N|kg|g|mm|cm|m|kW|W|V|A|dB|MPa|kPa|Pa|bar|Hz|rpm|%|회|cycles?)?\s*(?:에서|부터)\s*(-?\d+(?:\.\d+)?)\s*(°\s*C|℃|도|°|ms|초|sec(?:ond)?s?|s|N\s*[·.]?\s*m|Nm|N|kg|g|mm|cm|m|kW|W|V|A|dB|MPa|kPa|Pa|bar|Hz|rpm|%|회|cycles?)\s*까지/gi;
                let fromToRangeMatch: RegExpExecArray | null;
                while ((fromToRangeMatch = fromToRangePattern.exec(unit)) !== null) {
                    let lowerUnit = fromToRangeMatch[2] || fromToRangeMatch[4];
                    let upperUnit = fromToRangeMatch[4];
                    addRange(
                        fromToRangeMatch[1],
                        fromToRangeMatch[3],
                        upperUnit,
                        fromToRangeMatch.index,
                        fromToRangeMatch.index + fromToRangeMatch[0].length,
                        normalizedUnit(lowerUnit) !== normalizedUnit(upperUnit)
                    );
                    if (fromToRangeMatch[0].length === 0) fromToRangePattern.lastIndex += 1;
                }

                let rangePattern = /(-?\d+(?:\.\d+)?)\s*(?:~|∼|–|—|-)\s*(-?\d+(?:\.\d+)?)\s*(°\s*C|℃|도|°|ms|초|sec(?:ond)?s?|s|N\s*[·.]?\s*m|Nm|N|kg|g|mm|cm|m|kW|W|V|A|dB|MPa|kPa|Pa|bar|Hz|rpm|%|회|cycles?)/gi;
                let rangeMatch: RegExpExecArray | null;
                while ((rangeMatch = rangePattern.exec(unit)) !== null) {
                    if (!occupiedSpans.some(span => rangeMatch!.index < span[1] && rangeMatch!.index + rangeMatch![0].length > span[0])) {
                        addRange(rangeMatch[1], rangeMatch[2], rangeMatch[3], rangeMatch.index, rangeMatch.index + rangeMatch[0].length);
                    }
                    if (rangeMatch[0].length === 0) rangePattern.lastIndex += 1;
                }

                let overlapsOccupied = (start: number, end: number) => occupiedSpans.some(span => start < span[1] && end > span[0]);
                let scalarPattern = /(-?\d[\d,]*(?:\.\d+)?)\s*(°\s*C|℃|도|°|ms|초|sec(?:ond)?s?|s|N\s*[·.]?\s*m|Nm|N|kg|g|mm|cm|m|kW|W|V|A|dB|MPa|kPa|Pa|bar|Hz|rpm|%|회|cycles?)/gi;
                let scalarMatch: RegExpExecArray | null;
                while ((scalarMatch = scalarPattern.exec(unit)) !== null) {
                    if (!overlapsOccupied(scalarMatch.index, scalarMatch.index + scalarMatch[0].length)) {
                        let info = quantityInfo(quantityContext, scalarMatch[2], scalarMatch.index, scalarMatch[1].replace(/,/g, ""));
                        let bound = boundFor(unit);
                        let spacer = /^(?:°|%)$/.test(info.unit) ? "" : " ";
                        add(
                            info.label,
                            `${bound}${bound ? " " : ""}${scalarMatch[1]}${spacer}${info.unit}`,
                            info.kind,
                            info.confidence,
                            evidence,
                            "자연어",
                            location,
                            info.reviewReason
                        );
                    }
                    if (scalarMatch[0].length === 0) scalarPattern.lastIndex += 1;
                }

                let safetyMatch = unit.match(/안전율(?:은|는|이|가)?[^0-9]{0,12}(\d+(?:\.\d+)?)/i);
                if (safetyMatch) add("안전율", `${boundFor(unit, "≥")} ${safetyMatch[1]}`, "constraint", 97, evidence, "자연어", location);
                let protectionMatch = unit.match(/\bIP\s*(\d{2}[A-Z]?)\b/i);
                if (protectionMatch) add("보호 등급", `IP${protectionMatch[1].toUpperCase()}`, "constraint", 98, evidence, "자연어", location);
                let costMatch = unit.match(/((?:BOM\s*)?(?:목표\s*)?원가|비용)[^0-9₩]{0,15}(₩\s*[\d,]+|[\d,]+\s*(?:만|천)?원)/i);
                if (costMatch) {
                    let raw = costMatch[2].replace(/\s/g, "");
                    let numeric = Number(raw.replace(/[^\d.]/g, ""));
                    if (/만원/.test(raw)) numeric *= 10000;
                    else if (/천원/.test(raw)) numeric *= 1000;
                    let costValue = Number.isFinite(numeric) ? `₩${Math.round(numeric).toLocaleString("ko-KR")}` : raw;
                    let bound = boundFor(unit);
                    add("목표 원가", `${bound}${bound ? " " : ""}${costValue}`, bound ? "constraint" : "objective", 96, evidence, "자연어", location);
                }

                if (objectiveMarkers.test(unit)) {
                    let direction = /(?:최소화|낮춰|낮추|줄여|줄이|절감)/.test(unit) ? "최소화"
                        : /(?:최대화|높여|높이|향상|개선)/.test(unit) ? "향상"
                        : "우선 최적화";
                    let objectiveConcepts = [
                        { pattern: /원가|비용|BOM/i, label: "원가" },
                        { pattern: /소음|noise/i, label: "소음" },
                        { pattern: /중량|무게|경량|weight/i, label: "중량" },
                        { pattern: /진동|vibration/i, label: "진동" },
                        { pattern: /효율|efficiency/i, label: "효율" },
                        { pattern: /내구|수명|durability/i, label: "내구성" },
                        { pattern: /성능|performance/i, label: "성능" },
                        { pattern: /속도|speed/i, label: "속도" },
                        { pattern: /편의|조작성|사용성|ergonomic/i, label: "사용 편의성" },
                        { pattern: /외관|스타일|고급|미관|디자인/i, label: "외관 품질" }
                    ];
                    let matchedConcepts = objectiveConcepts.filter(concept => concept.pattern.test(unit));
                    let labelDirection = direction === "향상" ? "향상" : direction === "최소화" ? "최소화" : "최적화";
                    let subjectiveObjective = /(?:좋겠|원하|바라|선호|중요)/.test(unit)
                        && !/(?:최소화|최대화|개선|향상|낮춰|낮추|줄여|줄이|절감|높여|높이|\d)/.test(unit);
                    let objectiveConfidence = subjectiveObjective ? 78 : 94;
                    let objectiveReviewReason = subjectiveObjective ? "선호 수준을 평가할 수 있는 기준을 확인해주세요." : "";
                    let existingObjectives = requirements.filter(item => item.kind === "objective" && item.evidence === evidence);
                    let measuredValue = existingObjectives[0] ? existingObjectives[0].value : direction;
                    if (existingObjectives[0] && /%$/.test(measuredValue)) {
                        measuredValue = `${measuredValue} ${direction === "최소화" ? "절감" : labelDirection}`;
                    }
                    if (matchedConcepts.length > 0) {
                        matchedConcepts.forEach((concept, index) => {
                            if (existingObjectives[index]) {
                                existingObjectives[index].label = `${concept.label} ${labelDirection}`;
                                existingObjectives[index].value = measuredValue;
                                existingObjectives[index].confidence = objectiveConfidence;
                                existingObjectives[index].needsReview = this.requiresRequirementReview(objectiveConfidence);
                                existingObjectives[index].reviewReason = objectiveReviewReason;
                            } else {
                                add(`${concept.label} ${labelDirection}`, measuredValue, "objective", objectiveConfidence, evidence, "자연어", location, objectiveReviewReason);
                            }
                        });
                    } else if (existingObjectives.length === 0) {
                        let label = this.inferSemanticLabel(unit, "objective");
                        add(label, direction, "objective", 78, evidence, "자연어", location, "개선하려는 대상과 평가 기준을 확인해주세요.");
                    } else {
                        existingObjectives[0].label = this.inferSemanticLabel(unit, "objective");
                        existingObjectives[0].value = measuredValue;
                        existingObjectives[0].confidence = 78;
                        existingObjectives[0].needsReview = true;
                        existingObjectives[0].reviewReason = "개선하려는 대상과 평가 기준을 확인해주세요.";
                    }
                }

                let addedForUnit = requirements.length > beforeCount;
                if (!addedForUnit && obligationMarkers.test(unit)) {
                    let value = cleanStatement(unit);
                    add(this.inferSemanticLabel(unit, "constraint"), value, "constraint", 90, evidence, "자연어", location);
                    addedForUnit = true;
                }
                if (!addedForUnit && /(?:유지|그대로|변경하지|바꾸지|변경\s*없이)/.test(unit)) {
                    add(this.inferSemanticLabel(unit, "constraint"), "기존 사양 유지", "constraint", 95, evidence, "자연어", location);
                    addedForUnit = true;
                }
                if (!addedForUnit && structuralMarkers.test(unit) && !targetStatement) {
                    add(
                        this.inferSemanticLabel(unit, "input"),
                        "값 확인 필요",
                        "input",
                        58,
                        evidence,
                        "자연어",
                        location,
                        "구조 정보는 인식했지만 계산에 사용할 값을 명시적으로 분리하지 못했습니다."
                    );
                    addedForUnit = true;
                }
                if (!addedForUnit && referenceMarkers.test(unit)) {
                    add(this.inferSemanticLabel(unit, "reference"), cleanStatement(unit), "reference", 88, evidence, "자연어", location);
                    addedForUnit = true;
                }
                if (!addedForUnit && !targetStatement && this.isMeaningfulRequirementUnit(unit)) {
                    let value = cleanStatement(unit)
                        .replace(/(?:하고\s*)?싶(?:어|어요|습니다)$/g, "")
                        .trim();
                    if (value.length > 1) {
                        add(this.inferSemanticLabel(value, "constraint"), value, "constraint", 74, evidence, "자연어", location, "조건의 의도와 충족 기준이 명확한지 확인해주세요.");
                    }
                }
            });
        });

        this.uploadedFiles.forEach(file => {
            let type = `${file.type || ""} ${file.name || ""}`.toUpperCase();
            let label = /CAD|3D|STEP|STP|DWG|DXF/.test(type) ? "CAD 형상 모델"
                : /CATALOG|카탈로그/.test(type) ? "부품 카탈로그"
                : /TEST|시험/.test(type) ? "시험 데이터"
                : /PDF|DATA\s*SHEET/.test(type) ? "PDF 사양 자료"
                : /IMAGE|PNG|JPG|JPEG|WEBP/.test(type) ? "참고 이미지"
                : `${file.type || "첨부"} 자료`;
            add(label, file.name, "reference", 100, `${file.type || "첨부 파일"} · ${file.size || "크기 정보 없음"}`, "첨부 파일", `${file.name} · 파일 전체`);
        });

        let meaningfulFallback = sentenceRecords
            .flatMap(record => record.units)
            .map(unit => cleanStatement(unit))
            .filter(unit => this.isMeaningfulRequirementUnit(unit))
            .join(" ");
        if (requirements.length === 0 && meaningfulFallback) {
            add(this.inferSemanticLabel(meaningfulFallback, "constraint"), meaningfulFallback, "constraint", 66, meaningfulFallback, "자연어", "입력문 · 전체", "요구사항으로 해석할 핵심 대상과 충족 기준을 확인해주세요.");
        }
        requirements.forEach(item => item.expanded = false);
        return requirements;
    }

    public syncRequirementOutput() {
        this.rebuildRequirementGroups();
        let sourceCount = new Set(this.extractedRequirements.map(item => item.source)).size;
        this.agentOutputs[0] = {
            label: "REQUIREMENT OUTPUT",
            title: `${this.activeRequirementCount}개 요구사항 정리 완료`,
            summary: `요청에서 필수 조건·최적화 목표·설계 파라미터·참고 자료를 찾고, 원문과 AI 이해 결과를 비교할 수 있게 정리했습니다.`,
            metrics: [
                { label: "필수 조건", value: `${this.hardRequirementCount}개`, note: "사용자 확인 대상" },
                { label: "설계 파라미터", value: `${this.designInputCount}개`, note: "계산·CAD에 사용" },
                { label: "확인 필요", value: `${this.reviewNeededCount}개`, note: "원문 비교 필요" }
            ]
        };
        if (this.agentContracts[0]) {
            this.agentContracts[0].output = `필수 ${this.hardRequirementCount} · 목표 ${this.objectiveRequirementCount} · 파라미터 ${this.designInputCount} · 자료 ${this.referenceRequirementCount}`;
            this.agentContracts[0].sources = `${sourceCount}개 입력 출처 · 사용자 확인 상태 포함`;
        }
    }

    public async toggleRequirementExclusion(item: any) {
        item.excluded = !item.excluded;
        this.syncRequirementOutput();
        await this.service.render();
    }

    public async changeRequirementKind(item: any, kind: string) {
        item.kind = kind;
        this.applyRequirementDelivery(item);
        this.syncRequirementOutput();
        await this.service.render();
    }

    public async refreshRequirementDelivery(item: any) {
        this.applyRequirementDelivery(item);
        this.syncRequirementOutput();
        await this.service.render();
    }

    public async confirmRequirement(item: any) {
        item.needsReview = false;
        item.reviewReason = "";
        item.reviewConfirmed = true;
        item.expanded = false;
        this.syncRequirementOutput();
        this.persistRunContext();
        await this.service.render();
    }

    public async setAllReviewItemsConfirmed(event: any) {
        let checked = Boolean(event && event.target ? event.target.checked : event);
        this.extractedRequirements
            .filter(item =>
                !item.excluded &&
                !this.isProjectInformation(item) &&
                (item.needsReview || item.reviewConfirmed)
            )
            .forEach(item => {
                item.needsReview = !checked;
                item.reviewConfirmed = checked;
                item.expanded = false;
            });
        this.syncRequirementOutput();
        this.persistRunContext();
        await this.service.render();
    }

    public isRequirementGroupExpanded(kind: string) {
        return this.expandedRequirementGroups[kind] !== false;
    }

    public async toggleRequirementGroup(kind: string) {
        this.expandedRequirementGroups[kind] = !this.isRequirementGroupExpanded(kind);
        await this.service.render();
    }

    public async toggleRequirementItem(item: any) {
        let shouldExpand = !item.expanded;
        this.extractedRequirements.forEach(requirement => requirement.expanded = false);
        item.expanded = shouldExpand;
        await this.service.render();
    }

    public async openReviewItems() {
        this.extractedRequirements.forEach(item => item.expanded = false);
        let item = this.extractedRequirements.find(requirement => !requirement.excluded && requirement.needsReview);
        if (!item) return;
        item.expanded = true;
        this.expandedRequirementGroups[item.kind] = true;
        await this.service.render();
        setTimeout(() => {
            let element = typeof document !== "undefined" ? document.getElementById(item.id) : null;
            if (element) element.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 20);
    }

    public trackRequirementGroup(index: number, group: any) {
        return group.kind;
    }

    public trackRequirementItem(index: number, item: any) {
        return item.id || index;
    }

    public canOpenJourney(step: number) {
        if (step === 1 || this.workflowStage === "complete") return true;
        if (this.workflowStage === "review") return step === 2;
        if (this.workflowStage !== "running") return false;
        let unlocked = this.activePhase >= 4 ? 5 : this.activePhase >= 3 ? 4 : 3;
        return step <= unlocked;
    }

    public get serviceJourneyPhaseIndex() {
        let phaseByWorkspaceStep: any = { 1: 0, 2: 1, 3: 2, 4: 2, 5: 3, 6: 4, 7: 6 };
        return phaseByWorkspaceStep[this.journeyStep] ?? 0;
    }

    public serviceJourneyState(stage: any) {
        let index = this.serviceJourney.findIndex(item => item.key === stage.key);
        if (index === this.serviceJourneyPhaseIndex) return "active";
        if (stage.key === "evidence") {
            if (this.finalApproved) return "done";
            return this.workflowStage === "complete" ? "ready" : "locked";
        }
        if (stage.key === "report") return this.finalApproved ? "ready" : "locked";
        if (this.finalApproved && index <= 6) return "done";
        if (index < this.serviceJourneyPhaseIndex) return "done";
        if (this.canOpenServiceJourney(stage)) return "ready";
        return "locked";
    }

    public serviceJourneyStatusLabel(stage: any) {
        let labels: any = { active: "현재", done: "완료", ready: "확인 가능", locked: "대기" };
        return labels[this.serviceJourneyState(stage)] || "대기";
    }

    public canOpenServiceJourney(stage: any) {
        if (stage.workspaceStep) return this.canOpenJourney(stage.workspaceStep);
        if (stage.key === "evidence") return this.workflowStage === "complete";
        if (stage.key === "report") return this.finalApproved;
        return false;
    }

    public async goServiceJourney(stage: any) {
        if (!this.canOpenServiceJourney(stage)) return;
        if (stage.workspaceStep) {
            await this.goJourney(stage.workspaceStep);
            return;
        }
        if (stage.platformSection && typeof location !== "undefined") {
            location.href = this.runPlatformLink(stage.platformSection);
        }
    }

    public journeyStepState(step: number) {
        if (this.journeyStep === step) return "active";
        if (this.workflowStage === "complete" && step <= 6) return "done";
        if (this.canOpenJourney(step) && step < this.journeyStep) return "done";
        return this.canOpenJourney(step) ? "ready" : "locked";
    }

    public async goJourney(step: number) {
        if (!this.canOpenJourney(step)) return;
        this.journeyStep = step;
        this.detailDrawer = "";
        this.persistRunContext();
        await this.service.render();
        if (step === 1) this.scheduleRequestInputResize();
        this.scrollJourneyTop();
    }

    public async showResult() {
        if (this.workflowStage !== "complete") return;
        this.journeyStep = 7;
        this.persistRunContext();
        await this.service.render();
        this.scrollJourneyTop();
    }

    public scrollJourneyTop() {
        let reset = () => {
            let node: any = document.querySelector(".agent-platform");
            while (node) {
                node.scrollTop = 0;
                node.scrollLeft = 0;
                node = node.parentElement;
            }
            window.scrollTo(0, 0);
        };
        reset();
        setTimeout(reset, 30);
        setTimeout(reset, 120);
    }

    public async selectAlternative(index: number) {
        this.selectedAlternative = index;
        this.persistRunContext();
        await this.service.render();
    }

    public async toggleAlternativeDetail(index: number) {
        let shouldOpen = this.detailAlternative !== index;
        this.detailAlternative = shouldOpen ? index : -1;
        await this.service.render();
        if (!shouldOpen) return;
        setTimeout(() => {
            let panel = typeof document !== "undefined" ? document.getElementById("candidate-detail-panel") : null;
            if (panel) panel.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 30);
    }

    public selectIteration(index: number) {
        this.selectedIteration = index;
    }

    public setView(view: string) {
        this.selectedView = view;
    }

    public async openDetailDrawer(name: string) {
        this.detailDrawer = name;
        await this.service.render();
    }

    public async openSimulationResults() {
        if (this.workflowStage !== "complete") return;
        this.detailDrawer = "simulation";
        await this.service.render();
    }

    public async closeDetailDrawer() {
        this.detailDrawer = "";
        await this.service.render();
    }

    public async inspectAgent(index: number) {
        if (this.analysisState === "running" || this.flowStep < 3) return;
        let agent = this.agents[index];
        let execution = this.agentExecution[index];
        let nextAgent = this.agents[index + 1];
        this.activePhase = index;
        this.journeyStep = 3;
        this.selectedView = "agent";
        this.currentAgent = {
            name: agent.name,
            task: `${execution.task.replace("있습니다.", "완료했습니다.").replace("합니다.", "완료했습니다.")}`,
            progress: 100,
            confidence: execution.confidence,
            started: "완료 기록",
            run: this.runId,
            status: "done"
        };
        this.decisionSteps = [
            { type: "context", label: "Context", title: "프로젝트 컨텍스트 수신", detail: agent.desc, status: "done" },
            { type: "reason", label: "Decision", title: "자율 판단 계획 완료", detail: "목표·제약 우선순위 계산", status: "done" },
            { type: "tool", label: "Tool Call", title: "전문 도구 실행 완료", detail: execution.tool, status: "done" },
            { type: "result", label: "Handoff", title: nextAgent ? `${nextAgent.short} Agent 전달 완료` : "설계안 선택 요청", detail: "근거 패키지 저장", status: "done" }
        ];
        this.persistRunContext();
        await this.service.render();
        this.scrollJourneyTop();
    }

    public async handlePromptChange(value: string) {
        if (!value.trim()) {
            await this.resetWorkflow(false);
            return;
        }
        if (this.workflowStage === "empty" || this.workflowStage === "review" || this.workflowStage === "complete") {
            this.prepareDraft();
        } else if (this.workflowStage === "draft") {
            this.decisionSteps[0].detail = `${this.requestText.length}자 · 분석 준비 완료`;
        }
        this.persistRunContext();
        await this.service.render();
        this.scheduleRequestInputResize();
        this.scheduleLandingComposerResize();
    }

    public async openComposerFocus() {
        if (this.journeyStep !== 1 || this.workflowStage === "parsing" || this.composerFocusMode) return;
        this.composerFocusMode = true;
        await this.service.render();
        setTimeout(() => {
            let input: any = typeof document !== "undefined"
                ? document.querySelector("#landing-design-request")
                : null;
            if (input && input.focus) {
                input.focus({ preventScroll: true });
                this.resizeLandingComposer({ target: input });
            }
        }, 0);
    }

    public async closeComposerFocus() {
        if (!this.composerFocusMode) return;
        let input: any = typeof document !== "undefined"
            ? document.querySelector("#landing-design-request")
            : null;
        if (input && input.style) {
            input.style.height = "";
            input.style.overflowY = "";
        }
        this.composerFocusMode = false;
        await this.service.render();
    }

    @HostListener("document:keydown.escape")
    public async closeComposerFocusWithEscape() {
        if (!this.composerFocusMode) return;
        await this.closeComposerFocus();
    }

    public async applySamplePrompt(index: number) {
        this.requestText = this.samplePrompts[index].text;
        this.prepareDraft();
        await this.service.render();
        this.scheduleRequestInputResize();
        this.scheduleLandingComposerResize();
    }

    public resizeLandingComposer(event: any = null) {
        let target: any = event && event.target
            ? event.target
            : typeof document !== "undefined"
                ? document.querySelector("#landing-design-request")
                : null;
        if (!target || !target.style) return;

        let viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1440;
        let minimumHeight = this.composerFocusMode ? 136 : viewportWidth <= 520 ? 112 : 104;
        let maximumHeight = this.composerFocusMode
            ? viewportWidth <= 520 ? 280 : 360
            : viewportWidth <= 520 ? 180 : 200;
        target.style.height = "auto";
        let contentHeight = Number(target.scrollHeight || minimumHeight);
        let nextHeight = Math.min(Math.max(contentHeight, minimumHeight), maximumHeight);
        target.style.height = `${nextHeight}px`;
        target.style.overflowY = contentHeight > maximumHeight ? "auto" : "hidden";
    }

    public scheduleLandingComposerResize() {
        setTimeout(() => this.resizeLandingComposer(), 0);
        setTimeout(() => this.resizeLandingComposer(), 60);
    }

    public resizeRequestInput(event: any = null) {
        let target: any = event && event.target
            ? event.target
            : typeof document !== "undefined"
                ? document.querySelector(".conversation-composer textarea")
                : null;
        if (!target || !target.style) return;

        let minimumHeight = 118;
        let maximumHeight = 420;
        target.style.height = "auto";
        let contentHeight = Number(target.scrollHeight || minimumHeight);
        target.style.height = `${Math.min(Math.max(contentHeight, minimumHeight), maximumHeight)}px`;
        target.style.overflowY = contentHeight > maximumHeight ? "auto" : "hidden";
    }

    public scheduleRequestInputResize() {
        setTimeout(() => this.resizeRequestInput(), 0);
        setTimeout(() => this.resizeRequestInput(), 60);
    }

    public prepareDraft() {
        this.journeyStep = 1;
        this.workflowStage = "draft";
        this.analysisState = "draft";
        this.analysisProgress = 0;
        this.activePhase = 0;
        this.extractedRequirements = [];
        this.requirementGroups = [];
        this.requirementsConfirmed = false;
        this.finalApproved = false;
        this.selectedView = "agent";
        this.activity = [];
        this.agents.forEach(agent => agent.status = "waiting");
        this.agents[0].status = "active";
        this.currentAgent = {
            name: "요구사항 Agent",
            task: "자연어 입력을 감지했습니다. 분석을 시작하면 의미·조건 방향·설계 데이터 역할과 근거 위치를 구조화합니다.",
            progress: 8,
            confidence: 0,
            started: "입력 감지",
            run: "DRAFT",
            status: "active"
        };
        this.decisionSteps = [
            { type: "context", label: "Input", title: "자연어 입력 감지", detail: `${this.requestText.length}자 · 분석 준비 완료`, status: "done" },
            { type: "reason", label: "Decision", title: "요구사항 분류 대기", detail: "필수 조건·최적화 목표·설계 파라미터·참고 자료", status: "waiting" },
            { type: "tool", label: "Tool Call", title: "문서 컨텍스트 연결 대기", detail: `${this.uploadedFiles.length}개 첨부 자료`, status: "waiting" },
            { type: "result", label: "Review", title: "사용자 검토 대기", detail: "분석 후 확정 단계로 이동", status: "waiting" }
        ];
        this.persistRunContext();
    }

    public async analyzeRequirements() {
        if (!this.requestText.trim() || this.analysisState === "parsing") return;
        this.expandedRequirementGroups = { constraint: true, objective: true, input: true, reference: true };
        this.workflowStage = "parsing";
        this.analysisState = "parsing";
        this.analysisProgress = 24;
        this.activePhase = 0;
        this.agents.forEach(agent => agent.status = "waiting");
        this.agents[0].status = "active";
        this.activateAgent(0);
        this.currentAgent.progress = 24;
        this.currentAgent.run = this.runId;
        this.activity = [{
            time: this.currentTime(),
            from: "사용자",
            to: "요구사항",
            action: "Natural language input",
            text: "자연어 요구사항과 첨부 자료 분석을 요청했습니다.",
            status: "active",
            iteration: "Input"
        }];
        await this.service.render();
        await this.service.sleep(260);

        for (let progress of [42, 68, 88]) {
            this.currentAgent.progress = progress;
            this.analysisProgress = progress;
            await this.service.render();
            await this.service.sleep(340);
        }

        this.extractedRequirements = this.extractRequirementsFromPrompt(this.requestText);
        this.syncRequirementOutput();
        this.workflowStage = "review";
        this.analysisState = "review";
        this.journeyStep = 2;
        this.analysisProgress = 100;
        this.agents[0].status = "done";
        this.currentAgent.progress = 100;
        this.currentAgent.confidence = this.averageRequirementConfidence;
        this.currentAgent.status = "done";
        this.currentAgent.task = `${this.activeRequirementCount}개 요구사항을 원문과 AI 이해 결과로 정리했습니다. 사용자 확인이 필요한 항목은 ${this.reviewNeededCount}개입니다.`;
        let target = this.extractedRequirements.find(item => item.label === "설계 대상");
        this.decisionSteps = [
            { type: "context", label: "Extract", title: "설계 대상 인식", detail: target ? target.value : "대상 사용자 확인 필요", status: "done" },
            { type: "reason", label: "요구사항 분류", title: `${this.activeRequirementCount}개 항목 정리`, detail: `필수 ${this.hardRequirementCount} · 목표 ${this.objectiveRequirementCount} · 입력값 ${this.designInputCount} · 자료 ${this.referenceRequirementCount}`, status: "done" },
            { type: "tool", label: "Evidence", title: "원문 근거 연결", detail: `자연어 ${this.naturalLanguageRequirementCount}개 · 첨부 ${this.uploadedFiles.length}개`, status: "done" },
            { type: "result", label: "Review", title: "사용자 확정 요청", detail: "수정 가능 · 아직 실행 안 됨", status: "active" }
        ];
        this.activity[0].status = "done";
        this.activity.push({
            time: this.currentTime(),
            from: "요구사항",
            to: "사용자",
            action: "Constraint review",
            text: `${this.activeRequirementCount}개 요구사항을 필수 조건 ${this.hardRequirementCount}개·최적화 목표 ${this.objectiveRequirementCount}개·설계 파라미터 ${this.designInputCount}개·참고 자료 ${this.referenceRequirementCount}개로 정리했습니다.`,
            status: "active",
            iteration: "Review"
        });
        this.persistRunContext();
        await this.service.render();
    }

    public async addFiles() {
        let files = await this.service.file.select({
            accept: ".step,.stp,.dwg,.dxf,.iges,.igs,.pdf,.png,.jpg,.jpeg,.webp,.tif,.tiff,.csv,.xlsx,.xls,.doc,.docx,.txt,.json",
            multiple: true
        });
        if (!files || files.length === 0) return;

        Array.from(files).forEach((file: any) => {
            let extension = (file.name.split('.').pop() || '').toUpperCase();
            let type = ["STEP", "STP", "DWG", "DXF", "IGES", "IGS"].includes(extension) ? "CAD"
                : ["PNG", "JPG", "JPEG", "WEBP", "TIF", "TIFF"].includes(extension) ? "IMAGE"
                : ["CSV", "XLSX", "XLS"].includes(extension) ? "CATALOG"
                : extension === "PDF" ? "PDF"
                : "DOCUMENT";
            this.uploadedFiles.push({
                name: file.name,
                type,
                size: this.formatBytes(file.size),
                color: extension === "PDF" ? "red" : type === "IMAGE" ? "green" : "blue"
            });
        });
        this.persistRunContext();
        await this.service.render();
    }

    public removeFile(index: number) {
        this.uploadedFiles.splice(index, 1);
        this.persistRunContext();
    }

    public formatBytes(bytes: number) {
        if (!bytes) return "0 KB";
        if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    }

    public async confirmRequirements() {
        if (this.workflowStage !== "review" || !this.hasActiveDesignBrief || this.reviewNeededCount > 0) return;
        this.syncRequirementOutput();
        this.journeyStep = 3;
        this.requirementsConfirmed = true;
        this.activity.forEach(item => {
            if (item.status === "active") item.status = "done";
        });
        this.activity.push({
            time: this.currentTime(),
            from: "사용자",
            to: "요구사항",
            action: "Requirement confirmation",
            text: `엔지니어가 필수 조건 ${this.hardRequirementCount}개·최적화 목표 ${this.objectiveRequirementCount}개를 확정했습니다.`,
            status: "done",
            iteration: "Manual"
        });
        this.persistRunContext();
        await this.service.render();
        this.scrollJourneyTop();
        await this.service.sleep(240);
        await this.runAnalysis();
    }

    public async runAnalysis() {
        if (!this.requestText.trim() || this.analysisState === "running") return;
        if (!this.requirementsConfirmed) {
            await this.service.modal.warning("AI 추출 요구사항을 먼저 확정해주세요.", false, "확인");
            return;
        }

        this.analysisState = "running";
        this.workflowStage = "running";
        this.journeyStep = 3;
        this.analysisProgress = 5;
        this.finalApproved = false;
        this.selectedView = "agent";
        for (let index = 0; index < this.agents.length; index++) {
            this.activePhase = index;
            this.journeyStep = index >= 4 ? 5 : index >= 3 ? 4 : 3;
            this.agents.forEach((agent, agentIndex) => {
                agent.status = agentIndex < index ? "done" : agentIndex === index ? "active" : "waiting";
            });
            this.analysisProgress = 12 + (index * 16);
            this.activateAgent(index);
            let eventIndexes = [[0], [1], [2], [3], [4, 5, 6], [7]][index];
            for (let eventIndex of eventIndexes) {
                this.activity.push({
                    ...this.flowEvents[eventIndex],
                    time: this.currentTime()
                });
            }
            this.persistRunContext();
            await this.service.render();
            this.scrollJourneyTop();
            await this.service.sleep(420);
        }

        this.analysisProgress = 100;
        this.analysisState = "complete";
        this.workflowStage = "complete";
        this.journeyStep = 6;
        this.activePhase = 5;
        this.agents.forEach(agent => agent.status = "done");
        this.currentAgent.progress = 100;
        this.currentAgent.status = "done";
        this.currentAgent.task = "3개 추천안의 평가 근거 패키징을 완료하고 엔지니어의 설계안 선택을 기다립니다.";
        this.decisionSteps.forEach(step => step.status = "done");
        this.persistRunContext();
        await this.service.render();
        this.scrollJourneyTop();
    }

    public async runSimulation() {
        if (this.workflowStage !== "complete" || this.simulationRunning) return;
        this.detailDrawer = "simulation";
        this.simulationRunning = true;
        this.activePhase = 4;
        this.agents[4].status = "active";
        this.agents[5].status = "waiting";
        this.activateAgent(4);
        this.selectedView = "agent";
        this.activity.push({ time: this.currentTime(), from: "사용자", to: "해석/검증", action: "Simulation status preview", text: "선택 후보의 예시 재검증 상태를 화면에서 재생했습니다.", status: "active", iteration: "Preview" });
        await this.service.render();
        await this.service.sleep(900);
        this.simulationRunning = false;
        this.agents[4].status = "done";
        this.agents[5].status = "active";
        this.activateAgent(5);
        this.activity.push({ time: this.currentTime(), from: "해석/검증", to: "평가/선정", action: "Validation handoff preview", text: "예시 검증 결과를 Evaluation Agent에 전달한 Handoff를 표시했습니다.", status: "done", iteration: "Preview" });
        this.persistRunContext();
        await this.service.render();
    }

    public activateAgent(index: number) {
        let agent = this.agents[index];
        let execution = this.agentExecution[index];
        let nextAgent = this.agents[index + 1];
        this.currentAgent = {
            name: agent.name,
            task: execution.task,
            progress: Math.min(96, 18 + (index * 15)),
            confidence: execution.confidence,
            started: this.currentTime(),
            run: this.runId,
            status: "active"
        };
        this.decisionSteps = [
            { type: "context", label: "Context", title: "프로젝트 컨텍스트 수신", detail: agent.desc, status: "done" },
            { type: "reason", label: "Decision", title: "자율 판단 계획 수립", detail: "목표·제약 우선순위 계산", status: "done" },
            { type: "tool", label: "Tool Call", title: "전문 도구 실행", detail: execution.tool, status: "active" },
            { type: "result", label: "Handoff", title: nextAgent ? `${nextAgent.short} Agent 전달` : "설계안 선택 요청", detail: "근거 패키징 대기", status: "waiting" }
        ];
    }

    public async toggleAutoRedesign() {
        if (this.workflowStage !== "complete") return;
        this.autoRedesign = !this.autoRedesign;
        this.activity.push({
            time: this.currentTime(),
            from: "사용자",
            to: "최적화",
            action: "자동 재설계 설정",
            text: `자동 재설계가 ${this.autoRedesign ? "활성화" : "일시 중지"}되었습니다.`,
            status: this.autoRedesign ? "done" : "waiting",
            iteration: "Manual"
        });
        await this.service.render();
    }

    public async approveDesign() {
        if (this.workflowStage !== "complete" || this.finalApproved) return;
        let approved = await this.service.modal.show({
            title: "최종 설계안 승인",
            message: `${this.selectedDesign.title}을 ${this.runId}의 기준안으로 승인하시겠습니까? 승인 시 추천 근거와 Validation Evidence가 결정 기록에 연결되고 최종 보고서가 준비됩니다.`,
            cancel: "취소",
            action: "최종안 승인",
            actionBtn: "success",
            status: "success"
        });
        if (!approved) return;

        this.finalApproved = true;
        this.journeyStep = 7;
        this.activity.push({ time: this.currentTime(), from: "사용자", to: "Run Archive", action: "Final design approval", text: `${this.selectedDesign.title}의 Evidence 스냅샷과 승인 결정이 최종 보고서 단계로 전달되었습니다.`, status: "done", iteration: "Human Gate" });
        this.persistRunContext();
        await this.service.render();
    }

    public async resetWorkflow(clearPrompt: boolean = true) {
        if (clearPrompt) {
            this.requestText = "";
            this.uploadedFiles = [];
            this.composerFocusMode = false;
        }
        this.workflowStage = "empty";
        this.analysisState = "idle";
        this.analysisProgress = 0;
        this.activePhase = -1;
        this.requirementsConfirmed = false;
        this.finalApproved = false;
        this.simulationRunning = false;
        this.selectedView = "agent";
        this.showCompareDrawer = false;
        this.detailDrawer = "";
        this.detailAlternative = -1;
        this.expandedRequirementGroups = { constraint: true, objective: true, input: true, reference: true };
        this.showAssistant = false;
        this.journeyStep = 1;
        this.extractedRequirements = [];
        this.requirementGroups = [];
        this.activity = [];
        this.agents.forEach(agent => agent.status = "waiting");
        this.currentAgent = {
            name: "Agent Orchestrator",
            task: "자연어 요구사항이 입력되면 적합한 Agent 실행 계획을 구성합니다.",
            progress: 0,
            confidence: 0,
            started: "—",
            run: "입력 대기",
            status: "waiting"
        };
        this.decisionSteps = [
            { type: "context", label: "Context", title: "자연어 입력 대기", detail: "설계 목표와 제약을 입력해주세요.", status: "waiting" },
            { type: "reason", label: "Decision", title: "실행 계획 대기", detail: "입력 후 담당 Agent를 결정합니다.", status: "waiting" },
            { type: "tool", label: "Tool Call", title: "도구 호출 대기", detail: "CAD·부품·CAE 도구 연결 준비", status: "waiting" },
            { type: "result", label: "Handoff", title: "Agent 전달 대기", detail: "검증된 컨텍스트만 전달합니다.", status: "waiting" }
        ];
        this.persistRunContext();
        await this.service.render();
        if (!clearPrompt && this.requestText) this.scheduleRequestInputResize();
        if (!clearPrompt) this.scheduleLandingComposerResize();
        this.scrollJourneyTop();
    }

    public async loadCompletedDemo() {
        this.requestText = this.samplePrompts[0].text;
        this.uploadedFiles = [
            { name: "NX4_tailgate.step", type: "3D CAD", size: "18.4 MB", color: "blue" },
            { name: "motor_catalog.pdf", type: "DATA SHEET", size: "2.1 MB", color: "red" }
        ];
        this.extractedRequirements = this.extractRequirementsFromPrompt(this.requestText);
        this.syncRequirementOutput();
        this.workflowStage = "complete";
        this.analysisState = "complete";
        this.analysisProgress = 100;
        this.activePhase = 5;
        this.requirementsConfirmed = true;
        this.finalApproved = false;
        this.expandedRequirementGroups = { constraint: true, objective: true, input: true, reference: true };
        this.selectedView = "agent";
        this.journeyStep = 6;
        this.activity = this.flowEvents.map(item => ({ ...item }));
        this.agents.forEach(agent => agent.status = "done");
        this.currentAgent = {
            name: "평가/선정 Agent",
            task: "3개 추천안의 평가 근거 패키징을 완료하고 엔지니어의 설계안 선택을 기다립니다.",
            progress: 100,
            confidence: 97,
            started: "09:51:20",
            run: this.runId,
            status: "done"
        };
        this.decisionSteps = [
            { type: "context", label: "Context", title: "검증 결과 수신", detail: "128개 Simulation · 18개 근거", status: "done" },
            { type: "reason", label: "Decision", title: "다목적 평가 완료", detail: "성능·원가·안전성·신뢰도", status: "done" },
            { type: "tool", label: "Evidence", title: "Confidence 검증", detail: "근거 일치도 97%", status: "done" },
            { type: "result", label: "Handoff", title: "설계안 선택 요청", detail: "최종 추천 3개", status: "done" }
        ];
        this.persistRunContext();
        await this.service.render();
        this.scrollJourneyTop();
    }

    public async sendAssistant() {
        let message = this.assistantText.trim();
        if (!message) return;
        this.activity.push({ time: this.currentTime(), from: "사용자", to: "요구사항", action: "Constraint update", text: `“${message}” 조건을 다음 최적화 Run에 반영할 준비가 되었습니다.`, status: "done", iteration: "Chat" });
        this.assistantText = "";
        this.showAssistant = false;
        await this.service.render();
    }

    public currentTime() {
        return new Date().toLocaleTimeString("ko-KR", { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
    }

    public exportSummary() {
        this.service.file.download({
            runId: this.runId,
            project: this.activeProjectTitle,
            exportedAt: new Date().toISOString(),
            requirements: this.requestText,
            requirementBrief: this.requirementBriefSummary,
            structuredRequirements: this.extractedRequirements.filter(item => !item.excluded),
            selectedDesign: this.selectedDesign,
            optimizationHistory: this.optimizationHistory,
            agentActivity: this.activity,
            approved: this.finalApproved,
            validation: ["개폐 시간 충족", "온도 조건 충족", "간섭 없음", "피로 수명 125,000 cycles"]
        }, `${this.runId}_design_summary.json`);
    }
}

export default PageDashboardComponent;